// File:src/Three.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

var THREE = module.exports = { REVISION: '71-custom' };

// set the default log handlers
THREE.log = function () {console.log.apply(console, arguments);};
THREE.warn = function () {console.warn.apply(console, arguments);};
THREE.error = function () {console.error.apply(console, arguments);};


// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent.button

THREE.MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };

// GL STATE CONSTANTS

THREE.CullFaceNone = 0;
THREE.CullFaceBack = 1;
THREE.CullFaceFront = 2;
THREE.CullFaceFrontBack = 3;

THREE.FrontFaceDirectionCW = 0;
THREE.FrontFaceDirectionCCW = 1;

// SHADOWING TYPES

THREE.BasicShadowMap = 0;
THREE.PCFShadowMap = 1;
THREE.PCFSoftShadowMap = 2;

// MATERIAL CONSTANTS

// side

THREE.FrontSide = 0;
THREE.BackSide = 1;
THREE.DoubleSide = 2;

// shading

THREE.NoShading = 0;
THREE.FlatShading = 1;
THREE.SmoothShading = 2;

// colors

THREE.NoColors = 0;
THREE.FaceColors = 1;
THREE.VertexColors = 2;

// blending modes

THREE.NoBlending = 0;
THREE.NormalBlending = 1;
THREE.AdditiveBlending = 2;
THREE.SubtractiveBlending = 3;
THREE.MultiplyBlending = 4;
THREE.CustomBlending = 5;

// custom blending equations
// (numbers start from 100 not to clash with other
//  mappings to OpenGL constants defined in Texture.js)

THREE.AddEquation = 100;
THREE.SubtractEquation = 101;
THREE.ReverseSubtractEquation = 102;
THREE.MinEquation = 103;
THREE.MaxEquation = 104;

// custom blending destination factors

THREE.ZeroFactor = 200;
THREE.OneFactor = 201;
THREE.SrcColorFactor = 202;
THREE.OneMinusSrcColorFactor = 203;
THREE.SrcAlphaFactor = 204;
THREE.OneMinusSrcAlphaFactor = 205;
THREE.DstAlphaFactor = 206;
THREE.OneMinusDstAlphaFactor = 207;

// custom blending source factors

//THREE.ZeroFactor = 200;
//THREE.OneFactor = 201;
//THREE.SrcAlphaFactor = 204;
//THREE.OneMinusSrcAlphaFactor = 205;
//THREE.DstAlphaFactor = 206;
//THREE.OneMinusDstAlphaFactor = 207;
THREE.DstColorFactor = 208;
THREE.OneMinusDstColorFactor = 209;
THREE.SrcAlphaSaturateFactor = 210;


// TEXTURE CONSTANTS

THREE.MultiplyOperation = 0;
THREE.MixOperation = 1;
THREE.AddOperation = 2;

// Mapping modes

THREE.UVMapping = 300;

THREE.CubeReflectionMapping = 301;
THREE.CubeRefractionMapping = 302;

THREE.EquirectangularReflectionMapping = 303;
THREE.EquirectangularRefractionMapping = 304;

THREE.SphericalReflectionMapping = 305;

// Wrapping modes

THREE.RepeatWrapping = 1000;
THREE.ClampToEdgeWrapping = 1001;
THREE.MirroredRepeatWrapping = 1002;

// Filters

THREE.NearestFilter = 1003;
THREE.NearestMipMapNearestFilter = 1004;
THREE.NearestMipMapLinearFilter = 1005;
THREE.LinearFilter = 1006;
THREE.LinearMipMapNearestFilter = 1007;
THREE.LinearMipMapLinearFilter = 1008;

// Data types

THREE.UnsignedByteType = 1009;
THREE.ByteType = 1010;
THREE.ShortType = 1011;
THREE.UnsignedShortType = 1012;
THREE.IntType = 1013;
THREE.UnsignedIntType = 1014;
THREE.FloatType = 1015;
THREE.HalfFloatType = 1025;

// Pixel types

//THREE.UnsignedByteType = 1009;
THREE.UnsignedShort4444Type = 1016;
THREE.UnsignedShort5551Type = 1017;
THREE.UnsignedShort565Type = 1018;

// Pixel formats

THREE.AlphaFormat = 1019;
THREE.RGBFormat = 1020;
THREE.RGBAFormat = 1021;
THREE.LuminanceFormat = 1022;
THREE.LuminanceAlphaFormat = 1023;
// THREE.RGBEFormat handled as THREE.RGBAFormat in shaders
THREE.RGBEFormat = THREE.RGBAFormat; //1024;

// DDS / ST3C Compressed texture formats

THREE.RGB_S3TC_DXT1_Format = 2001;
THREE.RGBA_S3TC_DXT1_Format = 2002;
THREE.RGBA_S3TC_DXT3_Format = 2003;
THREE.RGBA_S3TC_DXT5_Format = 2004;


// PVRTC compressed texture formats

THREE.RGB_PVRTC_4BPPV1_Format = 2100;
THREE.RGB_PVRTC_2BPPV1_Format = 2101;
THREE.RGBA_PVRTC_4BPPV1_Format = 2102;
THREE.RGBA_PVRTC_2BPPV1_Format = 2103;


// File:src/math/Color.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Color = function (color) {

  if (arguments.length === 3) {

    return this.setRGB(arguments[0], arguments[1], arguments[2]);

  }

  return this.set(color);

};

THREE.Color.prototype = {

  constructor: THREE.Color,

  r: 1, g: 1, b: 1,

  set: function (value) {

    if (value instanceof THREE.Color) {

      this.copy(value);

    } else if (typeof value === 'number') {

      this.setHex(value);

    } else if (typeof value === 'string') {

      this.setStyle(value);

    }

    return this;

  },

  setHex: function (hex) {

    hex = Math.floor(hex);

    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;

    return this;

  },

  setRGB: function (r, g, b) {

    this.r = r;
    this.g = g;
    this.b = b;

    return this;

  },

  setHSL: function (h, s, l) {

    // h,s,l ranges are in 0.0 - 1.0

    if (s === 0) {

      this.r = this.g = this.b = l;

    } else {

      var hue2rgb = function (p, q, t) {

        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
        return p;

      };

      var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
      var q = 2 * l - p;

      this.r = hue2rgb(q, p, h + 1 / 3);
      this.g = hue2rgb(q, p, h);
      this.b = hue2rgb(q, p, h - 1 / 3);

    }

    return this;

  },

  setStyle: function (style) {

    // rgb(255,0,0)

    if (/^rgb\((\d+), ?(\d+), ?(\d+)\)$/i.test(style)) {

      var color = /^rgb\((\d+), ?(\d+), ?(\d+)\)$/i.exec(style);

      this.r = Math.min(255, parseInt(color[1], 10)) / 255;
      this.g = Math.min(255, parseInt(color[2], 10)) / 255;
      this.b = Math.min(255, parseInt(color[3], 10)) / 255;

      return this;

    }

    // rgb(100%,0%,0%)

    if (/^rgb\((\d+)\%, ?(\d+)\%, ?(\d+)\%\)$/i.test(style)) {

      var color = /^rgb\((\d+)\%, ?(\d+)\%, ?(\d+)\%\)$/i.exec(style);

      this.r = Math.min(100, parseInt(color[1], 10)) / 100;
      this.g = Math.min(100, parseInt(color[2], 10)) / 100;
      this.b = Math.min(100, parseInt(color[3], 10)) / 100;

      return this;

    }

    // #ff0000

    if (/^\#([0-9a-f]{6})$/i.test(style)) {

      var color = /^\#([0-9a-f]{6})$/i.exec(style);

      this.setHex(parseInt(color[1], 16));

      return this;

    }

    // #f00

    if (/^\#([0-9a-f])([0-9a-f])([0-9a-f])$/i.test(style)) {

      var color = /^\#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(style);

      this.setHex(parseInt(color[1] + color[1] + color[2] + color[2] + color[3] + color[3], 16));

      return this;

    }

    // red

    if (/^(\w+)$/i.test(style)) {

      this.setHex(THREE.ColorKeywords[style]);

      return this;

    }


  },

  copy: function (color) {

    this.r = color.r;
    this.g = color.g;
    this.b = color.b;

    return this;

  },

  copyGammaToLinear: function (color, gammaFactor) {

    if (gammaFactor === undefined) gammaFactor = 2.0;

    this.r = Math.pow(color.r, gammaFactor);
    this.g = Math.pow(color.g, gammaFactor);
    this.b = Math.pow(color.b, gammaFactor);

    return this;

  },

  copyLinearToGamma: function (color, gammaFactor) {

    if (gammaFactor === undefined) gammaFactor = 2.0;

    var safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;

    this.r = Math.pow(color.r, safeInverse);
    this.g = Math.pow(color.g, safeInverse);
    this.b = Math.pow(color.b, safeInverse);

    return this;

  },

  convertGammaToLinear: function () {

    var r = this.r,g = this.g,b = this.b;

    this.r = r * r;
    this.g = g * g;
    this.b = b * b;

    return this;

  },

  convertLinearToGamma: function () {

    this.r = Math.sqrt(this.r);
    this.g = Math.sqrt(this.g);
    this.b = Math.sqrt(this.b);

    return this;

  },

  getHex: function () {

    return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;

  },

  getHexString: function () {

    return ('000000' + this.getHex().toString(16)).slice(-6);

  },

  getHSL: function (optionalTarget) {

    // h,s,l ranges are in 0.0 - 1.0

    var hsl = optionalTarget || { h: 0, s: 0, l: 0 };

    var r = this.r,g = this.g,b = this.b;

    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);

    var hue, saturation;
    var lightness = (min + max) / 2.0;

    if (min === max) {

      hue = 0;
      saturation = 0;

    } else {

      var delta = max - min;

      saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);

      switch (max) {

        case r:hue = (g - b) / delta + (g < b ? 6 : 0);break;
        case g:hue = (b - r) / delta + 2;break;
        case b:hue = (r - g) / delta + 4;break;

      }

      hue /= 6;

    }

    hsl.h = hue;
    hsl.s = saturation;
    hsl.l = lightness;

    return hsl;

  },

  getStyle: function () {

    return 'rgb(' + (this.r * 255 | 0) + ',' + (this.g * 255 | 0) + ',' + (this.b * 255 | 0) + ')';

  },

  offsetHSL: function (h, s, l) {

    var hsl = this.getHSL();

    hsl.h += h;hsl.s += s;hsl.l += l;

    this.setHSL(hsl.h, hsl.s, hsl.l);

    return this;

  },

  add: function (color) {

    this.r += color.r;
    this.g += color.g;
    this.b += color.b;

    return this;

  },

  addColors: function (color1, color2) {

    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;

    return this;

  },

  addScalar: function (s) {

    this.r += s;
    this.g += s;
    this.b += s;

    return this;

  },

  multiply: function (color) {

    this.r *= color.r;
    this.g *= color.g;
    this.b *= color.b;

    return this;

  },

  multiplyScalar: function (s) {

    this.r *= s;
    this.g *= s;
    this.b *= s;

    return this;

  },

  lerp: function (color, alpha) {

    this.r += (color.r - this.r) * alpha;
    this.g += (color.g - this.g) * alpha;
    this.b += (color.b - this.b) * alpha;

    return this;

  },

  equals: function (c) {

    return c.r === this.r && c.g === this.g && c.b === this.b;

  },

  fromArray: function (array) {

    this.r = array[0];
    this.g = array[1];
    this.b = array[2];

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this.r;
    array[offset + 1] = this.g;
    array[offset + 2] = this.b;

    return array;
  },

  clone: function () {

    return new THREE.Color().setRGB(this.r, this.g, this.b);

  }

};

THREE.ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
  'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
  'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
  'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
  'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
  'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
  'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
  'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
  'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
  'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
  'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
  'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
  'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
  'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
  'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
  'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
  'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
  'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
  'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
  'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
  'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
  'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
  'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
  'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

// File:src/math/Quaternion.js

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://exocortex.com
 */

THREE.Quaternion = function (x, y, z, w) {

  this._x = x || 0;
  this._y = y || 0;
  this._z = z || 0;
  this._w = w !== undefined ? w : 1;

};

THREE.Quaternion.prototype = {

  constructor: THREE.Quaternion,

  _x: 0, _y: 0, _z: 0, _w: 0,

  get x() {

    return this._x;

  },

  set x(value) {

    this._x = value;
    this.onChangeCallback();

  },

  get y() {

    return this._y;

  },

  set y(value) {

    this._y = value;
    this.onChangeCallback();

  },

  get z() {

    return this._z;

  },

  set z(value) {

    this._z = value;
    this.onChangeCallback();

  },

  get w() {

    return this._w;

  },

  set w(value) {

    this._w = value;
    this.onChangeCallback();

  },

  set: function (x, y, z, w) {

    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;

    this.onChangeCallback();

    return this;

  },

  copy: function (quaternion) {

    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;

    this.onChangeCallback();

    return this;

  },

  setFromEuler: function (euler, update) {

    if (euler instanceof THREE.Euler === false) {

      throw new Error('THREE.Quaternion: .setFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
    }

    // http://www.mathworks.com/matlabcentral/fileexchange/
    // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
    //	content/SpinCalc.m

    var c1 = Math.cos(euler._x / 2);
    var c2 = Math.cos(euler._y / 2);
    var c3 = Math.cos(euler._z / 2);
    var s1 = Math.sin(euler._x / 2);
    var s2 = Math.sin(euler._y / 2);
    var s3 = Math.sin(euler._z / 2);

    if (euler.order === 'XYZ') {

      this._x = s1 * c2 * c3 + c1 * s2 * s3;
      this._y = c1 * s2 * c3 - s1 * c2 * s3;
      this._z = c1 * c2 * s3 + s1 * s2 * c3;
      this._w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if (euler.order === 'YXZ') {

      this._x = s1 * c2 * c3 + c1 * s2 * s3;
      this._y = c1 * s2 * c3 - s1 * c2 * s3;
      this._z = c1 * c2 * s3 - s1 * s2 * c3;
      this._w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if (euler.order === 'ZXY') {

      this._x = s1 * c2 * c3 - c1 * s2 * s3;
      this._y = c1 * s2 * c3 + s1 * c2 * s3;
      this._z = c1 * c2 * s3 + s1 * s2 * c3;
      this._w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if (euler.order === 'ZYX') {

      this._x = s1 * c2 * c3 - c1 * s2 * s3;
      this._y = c1 * s2 * c3 + s1 * c2 * s3;
      this._z = c1 * c2 * s3 - s1 * s2 * c3;
      this._w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if (euler.order === 'YZX') {

      this._x = s1 * c2 * c3 + c1 * s2 * s3;
      this._y = c1 * s2 * c3 + s1 * c2 * s3;
      this._z = c1 * c2 * s3 - s1 * s2 * c3;
      this._w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if (euler.order === 'XZY') {

      this._x = s1 * c2 * c3 - c1 * s2 * s3;
      this._y = c1 * s2 * c3 - s1 * c2 * s3;
      this._z = c1 * c2 * s3 + s1 * s2 * c3;
      this._w = c1 * c2 * c3 + s1 * s2 * s3;

    }

    if (update !== false) this.onChangeCallback();

    return this;

  },

  setFromAxisAngle: function (axis, angle) {

    // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

    // assumes axis is normalized

    var halfAngle = angle / 2,s = Math.sin(halfAngle);

    this._x = axis.x * s;
    this._y = axis.y * s;
    this._z = axis.z * s;
    this._w = Math.cos(halfAngle);

    this.onChangeCallback();

    return this;

  },

  setFromRotationMatrix: function (m) {

    // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

    // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

    var te = m.elements,

      m11 = te[0],m12 = te[4],m13 = te[8],
      m21 = te[1],m22 = te[5],m23 = te[9],
      m31 = te[2],m32 = te[6],m33 = te[10],

      trace = m11 + m22 + m33,
      s;

    if (trace > 0) {

      s = 0.5 / Math.sqrt(trace + 1.0);

      this._w = 0.25 / s;
      this._x = (m32 - m23) * s;
      this._y = (m13 - m31) * s;
      this._z = (m21 - m12) * s;

    } else if (m11 > m22 && m11 > m33) {

      s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);

      this._w = (m32 - m23) / s;
      this._x = 0.25 * s;
      this._y = (m12 + m21) / s;
      this._z = (m13 + m31) / s;

    } else if (m22 > m33) {

      s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);

      this._w = (m13 - m31) / s;
      this._x = (m12 + m21) / s;
      this._y = 0.25 * s;
      this._z = (m23 + m32) / s;

    } else {

      s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);

      this._w = (m21 - m12) / s;
      this._x = (m13 + m31) / s;
      this._y = (m23 + m32) / s;
      this._z = 0.25 * s;

    }

    this.onChangeCallback();

    return this;

  },

  setFromUnitVectors: function () {

    // http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final

    // assumes direction vectors vFrom and vTo are normalized

    var v1, r;

    var EPS = 0.000001;

    return function (vFrom, vTo) {

      if (v1 === undefined) v1 = new THREE.Vector3();

      r = vFrom.dot(vTo) + 1;

      if (r < EPS) {

        r = 0;

        if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {

          v1.set(-vFrom.y, vFrom.x, 0);

        } else {

          v1.set(0, -vFrom.z, vFrom.y);

        }

      } else {

        v1.crossVectors(vFrom, vTo);

      }

      this._x = v1.x;
      this._y = v1.y;
      this._z = v1.z;
      this._w = r;

      this.normalize();

      return this;

    };

  }(),

  inverse: function () {

    this.conjugate().normalize();

    return this;

  },

  // Polyfill for r125 Quaternion.invert: https://github.com/mrdoob/three.js/commit/8bc2e1f28c510586dcfd643b4fd9f8a1af023761
  invert: function () {
    return this.inverse();
  },

  conjugate: function () {

    this._x *= -1;
    this._y *= -1;
    this._z *= -1;

    this.onChangeCallback();

    return this;

  },

  dot: function (v) {

    return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

  },

  lengthSq: function () {

    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

  },

  length: function () {

    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);

  },

  normalize: function () {

    var l = this.length();

    if (l === 0) {

      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;

    } else {

      l = 1 / l;

      this._x = this._x * l;
      this._y = this._y * l;
      this._z = this._z * l;
      this._w = this._w * l;

    }

    this.onChangeCallback();

    return this;

  },

  multiply: function (q, p) {

    if (p !== undefined) {

      THREE.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
      return this.multiplyQuaternions(q, p);

    }

    return this.multiplyQuaternions(this, q);

  },

  multiplyQuaternions: function (a, b) {

    // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

    var qax = a._x,qay = a._y,qaz = a._z,qaw = a._w;
    var qbx = b._x,qby = b._y,qbz = b._z,qbw = b._w;

    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

    this.onChangeCallback();

    return this;

  },

  multiplyVector3: function (vector) {

    THREE.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
    return vector.applyQuaternion(this);

  },

  slerp: function (qb, t) {

    if (t === 0) return this;
    if (t === 1) return this.copy(qb);

    var x = this._x,y = this._y,z = this._z,w = this._w;

    // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

    var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

    if (cosHalfTheta < 0) {

      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;

      cosHalfTheta = -cosHalfTheta;

    } else {

      this.copy(qb);

    }

    if (cosHalfTheta >= 1.0) {

      this._w = w;
      this._x = x;
      this._y = y;
      this._z = z;

      return this;

    }

    var halfTheta = Math.acos(cosHalfTheta);
    var sinHalfTheta = Math.sqrt(1.0 - cosHalfTheta * cosHalfTheta);

    if (Math.abs(sinHalfTheta) < 0.001) {

      this._w = 0.5 * (w + this._w);
      this._x = 0.5 * (x + this._x);
      this._y = 0.5 * (y + this._y);
      this._z = 0.5 * (z + this._z);

      return this;

    }

    var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
      ratioB = Math.sin(t * halfTheta) / sinHalfTheta;

    this._w = w * ratioA + this._w * ratioB;
    this._x = x * ratioA + this._x * ratioB;
    this._y = y * ratioA + this._y * ratioB;
    this._z = z * ratioA + this._z * ratioB;

    this.onChangeCallback();

    return this;

  },

  equals: function (quaternion) {

    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;

  },

  fromArray: function (array, offset) {

    if (offset === undefined) offset = 0;

    this._x = array[offset];
    this._y = array[offset + 1];
    this._z = array[offset + 2];
    this._w = array[offset + 3];

    this.onChangeCallback();

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._w;

    return array;

  },

  onChange: function (callback) {

    this.onChangeCallback = callback;

    return this;

  },

  onChangeCallback: function () {},

  clone: function () {

    return new THREE.Quaternion(this._x, this._y, this._z, this._w);

  }

};

THREE.Quaternion.slerp = function (qa, qb, qm, t) {

  return qm.copy(qa).slerp(qb, t);

};

// File:src/math/Vector2.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author philogb / http://blog.thejit.org/
 * @author egraether / http://egraether.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

THREE.Vector2 = function (x, y) {

  this.x = x || 0;
  this.y = y || 0;

};

THREE.Vector2.prototype = {

  constructor: THREE.Vector2,

  set: function (x, y) {

    this.x = x;
    this.y = y;

    return this;

  },

  setX: function (x) {

    this.x = x;

    return this;

  },

  setY: function (y) {

    this.y = y;

    return this;

  },

  setComponent: function (index, value) {

    switch (index) {

      case 0:this.x = value;break;
      case 1:this.y = value;break;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  getComponent: function (index) {

    switch (index) {

      case 0:return this.x;
      case 1:return this.y;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  copy: function (v) {

    this.x = v.x;
    this.y = v.y;

    return this;

  },

  add: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
      return this.addVectors(v, w);

    }

    this.x += v.x;
    this.y += v.y;

    return this;

  },

  addScalar: function (s) {

    this.x += s;
    this.y += s;

    return this;

  },

  addVectors: function (a, b) {

    this.x = a.x + b.x;
    this.y = a.y + b.y;

    return this;

  },

  sub: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
      return this.subVectors(v, w);

    }

    this.x -= v.x;
    this.y -= v.y;

    return this;

  },

  subScalar: function (s) {

    this.x -= s;
    this.y -= s;

    return this;

  },

  subVectors: function (a, b) {

    this.x = a.x - b.x;
    this.y = a.y - b.y;

    return this;

  },

  multiply: function (v) {

    this.x *= v.x;
    this.y *= v.y;

    return this;

  },

  multiplyScalar: function (s) {

    this.x *= s;
    this.y *= s;

    return this;

  },

  divide: function (v) {

    this.x /= v.x;
    this.y /= v.y;

    return this;

  },

  divideScalar: function (scalar) {

    if (scalar !== 0) {

      var invScalar = 1 / scalar;

      this.x *= invScalar;
      this.y *= invScalar;

    } else {

      this.x = 0;
      this.y = 0;

    }

    return this;

  },

  min: function (v) {

    if (this.x > v.x) {

      this.x = v.x;

    }

    if (this.y > v.y) {

      this.y = v.y;

    }

    return this;

  },

  max: function (v) {

    if (this.x < v.x) {

      this.x = v.x;

    }

    if (this.y < v.y) {

      this.y = v.y;

    }

    return this;

  },

  clamp: function (min, max) {

    // This function assumes min < max, if this assumption isn't true it will not operate correctly

    if (this.x < min.x) {

      this.x = min.x;

    } else if (this.x > max.x) {

      this.x = max.x;

    }

    if (this.y < min.y) {

      this.y = min.y;

    } else if (this.y > max.y) {

      this.y = max.y;

    }

    return this;
  },

  clampScalar: function () {

    var min, max;

    return function (minVal, maxVal) {

      if (min === undefined) {

        min = new THREE.Vector2();
        max = new THREE.Vector2();

      }

      min.set(minVal, minVal);
      max.set(maxVal, maxVal);

      return this.clamp(min, max);

    };

  }(),

  floor: function () {

    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);

    return this;

  },

  ceil: function () {

    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);

    return this;

  },

  round: function () {

    this.x = Math.round(this.x);
    this.y = Math.round(this.y);

    return this;

  },

  roundToZero: function () {

    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);

    return this;

  },

  negate: function () {

    this.x = -this.x;
    this.y = -this.y;

    return this;

  },

  dot: function (v) {

    return this.x * v.x + this.y * v.y;

  },

  lengthSq: function () {

    return this.x * this.x + this.y * this.y;

  },

  length: function () {

    return Math.sqrt(this.x * this.x + this.y * this.y);

  },

  normalize: function () {

    return this.divideScalar(this.length());

  },

  distanceTo: function (v) {

    return Math.sqrt(this.distanceToSquared(v));

  },

  distanceToSquared: function (v) {

    var dx = this.x - v.x,dy = this.y - v.y;
    return dx * dx + dy * dy;

  },

  setLength: function (l) {

    var oldLength = this.length();

    if (oldLength !== 0 && l !== oldLength) {

      this.multiplyScalar(l / oldLength);
    }

    return this;

  },

  lerp: function (v, alpha) {

    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;

    return this;

  },

  lerpVectors: function (v1, v2, alpha) {

    this.subVectors(v2, v1).multiplyScalar(alpha).add(v1);

    return this;

  },

  equals: function (v) {

    return v.x === this.x && v.y === this.y;

  },

  fromArray: function (array, offset) {

    if (offset === undefined) offset = 0;

    this.x = array[offset];
    this.y = array[offset + 1];

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this.x;
    array[offset + 1] = this.y;

    return array;

  },

  fromAttribute: function (attribute, index, offset) {

    if (offset === undefined) offset = 0;

    index = index * attribute.itemSize + offset;

    this.x = attribute.array[index];
    this.y = attribute.array[index + 1];

    return this;

  },

  // Polyfill for r84 Vector2.fromBufferAttribute: https://github.com/mrdoob/three.js/commit/a4cf80b2c62d8348d8e13986591bcf6d3a72ce7c
  fromBufferAttribute: function (attribute, index, offset) {

    return this.fromAttribute(attribute, index, offset);

  },

  clone: function () {

    return new THREE.Vector2(this.x, this.y);

  }

};

// File:src/math/Vector3.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author *kile / http://kile.stravaganza.org/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

THREE.Vector3 = function (x, y, z) {

  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;

};

THREE.Vector3.prototype = {

  constructor: THREE.Vector3,

  set: function (x, y, z) {

    this.x = x;
    this.y = y;
    this.z = z;

    return this;

  },

  setX: function (x) {

    this.x = x;

    return this;

  },

  setY: function (y) {

    this.y = y;

    return this;

  },

  setZ: function (z) {

    this.z = z;

    return this;

  },

  setComponent: function (index, value) {

    switch (index) {

      case 0:this.x = value;break;
      case 1:this.y = value;break;
      case 2:this.z = value;break;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  getComponent: function (index) {

    switch (index) {

      case 0:return this.x;
      case 1:return this.y;
      case 2:return this.z;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  copy: function (v) {

    this.x = v.x;
    this.y = v.y;
    this.z = v.z;

    return this;

  },

  add: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
      return this.addVectors(v, w);

    }

    this.x += v.x;
    this.y += v.y;
    this.z += v.z;

    return this;

  },

  addScalar: function (s) {

    this.x += s;
    this.y += s;
    this.z += s;

    return this;

  },

  addVectors: function (a, b) {

    this.x = a.x + b.x;
    this.y = a.y + b.y;
    this.z = a.z + b.z;

    return this;

  },

  sub: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
      return this.subVectors(v, w);

    }

    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;

    return this;

  },

  subScalar: function (s) {

    this.x -= s;
    this.y -= s;
    this.z -= s;

    return this;

  },

  subVectors: function (a, b) {

    this.x = a.x - b.x;
    this.y = a.y - b.y;
    this.z = a.z - b.z;

    return this;

  },

  multiply: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
      return this.multiplyVectors(v, w);

    }

    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;

    return this;

  },

  multiplyScalar: function (scalar) {

    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;

    return this;

  },

  multiplyVectors: function (a, b) {

    this.x = a.x * b.x;
    this.y = a.y * b.y;
    this.z = a.z * b.z;

    return this;

  },

  applyEuler: function () {

    var quaternion;

    return function (euler) {

      if (euler instanceof THREE.Euler === false) {

        THREE.error('THREE.Vector3: .applyEuler() now expects a Euler rotation rather than a Vector3 and order.');

      }

      if (quaternion === undefined) quaternion = new THREE.Quaternion();

      this.applyQuaternion(quaternion.setFromEuler(euler));

      return this;

    };

  }(),

  applyAxisAngle: function () {

    var quaternion;

    return function (axis, angle) {

      if (quaternion === undefined) quaternion = new THREE.Quaternion();

      this.applyQuaternion(quaternion.setFromAxisAngle(axis, angle));

      return this;

    };

  }(),

  applyMatrix3: function (m) {

    var x = this.x;
    var y = this.y;
    var z = this.z;

    var e = m.elements;

    this.x = e[0] * x + e[3] * y + e[6] * z;
    this.y = e[1] * x + e[4] * y + e[7] * z;
    this.z = e[2] * x + e[5] * y + e[8] * z;

    return this;

  },

  applyMatrix4: function (m) {

    // input: THREE.Matrix4 affine matrix

    var x = this.x,y = this.y,z = this.z;

    var e = m.elements;

    this.x = e[0] * x + e[4] * y + e[8] * z + e[12];
    this.y = e[1] * x + e[5] * y + e[9] * z + e[13];
    this.z = e[2] * x + e[6] * y + e[10] * z + e[14];

    return this;

  },

  applyProjection: function (m) {

    // input: THREE.Matrix4 projection matrix

    var x = this.x,y = this.y,z = this.z;

    var e = m.elements;
    var d = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]); // perspective divide

    this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * d;
    this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * d;
    this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * d;

    return this;

  },

  applyQuaternion: function (q) {

    var x = this.x;
    var y = this.y;
    var z = this.z;

    var qx = q.x;
    var qy = q.y;
    var qz = q.z;
    var qw = q.w;

    // calculate quat * vector

    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z;

    // calculate result * inverse quat

    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

    return this;

  },

  project: function () {

    var matrix;

    return function (camera) {

      if (matrix === undefined) matrix = new THREE.Matrix4();

      matrix.multiplyMatrices(camera.projectionMatrix, matrix.getInverse(camera.matrixWorld));
      return this.applyProjection(matrix);

    };

  }(),

  unproject: function () {

    var matrix;

    return function (camera) {

      if (matrix === undefined) matrix = new THREE.Matrix4();

      matrix.multiplyMatrices(camera.matrixWorld, matrix.getInverse(camera.projectionMatrix));
      return this.applyProjection(matrix);

    };

  }(),

  transformDirection: function (m) {

    // input: THREE.Matrix4 affine matrix
    // vector interpreted as a direction

    var x = this.x,y = this.y,z = this.z;

    var e = m.elements;

    this.x = e[0] * x + e[4] * y + e[8] * z;
    this.y = e[1] * x + e[5] * y + e[9] * z;
    this.z = e[2] * x + e[6] * y + e[10] * z;

    this.normalize();

    return this;

  },

  divide: function (v) {

    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;

    return this;

  },

  divideScalar: function (scalar) {

    if (scalar !== 0) {

      var invScalar = 1 / scalar;

      this.x *= invScalar;
      this.y *= invScalar;
      this.z *= invScalar;

    } else {

      this.x = 0;
      this.y = 0;
      this.z = 0;

    }

    return this;

  },

  min: function (v) {

    if (this.x > v.x) {

      this.x = v.x;

    }

    if (this.y > v.y) {

      this.y = v.y;

    }

    if (this.z > v.z) {

      this.z = v.z;

    }

    return this;

  },

  max: function (v) {

    if (this.x < v.x) {

      this.x = v.x;

    }

    if (this.y < v.y) {

      this.y = v.y;

    }

    if (this.z < v.z) {

      this.z = v.z;

    }

    return this;

  },

  clamp: function (min, max) {

    // This function assumes min < max, if this assumption isn't true it will not operate correctly

    if (this.x < min.x) {

      this.x = min.x;

    } else if (this.x > max.x) {

      this.x = max.x;

    }

    if (this.y < min.y) {

      this.y = min.y;

    } else if (this.y > max.y) {

      this.y = max.y;

    }

    if (this.z < min.z) {

      this.z = min.z;

    } else if (this.z > max.z) {

      this.z = max.z;

    }

    return this;

  },

  clampScalar: function () {

    var min, max;

    return function (minVal, maxVal) {

      if (min === undefined) {

        min = new THREE.Vector3();
        max = new THREE.Vector3();

      }

      min.set(minVal, minVal, minVal);
      max.set(maxVal, maxVal, maxVal);

      return this.clamp(min, max);

    };

  }(),

  floor: function () {

    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);

    return this;

  },

  ceil: function () {

    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);

    return this;

  },

  round: function () {

    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);

    return this;

  },

  roundToZero: function () {

    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);

    return this;

  },

  negate: function () {

    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;

    return this;

  },

  dot: function (v) {

    return this.x * v.x + this.y * v.y + this.z * v.z;

  },

  lengthSq: function () {

    return this.x * this.x + this.y * this.y + this.z * this.z;

  },

  length: function () {

    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);

  },

  lengthManhattan: function () {

    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);

  },

  normalize: function () {

    return this.divideScalar(this.length());

  },

  setLength: function (l) {

    var oldLength = this.length();

    if (oldLength !== 0 && l !== oldLength) {

      this.multiplyScalar(l / oldLength);
    }

    return this;

  },

  lerp: function (v, alpha) {

    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;

    return this;

  },

  lerpVectors: function (v1, v2, alpha) {

    this.subVectors(v2, v1).multiplyScalar(alpha).add(v1);

    return this;

  },

  cross: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
      return this.crossVectors(v, w);

    }

    var x = this.x,y = this.y,z = this.z;

    this.x = y * v.z - z * v.y;
    this.y = z * v.x - x * v.z;
    this.z = x * v.y - y * v.x;

    return this;

  },

  crossVectors: function (a, b) {

    var ax = a.x,ay = a.y,az = a.z;
    var bx = b.x,by = b.y,bz = b.z;

    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;

    return this;

  },

  projectOnVector: function () {

    var v1, dot;

    return function (vector) {

      if (v1 === undefined) v1 = new THREE.Vector3();

      v1.copy(vector).normalize();

      dot = this.dot(v1);

      return this.copy(v1).multiplyScalar(dot);

    };

  }(),

  projectOnPlane: function () {

    var v1;

    return function (planeNormal) {

      if (v1 === undefined) v1 = new THREE.Vector3();

      v1.copy(this).projectOnVector(planeNormal);

      return this.sub(v1);

    };

  }(),

  reflect: function () {

    // reflect incident vector off plane orthogonal to normal
    // normal is assumed to have unit length

    var v1;

    return function (normal) {

      if (v1 === undefined) v1 = new THREE.Vector3();

      return this.sub(v1.copy(normal).multiplyScalar(2 * this.dot(normal)));

    };

  }(),

  angleTo: function (v) {

    var theta = this.dot(v) / (this.length() * v.length());

    // clamp, to handle numerical problems

    return Math.acos(THREE.Math.clamp(theta, -1, 1));

  },

  distanceTo: function (v) {

    return Math.sqrt(this.distanceToSquared(v));

  },

  distanceToSquared: function (v) {

    var dx = this.x - v.x;
    var dy = this.y - v.y;
    var dz = this.z - v.z;

    return dx * dx + dy * dy + dz * dz;

  },

  setEulerFromRotationMatrix: function (m, order) {

    THREE.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');

  },

  setEulerFromQuaternion: function (q, order) {

    THREE.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');

  },

  getPositionFromMatrix: function (m) {

    THREE.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');

    return this.setFromMatrixPosition(m);

  },

  getScaleFromMatrix: function (m) {

    THREE.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');

    return this.setFromMatrixScale(m);
  },

  getColumnFromMatrix: function (index, matrix) {

    THREE.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');

    return this.setFromMatrixColumn(index, matrix);

  },

  setFromMatrixPosition: function (m) {

    this.x = m.elements[12];
    this.y = m.elements[13];
    this.z = m.elements[14];

    return this;

  },

  setFromMatrixScale: function (m) {

    var sx = this.set(m.elements[0], m.elements[1], m.elements[2]).length();
    var sy = this.set(m.elements[4], m.elements[5], m.elements[6]).length();
    var sz = this.set(m.elements[8], m.elements[9], m.elements[10]).length();

    this.x = sx;
    this.y = sy;
    this.z = sz;

    return this;
  },

  setFromMatrixColumn: function (index, matrix) {

    var offset = index * 4;

    var me = matrix.elements;

    this.x = me[offset];
    this.y = me[offset + 1];
    this.z = me[offset + 2];

    return this;

  },

  equals: function (v) {

    return v.x === this.x && v.y === this.y && v.z === this.z;

  },

  fromArray: function (array, offset) {

    if (offset === undefined) offset = 0;

    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;

    return array;

  },

  fromAttribute: function (attribute, index, offset) {

    if (offset === undefined) offset = 0;

    index = index * attribute.itemSize + offset;

    this.x = attribute.array[index];
    this.y = attribute.array[index + 1];
    this.z = attribute.array[index + 2];

    return this;

  },

  // Polyfill for r84 Vector2.fromBufferAttribute: https://github.com/mrdoob/three.js/commit/a4cf80b2c62d8348d8e13986591bcf6d3a72ce7c
  fromBufferAttribute: function (attribute, index, offset) {

    return this.fromAttribute(attribute, index, offset);

  },

  clone: function () {

    return new THREE.Vector3(this.x, this.y, this.z);

  }

};

// File:src/math/Vector4.js

/**
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

THREE.Vector4 = function (x, y, z, w) {

  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;
  this.w = w !== undefined ? w : 1;

};

THREE.Vector4.prototype = {

  constructor: THREE.Vector4,

  set: function (x, y, z, w) {

    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;

    return this;

  },

  setX: function (x) {

    this.x = x;

    return this;

  },

  setY: function (y) {

    this.y = y;

    return this;

  },

  setZ: function (z) {

    this.z = z;

    return this;

  },

  setW: function (w) {

    this.w = w;

    return this;

  },

  setComponent: function (index, value) {

    switch (index) {

      case 0:this.x = value;break;
      case 1:this.y = value;break;
      case 2:this.z = value;break;
      case 3:this.w = value;break;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  getComponent: function (index) {

    switch (index) {

      case 0:return this.x;
      case 1:return this.y;
      case 2:return this.z;
      case 3:return this.w;
      default:throw new Error('index is out of range: ' + index);

    }

  },

  copy: function (v) {

    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    this.w = v.w !== undefined ? v.w : 1;

    return this;

  },

  add: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
      return this.addVectors(v, w);

    }

    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    this.w += v.w;

    return this;

  },

  addScalar: function (s) {

    this.x += s;
    this.y += s;
    this.z += s;
    this.w += s;

    return this;

  },

  addVectors: function (a, b) {

    this.x = a.x + b.x;
    this.y = a.y + b.y;
    this.z = a.z + b.z;
    this.w = a.w + b.w;

    return this;

  },

  sub: function (v, w) {

    if (w !== undefined) {

      THREE.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
      return this.subVectors(v, w);

    }

    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    this.w -= v.w;

    return this;

  },

  subScalar: function (s) {

    this.x -= s;
    this.y -= s;
    this.z -= s;
    this.w -= s;

    return this;

  },

  subVectors: function (a, b) {

    this.x = a.x - b.x;
    this.y = a.y - b.y;
    this.z = a.z - b.z;
    this.w = a.w - b.w;

    return this;

  },

  multiplyScalar: function (scalar) {

    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;

    return this;

  },

  applyMatrix4: function (m) {

    var x = this.x;
    var y = this.y;
    var z = this.z;
    var w = this.w;

    var e = m.elements;

    this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
    this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
    this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
    this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;

    return this;

  },

  divideScalar: function (scalar) {

    if (scalar !== 0) {

      var invScalar = 1 / scalar;

      this.x *= invScalar;
      this.y *= invScalar;
      this.z *= invScalar;
      this.w *= invScalar;

    } else {

      this.x = 0;
      this.y = 0;
      this.z = 0;
      this.w = 1;

    }

    return this;

  },

  setAxisAngleFromQuaternion: function (q) {

    // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

    // q is assumed to be normalized

    this.w = 2 * Math.acos(q.w);

    var s = Math.sqrt(1 - q.w * q.w);

    if (s < 0.0001) {

      this.x = 1;
      this.y = 0;
      this.z = 0;

    } else {

      this.x = q.x / s;
      this.y = q.y / s;
      this.z = q.z / s;

    }

    return this;

  },

  setAxisAngleFromRotationMatrix: function (m) {

    // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

    // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

    var angle,x,y,z, // variables for result
      epsilon = 0.01, // margin to allow for rounding errors
      epsilon2 = 0.1, // margin to distinguish between 0 and 180 degrees

      te = m.elements,

      m11 = te[0],m12 = te[4],m13 = te[8],
      m21 = te[1],m22 = te[5],m23 = te[9],
      m31 = te[2],m32 = te[6],m33 = te[10];

    if (Math.abs(m12 - m21) < epsilon &&
    Math.abs(m13 - m31) < epsilon &&
    Math.abs(m23 - m32) < epsilon) {

      // singularity found
      // first check for identity matrix which must have +1 for all terms
      // in leading diagonal and zero in other terms

      if (Math.abs(m12 + m21) < epsilon2 &&
      Math.abs(m13 + m31) < epsilon2 &&
      Math.abs(m23 + m32) < epsilon2 &&
      Math.abs(m11 + m22 + m33 - 3) < epsilon2) {

        // this singularity is identity matrix so angle = 0

        this.set(1, 0, 0, 0);

        return this; // zero angle, arbitrary axis

      }

      // otherwise this singularity is angle = 180

      angle = Math.PI;

      var xx = (m11 + 1) / 2;
      var yy = (m22 + 1) / 2;
      var zz = (m33 + 1) / 2;
      var xy = (m12 + m21) / 4;
      var xz = (m13 + m31) / 4;
      var yz = (m23 + m32) / 4;

      if (xx > yy && xx > zz) {// m11 is the largest diagonal term

        if (xx < epsilon) {

          x = 0;
          y = 0.707106781;
          z = 0.707106781;

        } else {

          x = Math.sqrt(xx);
          y = xy / x;
          z = xz / x;

        }

      } else if (yy > zz) {// m22 is the largest diagonal term

        if (yy < epsilon) {

          x = 0.707106781;
          y = 0;
          z = 0.707106781;

        } else {

          y = Math.sqrt(yy);
          x = xy / y;
          z = yz / y;

        }

      } else {// m33 is the largest diagonal term so base result on this

        if (zz < epsilon) {

          x = 0.707106781;
          y = 0.707106781;
          z = 0;

        } else {

          z = Math.sqrt(zz);
          x = xz / z;
          y = yz / z;

        }

      }

      this.set(x, y, z, angle);

      return this; // return 180 deg rotation

    }

    // as we have reached here there are no singularities so we can handle normally

    var s = Math.sqrt((m32 - m23) * (m32 - m23) +
    (m13 - m31) * (m13 - m31) +
    (m21 - m12) * (m21 - m12)); // used to normalize

    if (Math.abs(s) < 0.001) s = 1;

    // prevent divide by zero, should not happen if matrix is orthogonal and should be
    // caught by singularity test above, but I've left it in just in case

    this.x = (m32 - m23) / s;
    this.y = (m13 - m31) / s;
    this.z = (m21 - m12) / s;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);

    return this;

  },

  min: function (v) {

    if (this.x > v.x) {

      this.x = v.x;

    }

    if (this.y > v.y) {

      this.y = v.y;

    }

    if (this.z > v.z) {

      this.z = v.z;

    }

    if (this.w > v.w) {

      this.w = v.w;

    }

    return this;

  },

  max: function (v) {

    if (this.x < v.x) {

      this.x = v.x;

    }

    if (this.y < v.y) {

      this.y = v.y;

    }

    if (this.z < v.z) {

      this.z = v.z;

    }

    if (this.w < v.w) {

      this.w = v.w;

    }

    return this;

  },

  clamp: function (min, max) {

    // This function assumes min < max, if this assumption isn't true it will not operate correctly

    if (this.x < min.x) {

      this.x = min.x;

    } else if (this.x > max.x) {

      this.x = max.x;

    }

    if (this.y < min.y) {

      this.y = min.y;

    } else if (this.y > max.y) {

      this.y = max.y;

    }

    if (this.z < min.z) {

      this.z = min.z;

    } else if (this.z > max.z) {

      this.z = max.z;

    }

    if (this.w < min.w) {

      this.w = min.w;

    } else if (this.w > max.w) {

      this.w = max.w;

    }

    return this;

  },

  clampScalar: function () {

    var min, max;

    return function (minVal, maxVal) {

      if (min === undefined) {

        min = new THREE.Vector4();
        max = new THREE.Vector4();

      }

      min.set(minVal, minVal, minVal, minVal);
      max.set(maxVal, maxVal, maxVal, maxVal);

      return this.clamp(min, max);

    };

  }(),

  floor: function () {

    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);

    return this;

  },

  ceil: function () {

    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);

    return this;

  },

  round: function () {

    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);

    return this;

  },

  roundToZero: function () {

    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);

    return this;

  },

  negate: function () {

    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;

    return this;

  },

  dot: function (v) {

    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

  },

  lengthSq: function () {

    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

  },

  length: function () {

    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);

  },

  lengthManhattan: function () {

    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);

  },

  normalize: function () {

    return this.divideScalar(this.length());

  },

  setLength: function (l) {

    var oldLength = this.length();

    if (oldLength !== 0 && l !== oldLength) {

      this.multiplyScalar(l / oldLength);

    }

    return this;

  },

  lerp: function (v, alpha) {

    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    this.w += (v.w - this.w) * alpha;

    return this;

  },

  lerpVectors: function (v1, v2, alpha) {

    this.subVectors(v2, v1).multiplyScalar(alpha).add(v1);

    return this;

  },

  equals: function (v) {

    return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;

  },

  fromArray: function (array, offset) {

    if (offset === undefined) offset = 0;

    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    this.w = array[offset + 3];

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    array[offset + 3] = this.w;

    return array;

  },

  fromAttribute: function (attribute, index, offset) {

    if (offset === undefined) offset = 0;

    index = index * attribute.itemSize + offset;

    this.x = attribute.array[index];
    this.y = attribute.array[index + 1];
    this.z = attribute.array[index + 2];
    this.w = attribute.array[index + 3];

    return this;

  },

  // Polyfill for r84 Vector2.fromBufferAttribute: https://github.com/mrdoob/three.js/commit/a4cf80b2c62d8348d8e13986591bcf6d3a72ce7c
  fromBufferAttribute: function (attribute, index, offset) {

    return this.fromAttribute(attribute, index, offset);

  },

  clone: function () {

    return new THREE.Vector4(this.x, this.y, this.z, this.w);

  }

};

// File:src/math/Euler.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://exocortex.com
 */

THREE.Euler = function (x, y, z, order) {

  this._x = x || 0;
  this._y = y || 0;
  this._z = z || 0;
  this._order = order || THREE.Euler.DefaultOrder;

};

THREE.Euler.RotationOrders = ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'];

THREE.Euler.DefaultOrder = 'XYZ';

THREE.Euler.prototype = {

  constructor: THREE.Euler,

  _x: 0, _y: 0, _z: 0, _order: THREE.Euler.DefaultOrder,

  get x() {

    return this._x;

  },

  set x(value) {

    this._x = value;
    this.onChangeCallback();

  },

  get y() {

    return this._y;

  },

  set y(value) {

    this._y = value;
    this.onChangeCallback();

  },

  get z() {

    return this._z;

  },

  set z(value) {

    this._z = value;
    this.onChangeCallback();

  },

  get order() {

    return this._order;

  },

  set order(value) {

    this._order = value;
    this.onChangeCallback();

  },

  set: function (x, y, z, order) {

    this._x = x;
    this._y = y;
    this._z = z;
    this._order = order || this._order;

    this.onChangeCallback();

    return this;

  },

  copy: function (euler) {

    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;

    this.onChangeCallback();

    return this;

  },

  setFromRotationMatrix: function (m, order, update) {

    var clamp = THREE.Math.clamp;

    // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

    var te = m.elements;
    var m11 = te[0],m12 = te[4],m13 = te[8];
    var m21 = te[1],m22 = te[5],m23 = te[9];
    var m31 = te[2],m32 = te[6],m33 = te[10];

    order = order || this._order;

    if (order === 'XYZ') {

      this._y = Math.asin(clamp(m13, -1, 1));

      if (Math.abs(m13) < 0.99999) {

        this._x = Math.atan2(-m23, m33);
        this._z = Math.atan2(-m12, m11);

      } else {

        this._x = Math.atan2(m32, m22);
        this._z = 0;

      }

    } else if (order === 'YXZ') {

      this._x = Math.asin(-clamp(m23, -1, 1));

      if (Math.abs(m23) < 0.99999) {

        this._y = Math.atan2(m13, m33);
        this._z = Math.atan2(m21, m22);

      } else {

        this._y = Math.atan2(-m31, m11);
        this._z = 0;

      }

    } else if (order === 'ZXY') {

      this._x = Math.asin(clamp(m32, -1, 1));

      if (Math.abs(m32) < 0.99999) {

        this._y = Math.atan2(-m31, m33);
        this._z = Math.atan2(-m12, m22);

      } else {

        this._y = 0;
        this._z = Math.atan2(m21, m11);

      }

    } else if (order === 'ZYX') {

      this._y = Math.asin(-clamp(m31, -1, 1));

      if (Math.abs(m31) < 0.99999) {

        this._x = Math.atan2(m32, m33);
        this._z = Math.atan2(m21, m11);

      } else {

        this._x = 0;
        this._z = Math.atan2(-m12, m22);

      }

    } else if (order === 'YZX') {

      this._z = Math.asin(clamp(m21, -1, 1));

      if (Math.abs(m21) < 0.99999) {

        this._x = Math.atan2(-m23, m22);
        this._y = Math.atan2(-m31, m11);

      } else {

        this._x = 0;
        this._y = Math.atan2(m13, m33);

      }

    } else if (order === 'XZY') {

      this._z = Math.asin(-clamp(m12, -1, 1));

      if (Math.abs(m12) < 0.99999) {

        this._x = Math.atan2(m32, m22);
        this._y = Math.atan2(m13, m11);

      } else {

        this._x = Math.atan2(-m23, m33);
        this._y = 0;

      }

    } else {

      THREE.warn('THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order);

    }

    this._order = order;

    if (update !== false) this.onChangeCallback();

    return this;

  },

  setFromQuaternion: function () {

    var matrix;

    return function (q, order, update) {

      if (matrix === undefined) matrix = new THREE.Matrix4();
      matrix.makeRotationFromQuaternion(q);
      this.setFromRotationMatrix(matrix, order, update);

      return this;

    };

  }(),

  setFromVector3: function (v, order) {

    return this.set(v.x, v.y, v.z, order || this._order);

  },

  reorder: function () {

    // WARNING: this discards revolution information -bhouston

    var q = new THREE.Quaternion();

    return function (newOrder) {

      q.setFromEuler(this);
      this.setFromQuaternion(q, newOrder);

    };

  }(),

  equals: function (euler) {

    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;

  },

  fromArray: function (array) {

    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== undefined) this._order = array[3];

    this.onChangeCallback();

    return this;

  },

  toArray: function (array, offset) {

    if (array === undefined) array = [];
    if (offset === undefined) offset = 0;

    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._order;

    return array;
  },

  toVector3: function (optionalResult) {

    if (optionalResult) {

      return optionalResult.set(this._x, this._y, this._z);

    } else {

      return new THREE.Vector3(this._x, this._y, this._z);

    }

  },

  onChange: function (callback) {

    this.onChangeCallback = callback;

    return this;

  },

  onChangeCallback: function () {},

  clone: function () {

    return new THREE.Euler(this._x, this._y, this._z, this._order);

  }

};

// File:src/math/Line3.js

/**
 * @author bhouston / http://exocortex.com
 */

THREE.Line3 = function (start, end) {

  this.start = start !== undefined ? start : new THREE.Vector3();
  this.end = end !== undefined ? end : new THREE.Vector3();

};

THREE.Line3.prototype = {

  constructor: THREE.Line3,

  set: function (start, end) {

    this.start.copy(start);
    this.end.copy(end);

    return this;

  },

  copy: function (line) {

    this.start.copy(line.start);
    this.end.copy(line.end);

    return this;

  },

  center: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.addVectors(this.start, this.end).multiplyScalar(0.5);

  },

  delta: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.subVectors(this.end, this.start);

  },

  distanceSq: function () {

    return this.start.distanceToSquared(this.end);

  },

  distance: function () {

    return this.start.distanceTo(this.end);

  },

  at: function (t, optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();

    return this.delta(result).multiplyScalar(t).add(this.start);

  },

  closestPointToPointParameter: function () {

    var startP = new THREE.Vector3();
    var startEnd = new THREE.Vector3();

    return function (point, clampToLine) {

      startP.subVectors(point, this.start);
      startEnd.subVectors(this.end, this.start);

      var startEnd2 = startEnd.dot(startEnd);
      var startEnd_startP = startEnd.dot(startP);

      var t = startEnd_startP / startEnd2;

      if (clampToLine) {

        t = THREE.Math.clamp(t, 0, 1);

      }

      return t;

    };

  }(),

  closestPointToPoint: function (point, clampToLine, optionalTarget) {

    var t = this.closestPointToPointParameter(point, clampToLine);

    var result = optionalTarget || new THREE.Vector3();

    return this.delta(result).multiplyScalar(t).add(this.start);

  },

  applyMatrix4: function (matrix) {

    this.start.applyMatrix4(matrix);
    this.end.applyMatrix4(matrix);

    return this;

  },

  equals: function (line) {

    return line.start.equals(this.start) && line.end.equals(this.end);

  },

  clone: function () {

    return new THREE.Line3().copy(this);

  }

};

// File:src/math/Box2.js

/**
 * @author bhouston / http://exocortex.com
 */

THREE.Box2 = function (min, max) {

  this.min = min !== undefined ? min : new THREE.Vector2(Infinity, Infinity);
  this.max = max !== undefined ? max : new THREE.Vector2(-Infinity, -Infinity);

};

THREE.Box2.prototype = {

  constructor: THREE.Box2,

  set: function (min, max) {

    this.min.copy(min);
    this.max.copy(max);

    return this;

  },

  setFromPoints: function (points) {

    this.makeEmpty();

    for (var i = 0, il = points.length; i < il; i++) {

      this.expandByPoint(points[i]);

    }

    return this;

  },

  setFromCenterAndSize: function () {

    var v1 = new THREE.Vector2();

    return function (center, size) {

      var halfSize = v1.copy(size).multiplyScalar(0.5);
      this.min.copy(center).sub(halfSize);
      this.max.copy(center).add(halfSize);

      return this;

    };

  }(),

  copy: function (box) {

    this.min.copy(box.min);
    this.max.copy(box.max);

    return this;

  },

  makeEmpty: function () {

    this.min.x = this.min.y = Infinity;
    this.max.x = this.max.y = -Infinity;

    return this;

  },

  empty: function () {

    // https://github.com/mrdoob/three.js/blob/dev/src/math/Box2.js

    console.warn('Box2.empty has been deprecated. Use Box2.isEmpty instead');

    return this.isEmpty();

  },

  isEmpty: function () {

    // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

    return this.max.x < this.min.x || this.max.y < this.min.y;

  },

  center: function (optionalTarget) {
    console.warn("Box2.center() is deprecated. Use Box2.getCenter() instead.");
    return this.getCenter(optionalTarget);
  },

  getCenter: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector2();
    return result.addVectors(this.min, this.max).multiplyScalar(0.5);

  },

  size: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector2();
    return result.subVectors(this.max, this.min);

  },

  getSize: function (target) {

    return this.isEmpty() ? target.set(0, 0) : this.size(target);

  },

  expandByPoint: function (point) {

    this.min.min(point);
    this.max.max(point);

    return this;
  },

  expandByVector: function (vector) {

    this.min.sub(vector);
    this.max.add(vector);

    return this;
  },

  expandByScalar: function (scalar) {

    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);

    return this;
  },

  containsPoint: function (point) {

    if (point.x < this.min.x || point.x > this.max.x ||
    point.y < this.min.y || point.y > this.max.y) {

      return false;

    }

    return true;

  },

  containsBox: function (box) {

    if (this.min.x <= box.min.x && box.max.x <= this.max.x &&
    this.min.y <= box.min.y && box.max.y <= this.max.y) {

      return true;

    }

    return false;

  },

  getParameter: function (point, optionalTarget) {

    // This can potentially have a divide by zero if the box
    // has a size dimension of 0.

    var result = optionalTarget || new THREE.Vector2();

    return result.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y)
    );

  },

  isIntersectionBox: function (box) {

    // using 6 splitting planes to rule out intersections.

    if (box.max.x < this.min.x || box.min.x > this.max.x ||
    box.max.y < this.min.y || box.min.y > this.max.y) {

      return false;

    }

    return true;

  },

  intersectsBox: function (target) {

    return this.isIntersectionBox(target);

  },

  clampPoint: function (point, optionalTarget) {

    var result = optionalTarget || new THREE.Vector2();
    return result.copy(point).clamp(this.min, this.max);

  },

  distanceToPoint: function () {

    var v1 = new THREE.Vector2();

    return function (point) {

      var clampedPoint = v1.copy(point).clamp(this.min, this.max);
      return clampedPoint.sub(point).length();

    };

  }(),

  intersect: function (box) {

    this.min.max(box.min);
    this.max.min(box.max);

    return this;

  },

  union: function (box) {

    this.min.min(box.min);
    this.max.max(box.max);

    return this;

  },

  translate: function (offset) {

    this.min.add(offset);
    this.max.add(offset);

    return this;

  },

  equals: function (box) {

    return box.min.equals(this.min) && box.max.equals(this.max);

  },

  clone: function () {

    return new THREE.Box2().copy(this);

  }

};

// File:src/math/Box3.js

/**
 * @author bhouston / http://exocortex.com
 * @author WestLangley / http://github.com/WestLangley
 */

THREE.Box3 = function (min, max) {

  this.min = min !== undefined ? min : new THREE.Vector3(Infinity, Infinity, Infinity);
  this.max = max !== undefined ? max : new THREE.Vector3(-Infinity, -Infinity, -Infinity);

};

THREE.Box3.prototype = {

  constructor: THREE.Box3,

  set: function (min, max) {

    this.min.copy(min);
    this.max.copy(max);

    return this;

  },

  setFromPoints: function (points) {

    this.makeEmpty();

    for (var i = 0, il = points.length; i < il; i++) {

      this.expandByPoint(points[i]);

    }

    return this;

  },

  setFromCenterAndSize: function () {

    var v1 = new THREE.Vector3();

    return function (center, size) {

      var halfSize = v1.copy(size).multiplyScalar(0.5);

      this.min.copy(center).sub(halfSize);
      this.max.copy(center).add(halfSize);

      return this;

    };

  }(),

  setFromObject: function () {

    // Computes the world-axis-aligned bounding box of an object (including its children),
    // accounting for both the object's, and childrens', world transforms

    var v1 = new THREE.Vector3();

    return function (object) {

      var scope = this;

      object.updateMatrixWorld(true);

      this.makeEmpty();

      object.traverse(function (node) {

        var geometry = node.geometry;

        if (geometry !== undefined) {

          if (geometry instanceof THREE.BufferGeometry && geometry.attributes['position'] !== undefined) {

            var positions = geometry.attributes['position'].array;

            for (var i = 0, il = positions.length; i < il; i += 3) {

              v1.set(positions[i], positions[i + 1], positions[i + 2]);

              v1.applyMatrix4(node.matrixWorld);

              scope.expandByPoint(v1);

            }

          }

        }

      });

      return this;

    };

  }(),

  copy: function (box) {

    this.min.copy(box.min);
    this.max.copy(box.max);

    return this;

  },

  makeEmpty: function () {

    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;

    return this;

  },

  empty: function () {

    // https://github.com/mrdoob/three.js/blob/dev/src/math/Box3.js

    console.warn('Box3.empty has been deprecated. Use Box3.isEmpty instead');

    return this.isEmpty();

  },

  isEmpty: function () {

    // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;

  },

  center: function (optionalTarget) {
    console.warn("Box3.center() is deprecated. Use Box3.getCenter() instead.");
    return this.getCenter(optionalTarget);
  },

  getCenter: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.addVectors(this.min, this.max).multiplyScalar(0.5);

  },

  size: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.subVectors(this.max, this.min);

  },

  getSize: function (target) {

    return this.isEmpty() ? target.set(0, 0, 0) : this.size(target);

  },

  expandByPoint: function (point) {

    this.min.min(point);
    this.max.max(point);

    return this;

  },

  expandByVector: function (vector) {

    this.min.sub(vector);
    this.max.add(vector);

    return this;

  },

  expandByScalar: function (scalar) {

    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);

    return this;

  },

  containsPoint: function (point) {

    if (point.x < this.min.x || point.x > this.max.x ||
    point.y < this.min.y || point.y > this.max.y ||
    point.z < this.min.z || point.z > this.max.z) {

      return false;

    }

    return true;

  },

  containsBox: function (box) {

    if (this.min.x <= box.min.x && box.max.x <= this.max.x &&
    this.min.y <= box.min.y && box.max.y <= this.max.y &&
    this.min.z <= box.min.z && box.max.z <= this.max.z) {

      return true;

    }

    return false;

  },

  getParameter: function (point, optionalTarget) {

    // This can potentially have a divide by zero if the box
    // has a size dimension of 0.

    var result = optionalTarget || new THREE.Vector3();

    return result.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y),
      (point.z - this.min.z) / (this.max.z - this.min.z)
    );

  },

  isIntersectionBox: function (box) {

    // using 6 splitting planes to rule out intersections.

    if (box.max.x < this.min.x || box.min.x > this.max.x ||
    box.max.y < this.min.y || box.min.y > this.max.y ||
    box.max.z < this.min.z || box.min.z > this.max.z) {

      return false;

    }

    return true;

  },

  intersectsBox: function (target) {

    return this.isIntersectionBox(target);

  },

  clampPoint: function (point, optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.copy(point).clamp(this.min, this.max);

  },

  distanceToPoint: function () {

    var v1 = new THREE.Vector3();

    return function (point) {

      var clampedPoint = v1.copy(point).clamp(this.min, this.max);
      return clampedPoint.sub(point).length();

    };

  }(),

  getBoundingSphere: function () {

    var v1 = new THREE.Vector3();

    return function (optionalTarget) {

      var result = optionalTarget || new THREE.Sphere();

      result.center = this.getCenter();
      result.radius = this.size(v1).length() * 0.5;

      return result;

    };

  }(),

  intersect: function (box) {

    this.min.max(box.min);
    this.max.min(box.max);

    return this;

  },

  union: function (box) {

    this.min.min(box.min);
    this.max.max(box.max);

    return this;

  },

  applyMatrix4: function () {

    var min3 = new THREE.Vector3();
    var max3 = new THREE.Vector3();

    return function (matrix) {

      if (this.isEmpty()) {
        return this;
      }

      // use Jim Arvo's AABB transform algorithm
      // https://github.com/erich666/GraphicsGems/blob/7ef8b6990e125fa908dfaeb80bc42f4b4fae65b8/gems/TransBox.c
      // More digestible version here: https://stackoverflow.com/questions/6053522/how-to-recalculate-axis-aligned-bounding-box-after-translate-rotate/58630206#58630206
      var e = matrix.elements;
      for (var i = 0; i < 3; i++) {
        let min = e[12 + i];
        let max = min;
        for (var j = 0; j < 3; j++) {
          var a = e[i + j * 4] * this.min.getComponent(j);
          var b = e[i + j * 4] * this.max.getComponent(j);
          min += Math.min(a, b);
          max += Math.max(a, b);
        }
        min3.setComponent(i, min);
        max3.setComponent(i, max);
      }
      this.min.copy(min3);
      this.max.copy(max3);

      return this;

    };

  }(),

  translate: function (offset) {

    this.min.add(offset);
    this.max.add(offset);

    return this;

  },

  equals: function (box) {

    return box.min.equals(this.min) && box.max.equals(this.max);

  },

  clone: function () {

    return new THREE.Box3().copy(this);

  }

};

// File:src/math/Matrix3.js

/**
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://exocortex.com
 */

THREE.Matrix3 = function () {

  this.elements = new Float32Array([

  1, 0, 0,
  0, 1, 0,
  0, 0, 1]

  );

  if (arguments.length > 0) {

    THREE.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');

  }

};

THREE.Matrix3.prototype = {

  constructor: THREE.Matrix3,

  set: function (n11, n12, n13, n21, n22, n23, n31, n32, n33) {

    var te = this.elements;

    te[0] = n11;te[3] = n12;te[6] = n13;
    te[1] = n21;te[4] = n22;te[7] = n23;
    te[2] = n31;te[5] = n32;te[8] = n33;

    return this;

  },

  identity: function () {

    this.set(

      1, 0, 0,
      0, 1, 0,
      0, 0, 1

    );

    return this;

  },

  copy: function (m) {

    var me = m.elements;

    this.set(

      me[0], me[3], me[6],
      me[1], me[4], me[7],
      me[2], me[5], me[8]

    );

    return this;

  },

  multiplyVector3: function (vector) {

    THREE.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
    return vector.applyMatrix3(this);

  },

  multiplyVector3Array: function (a) {

    THREE.warn('THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.');
    return this.applyToVector3Array(a);

  },

  applyToVector3Array: function () {

    var v1 = new THREE.Vector3();

    return function (array, offset, length) {

      if (offset === undefined) offset = 0;
      if (length === undefined) length = array.length;

      for (var i = 0, j = offset; i < length; i += 3, j += 3) {

        v1.x = array[j];
        v1.y = array[j + 1];
        v1.z = array[j + 2];

        v1.applyMatrix3(this);

        array[j] = v1.x;
        array[j + 1] = v1.y;
        array[j + 2] = v1.z;

      }

      return array;

    };

  }(),

  multiplyScalar: function (s) {

    var te = this.elements;

    te[0] *= s;te[3] *= s;te[6] *= s;
    te[1] *= s;te[4] *= s;te[7] *= s;
    te[2] *= s;te[5] *= s;te[8] *= s;

    return this;

  },

  determinant: function () {

    var te = this.elements;

    var a = te[0],b = te[1],c = te[2],
      d = te[3],e = te[4],f = te[5],
      g = te[6],h = te[7],i = te[8];

    return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

  },

  getInverse: function (matrix, throwOnInvertible) {

    // input: THREE.Matrix4
    // ( based on http://code.google.com/p/webgl-mjs/ )

    var me = matrix.elements;
    var te = this.elements;

    te[0] = me[10] * me[5] - me[6] * me[9];
    te[1] = -me[10] * me[1] + me[2] * me[9];
    te[2] = me[6] * me[1] - me[2] * me[5];
    te[3] = -me[10] * me[4] + me[6] * me[8];
    te[4] = me[10] * me[0] - me[2] * me[8];
    te[5] = -me[6] * me[0] + me[2] * me[4];
    te[6] = me[9] * me[4] - me[5] * me[8];
    te[7] = -me[9] * me[0] + me[1] * me[8];
    te[8] = me[5] * me[0] - me[1] * me[4];

    var det = me[0] * te[0] + me[1] * te[3] + me[2] * te[6];

    // no inverse

    if (det === 0) {

      var msg = "Matrix3.getInverse(): can't invert matrix, determinant is 0";

      if (throwOnInvertible || false) {

        throw new Error(msg);

      } else {

        THREE.warn(msg);

      }

      this.identity();

      return this;

    }

    this.multiplyScalar(1.0 / det);

    return this;

  },

  // Backport from r123: https://github.com/mrdoob/three.js/pull/20611/commits/d52afdd2ceafd690ac9e20917d0c968ff2fa7661
  invert: function () {

    const te = this.elements,

      n11 = te[0],n21 = te[1],n31 = te[2],
      n12 = te[3],n22 = te[4],n32 = te[5],
      n13 = te[6],n23 = te[7],n33 = te[8],

      t11 = n33 * n22 - n32 * n23,
      t12 = n32 * n13 - n33 * n12,
      t13 = n23 * n12 - n22 * n13,

      det = n11 * t11 + n21 * t12 + n31 * t13;

    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);

    const detInv = 1 / det;

    te[0] = t11 * detInv;
    te[1] = (n31 * n23 - n33 * n21) * detInv;
    te[2] = (n32 * n21 - n31 * n22) * detInv;

    te[3] = t12 * detInv;
    te[4] = (n33 * n11 - n31 * n13) * detInv;
    te[5] = (n31 * n12 - n32 * n11) * detInv;

    te[6] = t13 * detInv;
    te[7] = (n21 * n13 - n23 * n11) * detInv;
    te[8] = (n22 * n11 - n21 * n12) * detInv;

    return this;

  },

  transpose: function () {

    var tmp,m = this.elements;

    tmp = m[1];m[1] = m[3];m[3] = tmp;
    tmp = m[2];m[2] = m[6];m[6] = tmp;
    tmp = m[5];m[5] = m[7];m[7] = tmp;

    return this;

  },

  flattenToArrayOffset: function (array, offset) {

    var te = this.elements;

    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];

    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];

    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];

    return array;

  },

  getNormalMatrix: function (m) {

    // input: THREE.Matrix4

    this.getInverse(m).transpose();

    return this;

  },

  transposeIntoArray: function (r) {

    var m = this.elements;

    r[0] = m[0];
    r[1] = m[3];
    r[2] = m[6];
    r[3] = m[1];
    r[4] = m[4];
    r[5] = m[7];
    r[6] = m[2];
    r[7] = m[5];
    r[8] = m[8];

    return this;

  },

  fromArray: function (array) {

    this.elements.set(array);

    return this;

  },

  toArray: function () {

    var te = this.elements;

    return [
    te[0], te[1], te[2],
    te[3], te[4], te[5],
    te[6], te[7], te[8]];


  },

  clone: function () {

    return new THREE.Matrix3().fromArray(this.elements);

  }

};

// File:src/math/Matrix4.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author jordi_ros / http://plattsoft.com
 * @author D1plo1d / http://github.com/D1plo1d
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author timknip / http://www.floorplanner.com/
 * @author bhouston / http://exocortex.com
 * @author WestLangley / http://github.com/WestLangley
 */

THREE.Matrix4 = function () {

  this.elements = new Float32Array([

  1, 0, 0, 0,
  0, 1, 0, 0,
  0, 0, 1, 0,
  0, 0, 0, 1]

  );

  if (arguments.length > 0) {

    THREE.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');

  }

};

THREE.Matrix4.prototype = {

  constructor: THREE.Matrix4,

  set: function (n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {

    var te = this.elements;

    te[0] = n11;te[4] = n12;te[8] = n13;te[12] = n14;
    te[1] = n21;te[5] = n22;te[9] = n23;te[13] = n24;
    te[2] = n31;te[6] = n32;te[10] = n33;te[14] = n34;
    te[3] = n41;te[7] = n42;te[11] = n43;te[15] = n44;

    return this;

  },

  identity: function () {

    this.set(

      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1

    );

    return this;

  },

  copy: function (m) {

    this.elements.set(m.elements);

    return this;

  },

  extractPosition: function (m) {

    THREE.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
    return this.copyPosition(m);

  },

  copyPosition: function (m) {

    var te = this.elements;
    var me = m.elements;

    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];

    return this;

  },

  extractBasis: function (xAxis, yAxis, zAxis) {

    var te = this.elements;

    xAxis.set(te[0], te[1], te[2]);
    yAxis.set(te[4], te[5], te[6]);
    zAxis.set(te[8], te[9], te[10]);

    return this;

  },

  makeBasis: function (xAxis, yAxis, zAxis) {

    this.set(
      xAxis.x, yAxis.x, zAxis.x, 0,
      xAxis.y, yAxis.y, zAxis.y, 0,
      xAxis.z, yAxis.z, zAxis.z, 0,
      0, 0, 0, 1
    );

    return this;

  },

  extractRotation: function () {

    var v1 = new THREE.Vector3();

    return function (m) {

      var te = this.elements;
      var me = m.elements;

      var scaleX = 1 / v1.set(me[0], me[1], me[2]).length();
      var scaleY = 1 / v1.set(me[4], me[5], me[6]).length();
      var scaleZ = 1 / v1.set(me[8], me[9], me[10]).length();

      te[0] = me[0] * scaleX;
      te[1] = me[1] * scaleX;
      te[2] = me[2] * scaleX;

      te[4] = me[4] * scaleY;
      te[5] = me[5] * scaleY;
      te[6] = me[6] * scaleY;

      te[8] = me[8] * scaleZ;
      te[9] = me[9] * scaleZ;
      te[10] = me[10] * scaleZ;

      return this;

    };

  }(),

  makeRotationFromEuler: function (euler) {

    if (euler instanceof THREE.Euler === false) {

      THREE.error('THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');

    }

    var te = this.elements;

    var x = euler.x,y = euler.y,z = euler.z;
    var a = Math.cos(x),b = Math.sin(x);
    var c = Math.cos(y),d = Math.sin(y);
    var e = Math.cos(z),f = Math.sin(z);

    if (euler.order === 'XYZ') {

      var ae = a * e,af = a * f,be = b * e,bf = b * f;

      te[0] = c * e;
      te[4] = -c * f;
      te[8] = d;

      te[1] = af + be * d;
      te[5] = ae - bf * d;
      te[9] = -b * c;

      te[2] = bf - ae * d;
      te[6] = be + af * d;
      te[10] = a * c;

    } else if (euler.order === 'YXZ') {

      var ce = c * e,cf = c * f,de = d * e,df = d * f;

      te[0] = ce + df * b;
      te[4] = de * b - cf;
      te[8] = a * d;

      te[1] = a * f;
      te[5] = a * e;
      te[9] = -b;

      te[2] = cf * b - de;
      te[6] = df + ce * b;
      te[10] = a * c;

    } else if (euler.order === 'ZXY') {

      var ce = c * e,cf = c * f,de = d * e,df = d * f;

      te[0] = ce - df * b;
      te[4] = -a * f;
      te[8] = de + cf * b;

      te[1] = cf + de * b;
      te[5] = a * e;
      te[9] = df - ce * b;

      te[2] = -a * d;
      te[6] = b;
      te[10] = a * c;

    } else if (euler.order === 'ZYX') {

      var ae = a * e,af = a * f,be = b * e,bf = b * f;

      te[0] = c * e;
      te[4] = be * d - af;
      te[8] = ae * d + bf;

      te[1] = c * f;
      te[5] = bf * d + ae;
      te[9] = af * d - be;

      te[2] = -d;
      te[6] = b * c;
      te[10] = a * c;

    } else if (euler.order === 'YZX') {

      var ac = a * c,ad = a * d,bc = b * c,bd = b * d;

      te[0] = c * e;
      te[4] = bd - ac * f;
      te[8] = bc * f + ad;

      te[1] = f;
      te[5] = a * e;
      te[9] = -b * e;

      te[2] = -d * e;
      te[6] = ad * f + bc;
      te[10] = ac - bd * f;

    } else if (euler.order === 'XZY') {

      var ac = a * c,ad = a * d,bc = b * c,bd = b * d;

      te[0] = c * e;
      te[4] = -f;
      te[8] = d * e;

      te[1] = ac * f + bd;
      te[5] = a * e;
      te[9] = ad * f - bc;

      te[2] = bc * f - ad;
      te[6] = b * e;
      te[10] = bd * f + ac;

    }

    // last column
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;

    // bottom row
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;

    return this;

  },

  setRotationFromQuaternion: function (q) {

    THREE.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');

    return this.makeRotationFromQuaternion(q);

  },

  makeRotationFromQuaternion: function (q) {

    var te = this.elements;

    var x = q.x,y = q.y,z = q.z,w = q.w;
    var x2 = x + x,y2 = y + y,z2 = z + z;
    var xx = x * x2,xy = x * y2,xz = x * z2;
    var yy = y * y2,yz = y * z2,zz = z * z2;
    var wx = w * x2,wy = w * y2,wz = w * z2;

    te[0] = 1 - (yy + zz);
    te[4] = xy - wz;
    te[8] = xz + wy;

    te[1] = xy + wz;
    te[5] = 1 - (xx + zz);
    te[9] = yz - wx;

    te[2] = xz - wy;
    te[6] = yz + wx;
    te[10] = 1 - (xx + yy);

    // last column
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;

    // bottom row
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;

    return this;

  },

  lookAt: function () {

    var x = new THREE.Vector3();
    var y = new THREE.Vector3();
    var z = new THREE.Vector3();

    return function (eye, target, up) {

      var te = this.elements;

      z.subVectors(eye, target).normalize();

      if (z.length() === 0) {

        z.z = 1;

      }

      x.crossVectors(up, z).normalize();

      if (x.length() === 0) {

        z.x += 0.0001;
        x.crossVectors(up, z).normalize();

      }

      y.crossVectors(z, x);


      te[0] = x.x;te[4] = y.x;te[8] = z.x;
      te[1] = x.y;te[5] = y.y;te[9] = z.y;
      te[2] = x.z;te[6] = y.z;te[10] = z.z;

      return this;

    };

  }(),

  multiply: function (m, n) {

    if (n !== undefined) {

      THREE.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
      return this.multiplyMatrices(m, n);

    }

    return this.multiplyMatrices(this, m);

  },

  multiplyMatrices: function (a, b) {

    var ae = a.elements;
    var be = b.elements;
    var te = this.elements;

    var a11 = ae[0],a12 = ae[4],a13 = ae[8],a14 = ae[12];
    var a21 = ae[1],a22 = ae[5],a23 = ae[9],a24 = ae[13];
    var a31 = ae[2],a32 = ae[6],a33 = ae[10],a34 = ae[14];
    var a41 = ae[3],a42 = ae[7],a43 = ae[11],a44 = ae[15];

    var b11 = be[0],b12 = be[4],b13 = be[8],b14 = be[12];
    var b21 = be[1],b22 = be[5],b23 = be[9],b24 = be[13];
    var b31 = be[2],b32 = be[6],b33 = be[10],b34 = be[14];
    var b41 = be[3],b42 = be[7],b43 = be[11],b44 = be[15];

    te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

    te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

    te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

    te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

    return this;

  },

  multiplyToArray: function (a, b, r) {

    var te = this.elements;

    this.multiplyMatrices(a, b);

    r[0] = te[0];r[1] = te[1];r[2] = te[2];r[3] = te[3];
    r[4] = te[4];r[5] = te[5];r[6] = te[6];r[7] = te[7];
    r[8] = te[8];r[9] = te[9];r[10] = te[10];r[11] = te[11];
    r[12] = te[12];r[13] = te[13];r[14] = te[14];r[15] = te[15];

    return this;

  },

  multiplyScalar: function (s) {

    var te = this.elements;

    te[0] *= s;te[4] *= s;te[8] *= s;te[12] *= s;
    te[1] *= s;te[5] *= s;te[9] *= s;te[13] *= s;
    te[2] *= s;te[6] *= s;te[10] *= s;te[14] *= s;
    te[3] *= s;te[7] *= s;te[11] *= s;te[15] *= s;

    return this;

  },

  multiplyVector3: function (vector) {

    THREE.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) or vector.applyProjection( matrix ) instead.');
    return vector.applyProjection(this);

  },

  multiplyVector4: function (vector) {

    THREE.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);

  },

  multiplyVector3Array: function (a) {

    THREE.warn('THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.');
    return this.applyToVector3Array(a);

  },

  applyToVector3Array: function () {

    var v1 = new THREE.Vector3();

    return function (array, offset, length) {

      if (offset === undefined) offset = 0;
      if (length === undefined) length = array.length;

      for (var i = 0, j = offset; i < length; i += 3, j += 3) {

        v1.x = array[j];
        v1.y = array[j + 1];
        v1.z = array[j + 2];

        v1.applyMatrix4(this);

        array[j] = v1.x;
        array[j + 1] = v1.y;
        array[j + 2] = v1.z;

      }

      return array;

    };

  }(),

  rotateAxis: function (v) {

    THREE.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');

    v.transformDirection(this);

  },

  crossVector: function (vector) {

    THREE.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);

  },

  determinant: function () {

    var te = this.elements;

    var n11 = te[0],n12 = te[4],n13 = te[8],n14 = te[12];
    var n21 = te[1],n22 = te[5],n23 = te[9],n24 = te[13];
    var n31 = te[2],n32 = te[6],n33 = te[10],n34 = te[14];
    var n41 = te[3],n42 = te[7],n43 = te[11],n44 = te[15];

    //TODO: make this more efficient
    //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

    return (
      n41 * (
      +n14 * n23 * n32 -
      n13 * n24 * n32 -
      n14 * n22 * n33 +
      n12 * n24 * n33 +
      n13 * n22 * n34 -
      n12 * n23 * n34) +

      n42 * (
      +n11 * n23 * n34 -
      n11 * n24 * n33 +
      n14 * n21 * n33 -
      n13 * n21 * n34 +
      n13 * n24 * n31 -
      n14 * n23 * n31) +

      n43 * (
      +n11 * n24 * n32 -
      n11 * n22 * n34 -
      n14 * n21 * n32 +
      n12 * n21 * n34 +
      n14 * n22 * n31 -
      n12 * n24 * n31) +

      n44 * (
      -n13 * n22 * n31 -
      n11 * n23 * n32 +
      n11 * n22 * n33 +
      n13 * n21 * n32 -
      n12 * n21 * n33 +
      n12 * n23 * n31));




  },

  transpose: function () {

    var te = this.elements;
    var tmp;

    tmp = te[1];te[1] = te[4];te[4] = tmp;
    tmp = te[2];te[2] = te[8];te[8] = tmp;
    tmp = te[6];te[6] = te[9];te[9] = tmp;

    tmp = te[3];te[3] = te[12];te[12] = tmp;
    tmp = te[7];te[7] = te[13];te[13] = tmp;
    tmp = te[11];te[11] = te[14];te[14] = tmp;

    return this;

  },

  flattenToArrayOffset: function (array, offset) {

    var te = this.elements;

    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];

    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];

    array[offset + 8] = te[8];
    array[offset + 9] = te[9];
    array[offset + 10] = te[10];
    array[offset + 11] = te[11];

    array[offset + 12] = te[12];
    array[offset + 13] = te[13];
    array[offset + 14] = te[14];
    array[offset + 15] = te[15];

    return array;

  },

  getPosition: function () {

    var v1 = new THREE.Vector3();

    return function () {

      THREE.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');

      var te = this.elements;
      return v1.set(te[12], te[13], te[14]);

    };

  }(),

  setPosition: function (v) {

    var te = this.elements;

    te[12] = v.x;
    te[13] = v.y;
    te[14] = v.z;

    return this;

  },

  getInverse: function (m, throwOnInvertible) {

    // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
    var te = this.elements;
    var me = m.elements;

    var n11 = me[0],n12 = me[4],n13 = me[8],n14 = me[12];
    var n21 = me[1],n22 = me[5],n23 = me[9],n24 = me[13];
    var n31 = me[2],n32 = me[6],n33 = me[10],n34 = me[14];
    var n41 = me[3],n42 = me[7],n43 = me[11],n44 = me[15];

    te[0] = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44;
    te[4] = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44;
    te[8] = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44;
    te[12] = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    te[1] = n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44;
    te[5] = n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44;
    te[9] = n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44;
    te[13] = n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34;
    te[2] = n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44;
    te[6] = n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44;
    te[10] = n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44;
    te[14] = n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34;
    te[3] = n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43;
    te[7] = n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43;
    te[11] = n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43;
    te[15] = n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33;

    var det = n11 * te[0] + n21 * te[4] + n31 * te[8] + n41 * te[12];

    if (det == 0) {

      var msg = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";

      if (throwOnInvertible || false) {

        throw new Error(msg);

      } else {

        THREE.warn(msg);

      }

      this.identity();

      return this;
    }

    this.multiplyScalar(1 / det);

    return this;

  },

  // Backport from r123: https://github.com/mrdoob/three.js/pull/20611/commits/d52afdd2ceafd690ac9e20917d0c968ff2fa7661
  invert: function () {

    return this.getInverse(this, false);

  },

  translate: function (v) {

    THREE.error('THREE.Matrix4: .translate() has been removed.');

  },

  rotateX: function (angle) {

    THREE.error('THREE.Matrix4: .rotateX() has been removed.');

  },

  rotateY: function (angle) {

    THREE.error('THREE.Matrix4: .rotateY() has been removed.');

  },

  rotateZ: function (angle) {

    THREE.error('THREE.Matrix4: .rotateZ() has been removed.');

  },

  rotateByAxis: function (axis, angle) {

    THREE.error('THREE.Matrix4: .rotateByAxis() has been removed.');

  },

  scale: function (v) {

    var te = this.elements;
    var x = v.x,y = v.y,z = v.z;

    te[0] *= x;te[4] *= y;te[8] *= z;
    te[1] *= x;te[5] *= y;te[9] *= z;
    te[2] *= x;te[6] *= y;te[10] *= z;
    te[3] *= x;te[7] *= y;te[11] *= z;

    return this;

  },

  getMaxScaleOnAxis: function () {

    var te = this.elements;

    var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
    var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
    var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];

    return Math.sqrt(Math.max(scaleXSq, Math.max(scaleYSq, scaleZSq)));

  },

  makeTranslation: function (x, y, z) {

    this.set(

      1, 0, 0, x,
      0, 1, 0, y,
      0, 0, 1, z,
      0, 0, 0, 1

    );

    return this;

  },

  makeRotationX: function (theta) {

    var c = Math.cos(theta),s = Math.sin(theta);

    this.set(

      1, 0, 0, 0,
      0, c, -s, 0,
      0, s, c, 0,
      0, 0, 0, 1

    );

    return this;

  },

  makeRotationY: function (theta) {

    var c = Math.cos(theta),s = Math.sin(theta);

    this.set(

      c, 0, s, 0,
      0, 1, 0, 0,
      -s, 0, c, 0,
      0, 0, 0, 1

    );

    return this;

  },

  makeRotationZ: function (theta) {

    var c = Math.cos(theta),s = Math.sin(theta);

    this.set(

      c, -s, 0, 0,
      s, c, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1

    );

    return this;

  },

  makeRotationAxis: function (axis, angle) {

    // Based on http://www.gamedev.net/reference/articles/article1199.asp

    var c = Math.cos(angle);
    var s = Math.sin(angle);
    var t = 1 - c;
    var x = axis.x,y = axis.y,z = axis.z;
    var tx = t * x,ty = t * y;

    this.set(

      tx * x + c, tx * y - s * z, tx * z + s * y, 0,
      tx * y + s * z, ty * y + c, ty * z - s * x, 0,
      tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
      0, 0, 0, 1

    );

    return this;

  },

  makeScale: function (x, y, z) {

    this.set(

      x, 0, 0, 0,
      0, y, 0, 0,
      0, 0, z, 0,
      0, 0, 0, 1

    );

    return this;

  },

  compose: function (position, quaternion, scale) {

    this.makeRotationFromQuaternion(quaternion);
    this.scale(scale);
    this.setPosition(position);

    return this;

  },

  decompose: function () {

    var vector = new THREE.Vector3();
    var matrix = new THREE.Matrix4();

    return function (position, quaternion, scale) {

      var te = this.elements;

      var sx = vector.set(te[0], te[1], te[2]).length();
      var sy = vector.set(te[4], te[5], te[6]).length();
      var sz = vector.set(te[8], te[9], te[10]).length();

      // if determine is negative, we need to invert one scale
      var det = this.determinant();
      if (det < 0) {
        sx = -sx;
      }

      position.x = te[12];
      position.y = te[13];
      position.z = te[14];

      // scale the rotation part

      matrix.elements.set(this.elements); // at this point matrix is incomplete so we can't use .copy()

      var invSX = 1 / sx;
      var invSY = 1 / sy;
      var invSZ = 1 / sz;

      matrix.elements[0] *= invSX;
      matrix.elements[1] *= invSX;
      matrix.elements[2] *= invSX;

      matrix.elements[4] *= invSY;
      matrix.elements[5] *= invSY;
      matrix.elements[6] *= invSY;

      matrix.elements[8] *= invSZ;
      matrix.elements[9] *= invSZ;
      matrix.elements[10] *= invSZ;

      quaternion.setFromRotationMatrix(matrix);

      scale.x = sx;
      scale.y = sy;
      scale.z = sz;

      return this;

    };

  }(),

  makeFrustum: function (left, right, bottom, top, near, far) {

    var te = this.elements;
    var x = 2 * near / (right - left);
    var y = 2 * near / (top - bottom);

    var a = (right + left) / (right - left);
    var b = (top + bottom) / (top - bottom);
    var c = -(far + near) / (far - near);
    var d = -2 * far * near / (far - near);

    te[0] = x;te[4] = 0;te[8] = a;te[12] = 0;
    te[1] = 0;te[5] = y;te[9] = b;te[13] = 0;
    te[2] = 0;te[6] = 0;te[10] = c;te[14] = d;
    te[3] = 0;te[7] = 0;te[11] = -1;te[15] = 0;

    return this;

  },

  makePerspective: function (fov, aspect, near, far) {

    var ymax = near * Math.tan(THREE.Math.degToRad(fov * 0.5));
    var ymin = -ymax;
    var xmin = ymin * aspect;
    var xmax = ymax * aspect;

    return this.makeFrustum(xmin, xmax, ymin, ymax, near, far);

  },

  makeOrthographic: function (left, right, top, bottom, near, far) {

    var te = this.elements;
    var w = right - left;
    var h = top - bottom;
    var p = far - near;

    var x = (right + left) / w;
    var y = (top + bottom) / h;
    var z = (far + near) / p;

    te[0] = 2 / w;te[4] = 0;te[8] = 0;te[12] = -x;
    te[1] = 0;te[5] = 2 / h;te[9] = 0;te[13] = -y;
    te[2] = 0;te[6] = 0;te[10] = -2 / p;te[14] = -z;
    te[3] = 0;te[7] = 0;te[11] = 0;te[15] = 1;

    return this;

  },

  equals(matrix) {

    const te = this.elements;
    const me = matrix.elements;

    for (var i = 0; i < 16; i++) {

      if (te[i] !== me[i]) return false;

    }

    return true;

  },

  fromArray: function (array) {

    this.elements.set(array);

    return this;

  },

  toArray: function () {

    var te = this.elements;

    return [
    te[0], te[1], te[2], te[3],
    te[4], te[5], te[6], te[7],
    te[8], te[9], te[10], te[11],
    te[12], te[13], te[14], te[15]];


  },

  clone: function () {

    return new THREE.Matrix4().fromArray(this.elements);

  }

};

// File:src/math/Ray.js

/**
 * @author bhouston / http://exocortex.com
 */

THREE.Ray = function (origin, direction) {

  this.origin = origin !== undefined ? origin : new THREE.Vector3();
  this.direction = direction !== undefined ? direction : new THREE.Vector3();

};

THREE.Ray.prototype = {

  constructor: THREE.Ray,

  set: function (origin, direction) {

    this.origin.copy(origin);
    this.direction.copy(direction);

    return this;

  },

  copy: function (ray) {

    this.origin.copy(ray.origin);
    this.direction.copy(ray.direction);

    return this;

  },

  at: function (t, optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();

    return result.copy(this.direction).multiplyScalar(t).add(this.origin);

  },

  recast: function () {

    var v1 = new THREE.Vector3();

    return function (t) {

      this.origin.copy(this.at(t, v1));

      return this;

    };

  }(),

  closestPointToPoint: function (point, optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    result.subVectors(point, this.origin);
    var directionDistance = result.dot(this.direction);

    if (directionDistance < 0) {

      return result.copy(this.origin);

    }

    return result.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);

  },

  distanceToPoint: function () {

    var v1 = new THREE.Vector3();

    return function (point) {

      var directionDistance = v1.subVectors(point, this.origin).dot(this.direction);

      // point behind the ray

      if (directionDistance < 0) {

        return this.origin.distanceTo(point);

      }

      v1.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);

      return v1.distanceTo(point);

    };

  }(),

  distanceSqToSegment: function () {

    var segCenter = new THREE.Vector3();
    var segDir = new THREE.Vector3();
    var diff = new THREE.Vector3();

    return function (v0, v1, optionalPointOnRay, optionalPointOnSegment) {

      // from http://www.geometrictools.com/LibMathematics/Distance/Wm5DistRay3Segment3.cpp
      // It returns the min distance between the ray and the segment
      // defined by v0 and v1
      // It can also set two optional targets :
      // - The closest point on the ray
      // - The closest point on the segment

      segCenter.copy(v0).add(v1).multiplyScalar(0.5);
      segDir.copy(v1).sub(v0).normalize();
      diff.copy(this.origin).sub(segCenter);

      var segExtent = v0.distanceTo(v1) * 0.5;
      var a01 = -this.direction.dot(segDir);
      var b0 = diff.dot(this.direction);
      var b1 = -diff.dot(segDir);
      var c = diff.lengthSq();
      var det = Math.abs(1 - a01 * a01);
      var s0, s1, sqrDist, extDet;

      if (det > 0) {

        // The ray and segment are not parallel.

        s0 = a01 * b1 - b0;
        s1 = a01 * b0 - b1;
        extDet = segExtent * det;

        if (s0 >= 0) {

          if (s1 >= -extDet) {

            if (s1 <= extDet) {

              // region 0
              // Minimum at interior points of ray and segment.

              var invDet = 1 / det;
              s0 *= invDet;
              s1 *= invDet;
              sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;

            } else {

              // region 1

              s1 = segExtent;
              s0 = Math.max(0, -(a01 * s1 + b0));
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;

            }

          } else {

            // region 5

            s1 = -segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;

          }

        } else {

          if (s1 <= -extDet) {

            // region 4

            s0 = Math.max(0, -(-a01 * segExtent + b0));
            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;

          } else if (s1 <= extDet) {

            // region 3

            s0 = 0;
            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = s1 * (s1 + 2 * b1) + c;

          } else {

            // region 2

            s0 = Math.max(0, -(a01 * segExtent + b0));
            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;

          }

        }

      } else {

        // Ray and segment are parallel.

        s1 = a01 > 0 ? -segExtent : segExtent;
        s0 = Math.max(0, -(a01 * s1 + b0));
        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;

      }

      if (optionalPointOnRay) {

        optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);

      }

      if (optionalPointOnSegment) {

        optionalPointOnSegment.copy(segDir).multiplyScalar(s1).add(segCenter);

      }

      return sqrDist;

    };

  }(),


  isIntersectionSphere: function (sphere) {

    return this.distanceToPoint(sphere.center) <= sphere.radius;

  },

  intersectSphere: function () {

    // from http://www.scratchapixel.com/lessons/3d-basic-lessons/lesson-7-intersecting-simple-shapes/ray-sphere-intersection/

    var v1 = new THREE.Vector3();

    return function (sphere, optionalTarget) {

      v1.subVectors(sphere.center, this.origin);

      var tca = v1.dot(this.direction);

      var d2 = v1.dot(v1) - tca * tca;

      var radius2 = sphere.radius * sphere.radius;

      if (d2 > radius2) return null;

      var thc = Math.sqrt(radius2 - d2);

      // t0 = first intersect point - entrance on front of sphere
      var t0 = tca - thc;

      // t1 = second intersect point - exit point on back of sphere
      var t1 = tca + thc;

      // test to see if both t0 and t1 are behind the ray - if so, return null
      if (t0 < 0 && t1 < 0) return null;

      // test to see if t0 is behind the ray:
      // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
      // in order to always return an intersect point that is in front of the ray.
      if (t0 < 0) return this.at(t1, optionalTarget);

      // else t0 is in front of the ray, so return the first collision point scaled by t0
      return this.at(t0, optionalTarget);

    };

  }(),

  isIntersectionPlane: function (plane) {

    // check if the ray lies on the plane first

    var distToPoint = plane.distanceToPoint(this.origin);

    if (distToPoint === 0) {

      return true;

    }

    var denominator = plane.normal.dot(this.direction);

    if (denominator * distToPoint < 0) {

      return true;

    }

    // ray origin is behind the plane (and is pointing behind it)

    return false;

  },

  distanceToPlane: function (plane) {

    var denominator = plane.normal.dot(this.direction);
    if (denominator == 0) {

      // line is coplanar, return origin
      if (plane.distanceToPoint(this.origin) == 0) {

        return 0;

      }

      // Null is preferable to undefined since undefined means.... it is undefined

      return null;

    }

    var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;

    // Return if the ray never intersects the plane

    return t >= 0 ? t : null;

  },

  intersectPlane: function (plane, optionalTarget) {

    var t = this.distanceToPlane(plane);

    if (t === null) {

      return null;
    }

    return this.at(t, optionalTarget);

  },

  isIntersectionBox: function () {

    var v = new THREE.Vector3();

    return function (box) {

      return this.intersectBox(box, v) !== null;

    };

  }(),

  intersectBox: function (box, optionalTarget) {

    // http://www.scratchapixel.com/lessons/3d-basic-lessons/lesson-7-intersecting-simple-shapes/ray-box-intersection/

    var tmin, tmax, tymin, tymax, tzmin, tzmax;

    var invdirx = 1 / this.direction.x,
      invdiry = 1 / this.direction.y,
      invdirz = 1 / this.direction.z;

    var origin = this.origin;

    if (invdirx >= 0) {

      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;

    } else {

      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }

    if (invdiry >= 0) {

      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;

    } else {

      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }

    if (tmin > tymax || tymin > tmax) return null;

    // These lines also handle the case where tmin or tmax is NaN
    // (result of 0 * Infinity). x !== x returns true if x is NaN

    if (tymin > tmin || tmin !== tmin) tmin = tymin;

    if (tymax < tmax || tmax !== tmax) tmax = tymax;

    if (invdirz >= 0) {

      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;

    } else {

      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }

    if (tmin > tzmax || tzmin > tmax) return null;

    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;

    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;

    //return point closest to the ray (positive side)

    if (tmax < 0) return null;

    return this.at(tmin >= 0 ? tmin : tmax, optionalTarget);

  },

  intersectsBox: function (target) {

    return this.isIntersectionBox(target);

  },


  intersectTriangle: function () {

    // Compute the offset origin, edges, and normal.
    var diff = new THREE.Vector3();
    var edge1 = new THREE.Vector3();
    var edge2 = new THREE.Vector3();
    var normal = new THREE.Vector3();

    return function (a, b, c, backfaceCulling, optionalTarget) {

      // from http://www.geometrictools.com/LibMathematics/Intersection/Wm5IntrRay3Triangle3.cpp

      edge1.subVectors(b, a);
      edge2.subVectors(c, a);
      normal.crossVectors(edge1, edge2);

      // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
      // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
      //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
      //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
      //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
      var DdN = this.direction.dot(normal);
      var sign;

      if (DdN > 0) {

        if (backfaceCulling) return null;
        sign = 1;

      } else if (DdN < 0) {

        sign = -1;
        DdN = -DdN;

      } else {

        return null;

      }

      diff.subVectors(this.origin, a);
      var DdQxE2 = sign * this.direction.dot(edge2.crossVectors(diff, edge2));

      // b1 < 0, no intersection
      if (DdQxE2 < 0) {

        return null;

      }

      var DdE1xQ = sign * this.direction.dot(edge1.cross(diff));

      // b2 < 0, no intersection
      if (DdE1xQ < 0) {

        return null;

      }

      // b1+b2 > 1, no intersection
      if (DdQxE2 + DdE1xQ > DdN) {

        return null;

      }

      // Line intersects triangle, check if ray does.
      var QdN = -sign * diff.dot(normal);

      // t < 0, no intersection
      if (QdN < 0) {

        return null;

      }

      // Ray intersects triangle.
      return this.at(QdN / DdN, optionalTarget);

    };

  }(),

  applyMatrix4: function (matrix4) {

    this.direction.add(this.origin).applyMatrix4(matrix4);
    this.origin.applyMatrix4(matrix4);
    this.direction.sub(this.origin);
    this.direction.normalize();

    return this;
  },

  equals: function (ray) {

    return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);

  },

  clone: function () {

    return new THREE.Ray().copy(this);

  }

};

// File:src/math/Sphere.js

/**
 * @author bhouston / http://exocortex.com
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Sphere = function (center, radius) {

  this.center = center !== undefined ? center : new THREE.Vector3();
  this.radius = radius !== undefined ? radius : 0;

};

THREE.Sphere.prototype = {

  constructor: THREE.Sphere,

  set: function (center, radius) {

    this.center.copy(center);
    this.radius = radius;

    return this;
  },

  setFromPoints: function () {

    var box = new THREE.Box3();

    return function (points, optionalCenter) {

      var center = this.center;

      if (optionalCenter !== undefined) {

        center.copy(optionalCenter);

      } else {

        box.setFromPoints(points).getCenter(center);

      }

      var maxRadiusSq = 0;

      for (var i = 0, il = points.length; i < il; i++) {

        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));

      }

      this.radius = Math.sqrt(maxRadiusSq);

      return this;

    };

  }(),

  copy: function (sphere) {

    this.center.copy(sphere.center);
    this.radius = sphere.radius;

    return this;

  },

  empty: function () {

    return this.radius <= 0;

  },

  containsPoint: function (point) {

    return point.distanceToSquared(this.center) <= this.radius * this.radius;

  },

  distanceToPoint: function (point) {

    return point.distanceTo(this.center) - this.radius;

  },

  intersectsSphere: function (sphere) {

    var radiusSum = this.radius + sphere.radius;

    return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;

  },

  clampPoint: function (point, optionalTarget) {

    var deltaLengthSq = this.center.distanceToSquared(point);

    var result = optionalTarget || new THREE.Vector3();
    result.copy(point);

    if (deltaLengthSq > this.radius * this.radius) {

      result.sub(this.center).normalize();
      result.multiplyScalar(this.radius).add(this.center);

    }

    return result;

  },

  getBoundingBox: function (optionalTarget) {

    var box = optionalTarget || new THREE.Box3();

    box.set(this.center, this.center);
    box.expandByScalar(this.radius);

    return box;

  },

  applyMatrix4: function (matrix) {

    this.center.applyMatrix4(matrix);
    this.radius = this.radius * matrix.getMaxScaleOnAxis();

    return this;

  },

  translate: function (offset) {

    this.center.add(offset);

    return this;

  },

  equals: function (sphere) {

    return sphere.center.equals(this.center) && sphere.radius === this.radius;

  },

  clone: function () {

    return new THREE.Sphere().copy(this);

  }

};

// File:src/math/Frustum.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author bhouston / http://exocortex.com
 */

THREE.Frustum = function (p0, p1, p2, p3, p4, p5) {

  this.planes = [

  p0 !== undefined ? p0 : new THREE.Plane(),
  p1 !== undefined ? p1 : new THREE.Plane(),
  p2 !== undefined ? p2 : new THREE.Plane(),
  p3 !== undefined ? p3 : new THREE.Plane(),
  p4 !== undefined ? p4 : new THREE.Plane(),
  p5 !== undefined ? p5 : new THREE.Plane()];



};

THREE.Frustum.prototype = {

  constructor: THREE.Frustum,

  set: function (p0, p1, p2, p3, p4, p5) {

    var planes = this.planes;

    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p2);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);

    return this;

  },

  copy: function (frustum) {

    var planes = this.planes;

    for (var i = 0; i < 6; i++) {

      planes[i].copy(frustum.planes[i]);

    }

    return this;

  },

  setFromMatrix: function (m) {

    var planes = this.planes;
    var me = m.elements;
    var me0 = me[0],me1 = me[1],me2 = me[2],me3 = me[3];
    var me4 = me[4],me5 = me[5],me6 = me[6],me7 = me[7];
    var me8 = me[8],me9 = me[9],me10 = me[10],me11 = me[11];
    var me12 = me[12],me13 = me[13],me14 = me[14],me15 = me[15];

    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();

    return this;

  },

  // Polyfill for r113 addition of Frustum.setFromProjectionMatrix https://github.com/mrdoob/three.js/commit/da2c0affd1c2cb21f7d5ecd67aaf5138221cd367
  setFromProjectionMatrix: function (m) {

    return this.setFromMatrix(m);

  },

  intersectsObject: function () {

    var sphere = new THREE.Sphere();

    return function (object) {

      var geometry = object.geometry;

      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

      sphere.copy(geometry.boundingSphere);
      sphere.applyMatrix4(object.matrixWorld);

      return this.intersectsSphere(sphere);

    };

  }(),

  intersectsSphere: function (sphere) {

    var planes = this.planes;
    var center = sphere.center;
    var negRadius = -sphere.radius;

    for (var i = 0; i < 6; i++) {

      var distance = planes[i].distanceToPoint(center);

      if (distance < negRadius) {

        return false;

      }

    }

    return true;

  },

  intersectsBox: function () {

    var p1 = new THREE.Vector3(),
      p2 = new THREE.Vector3();

    return function (box) {

      var planes = this.planes;

      for (var i = 0; i < 6; i++) {

        var plane = planes[i];

        p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
        p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
        p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
        p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
        p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
        p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;

        var d1 = plane.distanceToPoint(p1);
        var d2 = plane.distanceToPoint(p2);

        // if both outside plane, no intersection

        if (d1 < 0 && d2 < 0) {

          return false;

        }
      }

      return true;
    };

  }(),


  containsPoint: function (point) {

    var planes = this.planes;

    for (var i = 0; i < 6; i++) {

      if (planes[i].distanceToPoint(point) < 0) {

        return false;

      }

    }

    return true;

  },

  clone: function () {

    return new THREE.Frustum().copy(this);

  }

};

// File:src/math/Plane.js

/**
 * @author bhouston / http://exocortex.com
 */

THREE.Plane = function (normal, constant) {

  this.normal = normal !== undefined ? normal : new THREE.Vector3(1, 0, 0);
  this.constant = constant !== undefined ? constant : 0;

};

THREE.Plane.prototype = {

  constructor: THREE.Plane,

  set: function (normal, constant) {

    this.normal.copy(normal);
    this.constant = constant;

    return this;

  },

  setComponents: function (x, y, z, w) {

    this.normal.set(x, y, z);
    this.constant = w;

    return this;

  },

  setFromNormalAndCoplanarPoint: function (normal, point) {

    this.normal.copy(normal);
    this.constant = -point.dot(this.normal); // must be this.normal, not normal, as this.normal is normalized

    return this;

  },

  setFromCoplanarPoints: function () {

    var v1 = new THREE.Vector3();
    var v2 = new THREE.Vector3();

    return function (a, b, c) {

      var normal = v1.subVectors(c, b).cross(v2.subVectors(a, b)).normalize();

      // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

      this.setFromNormalAndCoplanarPoint(normal, a);

      return this;

    };

  }(),


  copy: function (plane) {

    this.normal.copy(plane.normal);
    this.constant = plane.constant;

    return this;

  },

  normalize: function () {

    // Note: will lead to a divide by zero if the plane is invalid.

    var inverseNormalLength = 1.0 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;

    return this;

  },

  negate: function () {

    this.constant *= -1;
    this.normal.negate();

    return this;

  },

  distanceToPoint: function (point) {

    return this.normal.dot(point) + this.constant;

  },

  distanceToSphere: function (sphere) {

    return this.distanceToPoint(sphere.center) - sphere.radius;

  },

  projectPoint: function (point, optionalTarget) {

    return this.orthoPoint(point, optionalTarget).sub(point).negate();

  },

  orthoPoint: function (point, optionalTarget) {

    var perpendicularMagnitude = this.distanceToPoint(point);

    var result = optionalTarget || new THREE.Vector3();
    return result.copy(this.normal).multiplyScalar(perpendicularMagnitude);

  },

  isIntersectionLine: function (line) {

    // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

    var startSign = this.distanceToPoint(line.start);
    var endSign = this.distanceToPoint(line.end);

    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;

  },

  intersectLine: function () {

    var v1 = new THREE.Vector3();

    return function (line, optionalTarget) {

      var result = optionalTarget || new THREE.Vector3();

      var direction = line.delta(v1);

      var denominator = this.normal.dot(direction);

      if (denominator == 0) {

        // line is coplanar, return origin
        if (this.distanceToPoint(line.start) == 0) {

          return result.copy(line.start);

        }

        // Unsure if this is the correct method to handle this case.
        return undefined;

      }

      var t = -(line.start.dot(this.normal) + this.constant) / denominator;

      if (t < 0 || t > 1) {

        return undefined;

      }

      return result.copy(direction).multiplyScalar(t).add(line.start);

    };

  }(),


  coplanarPoint: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.copy(this.normal).multiplyScalar(-this.constant);

  },

  applyMatrix4: function () {

    var v1 = new THREE.Vector3();
    var v2 = new THREE.Vector3();
    var m1 = new THREE.Matrix3();

    return function (matrix, optionalNormalMatrix) {

      // compute new normal based on theory here:
      // http://www.songho.ca/opengl/gl_normaltransform.html
      var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix(matrix);
      var newNormal = v1.copy(this.normal).applyMatrix3(normalMatrix);

      // LMV-Patch: [HB] Added missing re-normalization. Note that it is important to do this here
      // already, because it also affects the recomputation of this.constant.
      newNormal.normalize();

      var newCoplanarPoint = this.coplanarPoint(v2);
      newCoplanarPoint.applyMatrix4(matrix);

      this.setFromNormalAndCoplanarPoint(newNormal, newCoplanarPoint);

      return this;

    };

  }(),

  translate: function (offset) {

    this.constant = this.constant - offset.dot(this.normal);

    return this;

  },

  equals: function (plane) {

    return plane.normal.equals(this.normal) && plane.constant == this.constant;

  },

  clone: function () {

    return new THREE.Plane().copy(this);

  }

};

// File:src/math/Math.js

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Math = {

  generateUUID: function () {

    // http://www.broofa.com/Tools/Math.uuid.htm

    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = new Array(36);
    var rnd = 0,r;

    return function () {

      for (var i = 0; i < 36; i++) {

        if (i == 8 || i == 13 || i == 18 || i == 23) {

          uuid[i] = '-';

        } else if (i == 14) {

          uuid[i] = '4';

        } else {

          if (rnd <= 0x02) rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
          r = rnd & 0xf;
          rnd = rnd >> 4;
          uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];

        }
      }

      return uuid.join('');

    };

  }(),

  // Clamp value to range <a, b>

  clamp: function (x, a, b) {

    return x < a ? a : x > b ? b : x;

  },

  // Clamp value to range <a, inf)

  clampBottom: function (x, a) {

    return x < a ? a : x;

  },

  // Linear mapping from range <a1, a2> to range <b1, b2>

  mapLinear: function (x, a1, a2, b1, b2) {

    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);

  },

  // http://en.wikipedia.org/wiki/Smoothstep

  smoothstep: function (x, min, max) {

    if (x <= min) return 0;
    if (x >= max) return 1;

    x = (x - min) / (max - min);

    return x * x * (3 - 2 * x);

  },

  smootherstep: function (x, min, max) {

    if (x <= min) return 0;
    if (x >= max) return 1;

    x = (x - min) / (max - min);

    return x * x * x * (x * (x * 6 - 15) + 10);

  },

  // Random float from <0, 1> with 16 bits of randomness
  // (standard Math.random() creates repetitive patterns when applied over larger space)

  random16: function () {

    return (65280 * Math.random() + 255 * Math.random()) / 65535;

  },

  // Random integer from <low, high> interval

  randInt: function (low, high) {

    return Math.floor(this.randFloat(low, high));

  },

  // Random float from <low, high> interval

  randFloat: function (low, high) {

    return low + Math.random() * (high - low);

  },

  // Random float from <-range/2, range/2> interval

  randFloatSpread: function (range) {

    return range * (0.5 - Math.random());

  },

  degToRad: function () {

    var degreeToRadiansFactor = Math.PI / 180;

    return function (degrees) {

      return degrees * degreeToRadiansFactor;

    };

  }(),

  radToDeg: function () {

    var radianToDegreesFactor = 180 / Math.PI;

    return function (radians) {

      return radians * radianToDegreesFactor;

    };

  }(),

  isPowerOfTwo: function (value) {

    return (value & value - 1) === 0 && value !== 0;

  },

  nextPowerOfTwo: function (value) {

    value--;
    value |= value >> 1;
    value |= value >> 2;
    value |= value >> 4;
    value |= value >> 8;
    value |= value >> 16;
    value++;

    return value;

  }

};

// File:src/math/Triangle.js

/**
 * @author bhouston / http://exocortex.com
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Triangle = function (a, b, c) {

  this.a = a !== undefined ? a : new THREE.Vector3();
  this.b = b !== undefined ? b : new THREE.Vector3();
  this.c = c !== undefined ? c : new THREE.Vector3();

};

THREE.Triangle.normal = function () {

  var v0 = new THREE.Vector3();

  return function (a, b, c, optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();

    result.subVectors(c, b);
    v0.subVectors(a, b);
    result.cross(v0);

    var resultLengthSq = result.lengthSq();
    if (resultLengthSq > 0) {

      return result.multiplyScalar(1 / Math.sqrt(resultLengthSq));

    }

    return result.set(0, 0, 0);

  };

}();

THREE.Triangle.getNormal = function (a, b, c, target) {

  return this.normal(a, b, c, target);

};

// static/instance method to calculate barycoordinates
// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
THREE.Triangle.barycoordFromPoint = function () {

  var v0 = new THREE.Vector3();
  var v1 = new THREE.Vector3();
  var v2 = new THREE.Vector3();

  return function (point, a, b, c, optionalTarget) {

    v0.subVectors(c, a);
    v1.subVectors(b, a);
    v2.subVectors(point, a);

    var dot00 = v0.dot(v0);
    var dot01 = v0.dot(v1);
    var dot02 = v0.dot(v2);
    var dot11 = v1.dot(v1);
    var dot12 = v1.dot(v2);

    var denom = dot00 * dot11 - dot01 * dot01;

    var result = optionalTarget || new THREE.Vector3();

    // colinear or singular triangle
    if (denom == 0) {
      // arbitrary location outside of triangle?
      // not sure if this is the best idea, maybe should be returning undefined
      return result.set(-2, -1, -1);
    }

    var invDenom = 1 / denom;
    var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    var v = (dot00 * dot12 - dot01 * dot02) * invDenom;

    // barycoordinates must always sum to 1
    return result.set(1 - u - v, v, u);

  };

}();

THREE.Triangle.containsPoint = function () {

  var v1 = new THREE.Vector3();

  return function (point, a, b, c) {

    var result = THREE.Triangle.barycoordFromPoint(point, a, b, c, v1);

    return result.x >= 0 && result.y >= 0 && result.x + result.y <= 1;

  };

}();

THREE.Triangle.prototype = {

  constructor: THREE.Triangle,

  set: function (a, b, c) {

    this.a.copy(a);
    this.b.copy(b);
    this.c.copy(c);

    return this;

  },

  setFromPointsAndIndices: function (points, i0, i1, i2) {

    this.a.copy(points[i0]);
    this.b.copy(points[i1]);
    this.c.copy(points[i2]);

    return this;

  },

  copy: function (triangle) {

    this.a.copy(triangle.a);
    this.b.copy(triangle.b);
    this.c.copy(triangle.c);

    return this;

  },

  area: function () {

    var v0 = new THREE.Vector3();
    var v1 = new THREE.Vector3();

    return function () {

      v0.subVectors(this.c, this.b);
      v1.subVectors(this.a, this.b);

      return v0.cross(v1).length() * 0.5;

    };

  }(),

  midpoint: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();
    return result.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);

  },

  normal: function (optionalTarget) {

    return THREE.Triangle.normal(this.a, this.b, this.c, optionalTarget);

  },

  plane: function (optionalTarget) {

    var result = optionalTarget || new THREE.Plane();

    return result.setFromCoplanarPoints(this.a, this.b, this.c);

  },

  barycoordFromPoint: function (point, optionalTarget) {

    return THREE.Triangle.barycoordFromPoint(point, this.a, this.b, this.c, optionalTarget);

  },

  containsPoint: function (point) {

    return THREE.Triangle.containsPoint(point, this.a, this.b, this.c);

  },

  equals: function (triangle) {

    return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);

  },

  clone: function () {

    return new THREE.Triangle().copy(this);

  }

};

// File:src/core/Clock.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.Clock = function (autoStart) {

  this.autoStart = autoStart !== undefined ? autoStart : true;

  this.startTime = 0;
  this.oldTime = 0;
  this.elapsedTime = 0;

  this.running = false;

};

THREE.Clock.prototype = {

  constructor: THREE.Clock,

  start: function () {

    this.startTime = self.performance !== undefined && self.performance.now !== undefined ?
    self.performance.now() :
    Date.now();

    this.oldTime = this.startTime;
    this.running = true;
  },

  stop: function () {

    this.getElapsedTime();
    this.running = false;

  },

  getElapsedTime: function () {

    this.getDelta();
    return this.elapsedTime;

  },

  getDelta: function () {

    var diff = 0;

    if (this.autoStart && !this.running) {

      this.start();

    }

    if (this.running) {

      var newTime = self.performance !== undefined && self.performance.now !== undefined ?
      self.performance.now() :
      Date.now();

      diff = 0.001 * (newTime - this.oldTime);
      this.oldTime = newTime;

      this.elapsedTime += diff;

    }

    return diff;

  }

};

// File:src/core/EventDispatcher.js

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

THREE.EventDispatcher = function () {};

THREE.EventDispatcher.prototype = {

  constructor: THREE.EventDispatcher,

  apply: function (object) {

    object.addEventListener = THREE.EventDispatcher.prototype.addEventListener;
    object.hasEventListener = THREE.EventDispatcher.prototype.hasEventListener;
    object.removeEventListener = THREE.EventDispatcher.prototype.removeEventListener;
    object.dispatchEvent = THREE.EventDispatcher.prototype.dispatchEvent;

  },

  addEventListener: function (type, listener) {

    if (this._listeners === undefined) this._listeners = {};

    var listeners = this._listeners;

    if (listeners[type] === undefined) {

      listeners[type] = [];

    }

    if (listeners[type].indexOf(listener) === -1) {

      listeners[type].push(listener);

    }

  },

  hasEventListener: function (type, listener) {

    if (this._listeners === undefined) return false;

    var listeners = this._listeners;

    if (listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1) {

      return true;

    }

    return false;

  },

  removeEventListener: function (type, listener) {

    if (this._listeners === undefined) return;

    var listeners = this._listeners;
    var listenerArray = listeners[type];

    if (listenerArray !== undefined) {

      var index = listenerArray.indexOf(listener);

      if (index !== -1) {

        listenerArray.splice(index, 1);

      }

    }

  },

  dispatchEvent: function (event) {

    if (this._listeners === undefined) return;

    var listeners = this._listeners;
    var listenerArray = listeners[event.type];

    if (listenerArray !== undefined) {

      event.target = this;

      var array = [];
      var length = listenerArray.length;

      for (var i = 0; i < length; i++) {

        array[i] = listenerArray[i];

      }

      for (var i = 0; i < length; i++) {

        array[i].call(this, event);

      }

    }

  }

};

// File:src/core/Raycaster.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author bhouston / http://exocortex.com/
 * @author stephomi / http://stephaneginier.com/
 */

(function (THREE) {

  THREE.Raycaster = function (origin, direction, near, far) {

    this.ray = new THREE.Ray(origin, direction);
    // direction is assumed to be normalized (for accurate distance calculations)

    this.near = near || 0;
    this.far = far || Infinity;

    this.params = {
      Sprite: {},
      Mesh: {},
      PointCloud: { threshold: 1 },
      LOD: {},
      Line: { threshold: 1 }
    };

  };

  var descSort = function (a, b) {

    return a.distance - b.distance;

  };

  var intersectObject = function (object, raycaster, intersects, recursive) {

    object.raycast(raycaster, intersects);

    if (recursive === true) {

      var children = object.children;

      for (var i = 0, l = children.length; i < l; i++) {

        intersectObject(children[i], raycaster, intersects, true);

      }

    }

  };

  //

  THREE.Raycaster.prototype = {

    constructor: THREE.Raycaster,

    precision: 0.0001,

    set: function (origin, direction) {

      // direction is assumed to be normalized (for accurate distance calculations)

      this.ray.set(origin, direction);

    },

    setFromCamera: function (coords, camera) {

      // camera is assumed _not_ to be a child of a transformed object

      if (camera instanceof THREE.PerspectiveCamera) {

        this.ray.origin.copy(camera.position);
        this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(camera.position).normalize();

      } else if (camera instanceof THREE.OrthographicCamera) {

        this.ray.origin.set(coords.x, coords.y, -1).unproject(camera);
        this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);

      } else {

        THREE.error('THREE.Raycaster: Unsupported camera type.');

      }

    },

    intersectObject: function (object, recursive) {

      var intersects = [];

      intersectObject(object, this, intersects, recursive);

      intersects.sort(descSort);

      return intersects;

    },

    intersectObjects: function (objects, recursive) {

      var intersects = [];

      if (objects instanceof Array === false) {

        THREE.warn('THREE.Raycaster.intersectObjects: objects is not an Array.');
        return intersects;

      }

      for (var i = 0, l = objects.length; i < l; i++) {

        intersectObject(objects[i], this, intersects, recursive);

      }

      intersects.sort(descSort);

      return intersects;

    }

  };

  Object.defineProperty(THREE.Raycaster.prototype, 'linePrecision', {
    get: function get() {
      console.warn('THREE.Raycaster: .linePrecision is now .params.Line.threshold.');
      return this.params.Line.threshold;
    },
    set: function set(value) {
      console.warn('THREE.Raycaster: .linePrecision is now .params.Line.threshold.');
      this.params.Line.threshold = value;
    }
  });

})(THREE);

// File:src/core/Object3D.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 */

THREE.Object3D = function () {

  Object.defineProperty(this, 'id', { value: THREE.Object3DIdCount++ });

  this.uuid = THREE.Math.generateUUID();

  this.name = '';
  this.type = 'Object3D';

  this.parent = undefined;
  this.children = [];

  this.up = THREE.Object3D.DefaultUp.clone();

  var position = new THREE.Vector3();
  var rotation = new THREE.Euler();
  var quaternion = new THREE.Quaternion();
  var scale = new THREE.Vector3(1, 1, 1);

  var onRotationChange = function () {
    quaternion.setFromEuler(rotation, false);
  };

  var onQuaternionChange = function () {
    rotation.setFromQuaternion(quaternion, undefined, false);
  };

  rotation.onChange(onRotationChange);
  quaternion.onChange(onQuaternionChange);

  Object.defineProperties(this, {
    position: {
      enumerable: true,
      value: position
    },
    rotation: {
      enumerable: true,
      value: rotation
    },
    quaternion: {
      enumerable: true,
      value: quaternion
    },
    scale: {
      enumerable: true,
      value: scale
    }
  });

  this.rotationAutoUpdate = true;

  this.matrix = new THREE.Matrix4();
  this.matrixWorld = new THREE.Matrix4();

  this.matrixAutoUpdate = true;
  this.matrixWorldNeedsUpdate = false;

  this.visible = true;

  this.castShadow = false;
  this.receiveShadow = false;

  this.frustumCulled = true;
  this.renderOrder = 0;

  this.userData = {};

};

THREE.Object3D.DefaultUp = new THREE.Vector3(0, 1, 0);

THREE.Object3D.prototype = {

  constructor: THREE.Object3D,

  get eulerOrder() {

    THREE.warn('THREE.Object3D: .eulerOrder has been moved to .rotation.order.');

    return this.rotation.order;

  },

  set eulerOrder(value) {

    THREE.warn('THREE.Object3D: .eulerOrder has been moved to .rotation.order.');

    this.rotation.order = value;

  },

  get useQuaternion() {

    THREE.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');

  },

  set useQuaternion(value) {

    THREE.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');

  },

  applyMatrix: function (matrix) {

    this.matrix.multiplyMatrices(matrix, this.matrix);

    this.matrix.decompose(this.position, this.quaternion, this.scale);

  },

  // Polyfill for r113 Object3D.applyMatrix4: https://github.com/mrdoob/three.js/commit/957051a01feb7731d67fd6067a67a64d86db0965
  applyMatrix4: function (matrix) {

    this.applyMatrix(matrix);

    return this;

  },

  setRotationFromAxisAngle: function (axis, angle) {

    // assumes axis is normalized

    this.quaternion.setFromAxisAngle(axis, angle);

  },

  setRotationFromEuler: function (euler) {

    this.quaternion.setFromEuler(euler, true);

  },

  setRotationFromMatrix: function (m) {

    // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

    this.quaternion.setFromRotationMatrix(m);

  },

  setRotationFromQuaternion: function (q) {

    // assumes q is normalized

    this.quaternion.copy(q);

  },

  rotateOnAxis: function () {

    // rotate object on axis in object space
    // axis is assumed to be normalized

    var q1 = new THREE.Quaternion();

    return function (axis, angle) {

      q1.setFromAxisAngle(axis, angle);

      this.quaternion.multiply(q1);

      return this;

    };

  }(),

  rotateX: function () {

    var v1 = new THREE.Vector3(1, 0, 0);

    return function (angle) {

      return this.rotateOnAxis(v1, angle);

    };

  }(),

  rotateY: function () {

    var v1 = new THREE.Vector3(0, 1, 0);

    return function (angle) {

      return this.rotateOnAxis(v1, angle);

    };

  }(),

  rotateZ: function () {

    var v1 = new THREE.Vector3(0, 0, 1);

    return function (angle) {

      return this.rotateOnAxis(v1, angle);

    };

  }(),

  translateOnAxis: function () {

    // translate object by distance along axis in object space
    // axis is assumed to be normalized

    var v1 = new THREE.Vector3();

    return function (axis, distance) {

      v1.copy(axis).applyQuaternion(this.quaternion);

      this.position.add(v1.multiplyScalar(distance));

      return this;

    };

  }(),

  translate: function (distance, axis) {

    THREE.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
    return this.translateOnAxis(axis, distance);

  },

  translateX: function () {

    var v1 = new THREE.Vector3(1, 0, 0);

    return function (distance) {

      return this.translateOnAxis(v1, distance);

    };

  }(),

  translateY: function () {

    var v1 = new THREE.Vector3(0, 1, 0);

    return function (distance) {

      return this.translateOnAxis(v1, distance);

    };

  }(),

  translateZ: function () {

    var v1 = new THREE.Vector3(0, 0, 1);

    return function (distance) {

      return this.translateOnAxis(v1, distance);

    };

  }(),

  localToWorld: function (vector) {

    return vector.applyMatrix4(this.matrixWorld);

  },

  worldToLocal: function () {

    var m1 = new THREE.Matrix4();

    return function (vector) {

      return vector.applyMatrix4(m1.getInverse(this.matrixWorld));

    };

  }(),

  lookAt: function () {

    // This routine does not support objects with rotated and/or translated parent(s)

    var m1 = new THREE.Matrix4();

    return function (vector) {

      m1.lookAt(vector, this.position, this.up);

      this.quaternion.setFromRotationMatrix(m1);

    };

  }(),

  add: function (object) {

    if (arguments.length > 1) {

      for (var i = 0; i < arguments.length; i++) {

        this.add(arguments[i]);

      }

      return this;

    };

    if (object === this) {

      THREE.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;

    }

    if (object instanceof THREE.Object3D) {

      if (object.parent !== undefined) {

        object.parent.remove(object);

      }

      object.parent = this;
      object.dispatchEvent({ type: 'added' });

      this.children.push(object);

    } else {

      THREE.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);

    }

    return this;

  },

  remove: function (object) {

    if (arguments.length > 1) {

      for (var i = 0; i < arguments.length; i++) {

        this.remove(arguments[i]);

      }

    };

    var index = this.children.indexOf(object);

    if (index !== -1) {

      object.parent = undefined;

      object.dispatchEvent({ type: 'removed' });

      this.children.splice(index, 1);

    }

  },

  getChildByName: function (name) {

    THREE.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
    return this.getObjectByName(name);

  },

  getObjectById: function (id) {

    return this.getObjectByProperty('id', id);

  },

  getObjectByName: function (name) {

    return this.getObjectByProperty('name', name);

  },

  getObjectByProperty: function (name, value) {

    if (this[name] === value) return this;

    for (var i = 0, l = this.children.length; i < l; i++) {

      var child = this.children[i];
      var object = child.getObjectByProperty(name, value);

      if (object !== undefined) {

        return object;

      }

    }

    return undefined;

  },

  getWorldPosition: function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();

    this.updateMatrixWorld(true);

    return result.setFromMatrixPosition(this.matrixWorld);

  },

  getWorldQuaternion: function () {

    var position = new THREE.Vector3();
    var scale = new THREE.Vector3();

    return function (optionalTarget) {

      var result = optionalTarget || new THREE.Quaternion();

      this.updateMatrixWorld(true);

      this.matrixWorld.decompose(position, result, scale);

      return result;

    };

  }(),

  getWorldRotation: function () {

    var quaternion = new THREE.Quaternion();

    return function (optionalTarget) {

      var result = optionalTarget || new THREE.Euler();

      this.getWorldQuaternion(quaternion);

      return result.setFromQuaternion(quaternion, this.rotation.order, false);

    };

  }(),

  getWorldScale: function () {

    var position = new THREE.Vector3();
    var quaternion = new THREE.Quaternion();

    return function (optionalTarget) {

      var result = optionalTarget || new THREE.Vector3();

      this.updateMatrixWorld(true);

      this.matrixWorld.decompose(position, quaternion, result);

      return result;

    };

  }(),

  getWorldDirection: function () {

    var quaternion = new THREE.Quaternion();

    return function (optionalTarget) {

      var result = optionalTarget || new THREE.Vector3();

      this.getWorldQuaternion(quaternion);

      return result.set(0, 0, 1).applyQuaternion(quaternion);

    };

  }(),

  raycast: function () {},

  traverse: function (callback) {

    callback(this);

    for (var i = 0, l = this.children.length; i < l; i++) {

      this.children[i].traverse(callback);

    }

  },

  traverseVisible: function (callback) {

    if (this.visible === false) return;

    callback(this);

    for (var i = 0, l = this.children.length; i < l; i++) {

      this.children[i].traverseVisible(callback);

    }

  },

  traverseAncestors: function (callback) {

    if (this.parent) {

      callback(this.parent);

      this.parent.traverseAncestors(callback);

    }

  },

  updateMatrix: function () {

    this.matrix.compose(this.position, this.quaternion, this.scale);

    this.matrixWorldNeedsUpdate = true;

  },

  updateMatrixWorld: function (force) {

    if (this.matrixAutoUpdate === true) this.updateMatrix();

    if (this.matrixWorldNeedsUpdate === true || force === true) {

      if (this.parent === undefined) {

        this.matrixWorld.copy(this.matrix);

      } else {

        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);

      }

      this.matrixWorldNeedsUpdate = false;

      force = true;

    }

    // update children

    for (var i = 0, l = this.children.length; i < l; i++) {

      this.children[i].updateMatrixWorld(force);

    }

  },

  clone: function (object, recursive) {

    if (object === undefined) object = new THREE.Object3D();
    if (recursive === undefined) recursive = true;

    object.name = this.name;

    object.up.copy(this.up);

    object.position.copy(this.position);
    object.quaternion.copy(this.quaternion);
    object.scale.copy(this.scale);

    object.rotationAutoUpdate = this.rotationAutoUpdate;

    object.matrix.copy(this.matrix);
    object.matrixWorld.copy(this.matrixWorld);

    object.matrixAutoUpdate = this.matrixAutoUpdate;
    object.matrixWorldNeedsUpdate = this.matrixWorldNeedsUpdate;

    object.visible = this.visible;

    object.castShadow = this.castShadow;
    object.receiveShadow = this.receiveShadow;

    object.frustumCulled = this.frustumCulled;

    object.userData = JSON.parse(JSON.stringify(this.userData));

    if (recursive === true) {

      for (var i = 0; i < this.children.length; i++) {

        var child = this.children[i];
        object.add(child.clone());

      }

    }

    return object;

  }

};

THREE.EventDispatcher.prototype.apply(THREE.Object3D.prototype);

THREE.Object3DIdCount = 0;

// File:src/core/Face3.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.Face3 = function (a, b, c, normal, color, materialIndex) {

  this.a = a;
  this.b = b;
  this.c = c;

  this.normal = normal instanceof THREE.Vector3 ? normal : new THREE.Vector3();
  this.vertexNormals = normal instanceof Array ? normal : [];

  this.color = color instanceof THREE.Color ? color : new THREE.Color();
  this.vertexColors = color instanceof Array ? color : [];

  this.vertexTangents = [];

  this.materialIndex = materialIndex !== undefined ? materialIndex : 0;

};

THREE.Face3.prototype = {

  constructor: THREE.Face3,

  clone: function () {

    var face = new THREE.Face3(this.a, this.b, this.c);

    face.normal.copy(this.normal);
    face.color.copy(this.color);

    face.materialIndex = this.materialIndex;

    for (var i = 0, il = this.vertexNormals.length; i < il; i++) {

      face.vertexNormals[i] = this.vertexNormals[i].clone();

    }

    for (var i = 0, il = this.vertexColors.length; i < il; i++) {

      face.vertexColors[i] = this.vertexColors[i].clone();

    }

    for (var i = 0, il = this.vertexTangents.length; i < il; i++) {

      face.vertexTangents[i] = this.vertexTangents[i].clone();

    }

    return face;

  }

};

// File:src/core/Face4.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Face4 = function (a, b, c, d, normal, color, materialIndex) {

  THREE.warn('THREE.Face4 has been removed. A THREE.Face3 will be created instead.');
  return new THREE.Face3(a, b, c, normal, color, materialIndex);

};

// File:src/core/BufferAttribute.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

var _vector = new THREE.Vector3();

THREE.BufferAttribute = function (array, itemSize) {

  this.array = array;
  this.itemSize = itemSize;
  // Backport for BufferAttribute.count from r81
  // get count() (r72) https://github.com/mrdoob/three.js/commit/eee3194a368db36630630e741850b40bbe840281
  // get count() -> .count (r81) https://github.com/mrdoob/three.js/commit/3ac4adefcc9848975620ecad63a5470aef29fab0
  // modified from https://github.com/mrdoob/three.js/blob/r125/src/core/BufferAttribute.js#L22
  this.count = array != undefined ? array.length / itemSize : 0;
  this.needsUpdate = false;

};

THREE.BufferAttribute.prototype = {

  constructor: THREE.BufferAttribute,

  get length() {

    return this.array.length;

  },

  copyAt: function (index1, attribute, index2) {

    index1 *= this.itemSize;
    index2 *= attribute.itemSize;

    for (var i = 0, l = this.itemSize; i < l; i++) {

      this.array[index1 + i] = attribute.array[index2 + i];

    }

    return this;

  },

  applyMatrix3: function (m) {

    for (var i = 0, l = this.count; i < l; i++) {

      _vector.x = this.getX(i);
      _vector.y = this.getY(i);
      _vector.z = this.getZ(i);

      _vector.applyMatrix3(m);

      this.setXYZ(i, _vector.x, _vector.y, _vector.z);

    }

    return this;

  },

  applyMatrix4: function (m) {

    for (var i = 0, l = this.count; i < l; i++) {

      _vector.x = this.getX(i);
      _vector.y = this.getY(i);
      _vector.z = this.getZ(i);

      _vector.applyMatrix4(m);

      this.setXYZ(i, _vector.x, _vector.y, _vector.z);

    }

    return this;

  },

  applyNormalMatrix: function (m) {

    for (var i = 0, l = this.count; i < l; i++) {

      _vector.x = this.getX(i);
      _vector.y = this.getY(i);
      _vector.z = this.getZ(i);

      _vector.applyNormalMatrix(m);

      this.setXYZ(i, _vector.x, _vector.y, _vector.z);

    }

    return this;

  },

  transformDirection: function (m) {

    for (var i = 0, l = this.count; i < l; i++) {

      _vector.x = this.getX(i);
      _vector.y = this.getY(i);
      _vector.z = this.getZ(i);

      _vector.transformDirection(m);

      this.setXYZ(i, _vector.x, _vector.y, _vector.z);

    }

    return this;

  },

  set: function (value, offset) {

    if (offset === undefined) offset = 0;

    this.array.set(value, offset);

    return this;

  },

  setX: function (index, x) {

    this.array[index * this.itemSize] = x;

    return this;

  },

  setY: function (index, y) {

    this.array[index * this.itemSize + 1] = y;

    return this;

  },

  setZ: function (index, z) {

    this.array[index * this.itemSize + 2] = z;

    return this;

  },

  // Backports from r72: https://github.com/mrdoob/three.js/commit/1b6effb20430811374b648590bd24fa516548641

  setW: function (index, w) {

    this.array[index * this.itemSize + 3] = w;

    return this;

  },

  getX: function (index) {

    return this.array[index * this.itemSize];

  },

  getY: function (index) {

    return this.array[index * this.itemSize + 1];

  },

  getZ: function (index) {

    return this.array[index * this.itemSize + 2];

  },

  getW: function (index) {

    return this.array[index * this.itemSize + 3];

  },

  setXY: function (index, x, y) {

    index *= this.itemSize;

    this.array[index] = x;
    this.array[index + 1] = y;

    return this;

  },

  setXYZ: function (index, x, y, z) {

    index *= this.itemSize;

    this.array[index] = x;
    this.array[index + 1] = y;
    this.array[index + 2] = z;

    return this;

  },

  setXYZW: function (index, x, y, z, w) {

    index *= this.itemSize;

    this.array[index] = x;
    this.array[index + 1] = y;
    this.array[index + 2] = z;
    this.array[index + 3] = w;

    return this;

  },


  clone: function () {

    return new THREE.BufferAttribute(new this.array.constructor(this.array), this.itemSize);

  }

};

// Polyfills for r83 [Type]BufferAttribute
// [Type]Attribute -> [Type]BufferAttribute (r83) https://github.com/mrdoob/three.js/commit/33bfe1b393a8888259f079fcd3ed726445ff86fb
// function to class (r128) https://github.com/mrdoob/three.js/commit/5aaec4c0345035373b701a6b60b399f90addc4cc#diff-fd9bd9820242ad98f71b72535834e02a4500e4788ad62e618a172534b69af013

THREE.Float32BufferAttribute = function (array, itemSize) {

  THREE.BufferAttribute.call(this, new Float32Array(array), itemSize);

};
THREE.Float32BufferAttribute.prototype = Object.create(THREE.BufferAttribute.prototype);
THREE.Float32BufferAttribute.prototype.constructor = THREE.Float32BufferAttribute;

THREE.Uint16BufferAttribute = function (array, itemSize) {

  THREE.BufferAttribute.call(this, new Uint16Array(array), itemSize);

};
THREE.Uint16BufferAttribute.prototype = Object.create(THREE.BufferAttribute.prototype);
THREE.Uint16BufferAttribute.prototype.constructor = THREE.Uint16BufferAttribute;

THREE.Uint32BufferAttribute = function (array, itemSize) {

  THREE.BufferAttribute.call(this, new Uint32Array(array), itemSize);

};
THREE.Uint32BufferAttribute.prototype = Object.create(THREE.BufferAttribute.prototype);
THREE.Uint32BufferAttribute.prototype.constructor = THREE.Uint32BufferAttribute;


// File:src/core/DynamicBufferAttribute.js

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 * @author mrdoob / http://mrdoob.com/
 */

THREE.DynamicBufferAttribute = function (array, itemSize) {

  THREE.BufferAttribute.call(this, array, itemSize);

  this.updateRange = { offset: 0, count: -1 };

};

THREE.DynamicBufferAttribute.prototype = Object.create(THREE.BufferAttribute.prototype);
THREE.DynamicBufferAttribute.prototype.constructor = THREE.DynamicBufferAttribute;

THREE.DynamicBufferAttribute.prototype.clone = function () {

  return new THREE.DynamicBufferAttribute(new this.array.constructor(this.array), this.itemSize);

};

// File:src/core/BufferGeometry.js

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

THREE.GeometryIdCount = 0;

THREE.BufferGeometry = function () {

  Object.defineProperty(this, 'id', { value: THREE.GeometryIdCount++ });

  this.uuid = THREE.Math.generateUUID();

  this.name = '';
  this.type = 'BufferGeometry';

  this.attributes = {};
  this.attributesKeys = [];

  this.drawcalls = [];
  this.offsets = this.drawcalls; // backwards compatibility

  this.boundingBox = null;
  this.boundingSphere = null;

};

THREE.BufferGeometry.prototype = {

  constructor: THREE.BufferGeometry,

  addAttribute: function (name, attribute) {
    console.warn("BufferGeometry.addAttribute() is deprecated. Use BufferGeometry.setAttribute() instead.");
    this.setAttribute(name, attribute);
  },

  setAttribute: function (name, attribute) {

    if (attribute instanceof THREE.BufferAttribute === false) {

      THREE.warn('THREE.BufferGeometry: .setAttribute() now expects ( name, attribute ).');

      this.attributes[name] = { array: arguments[1], itemSize: arguments[2] };

      return;

    }

    this.attributes[name] = attribute;
    this.attributesKeys = Object.keys(this.attributes);

  },

  get index() {

    return this.attributes.index;

  },

  set index(val) {

    this.attributes.index = val;

  },

  getAttribute: function (name) {

    return this.attributes[name];

  },

  addDrawCall: function (start, count, indexOffset) {

    this.drawcalls.push({

      start: start,
      count: count,
      index: indexOffset !== undefined ? indexOffset : 0

    });

  },

  applyMatrix: function (matrix) {

    var position = this.attributes.position;

    if (position !== undefined) {

      matrix.applyToVector3Array(position.array);
      position.needsUpdate = true;

    }

    var normal = this.attributes.normal;

    if (normal !== undefined) {

      var normalMatrix = new THREE.Matrix3().getNormalMatrix(matrix);

      normalMatrix.applyToVector3Array(normal.array);
      normal.needsUpdate = true;

    }

    if (this.boundingBox !== null) {

      this.computeBoundingBox();

    }

    if (this.boundingSphere !== null) {

      this.computeBoundingSphere();

    }

  },

  // Polyfill for r113 BufferGeometry.applyMatrix4: https://github.com/mrdoob/three.js/commit/957051a01feb7731d67fd6067a67a64d86db0965
  applyMatrix4: function (matrix) {

    this.applyMatrix(matrix);

    return this;

  },

  center: function () {

    this.computeBoundingBox();

    var offset = this.boundingBox.getCenter().negate();

    this.applyMatrix(new THREE.Matrix4().setPosition(offset));

    return offset;

  },

  fromGeometry: function (geometry, settings) {

    settings = settings || { 'vertexColors': THREE.NoColors };

    var vertices = geometry.vertices;
    var faces = geometry.faces;
    var faceVertexUvs = geometry.faceVertexUvs;
    var vertexColors = settings.vertexColors;
    var hasFaceVertexUv = faceVertexUvs[0].length > 0;
    var hasFaceVertexNormals = faces[0].vertexNormals.length == 3;

    var positions = new Float32Array(faces.length * 3 * 3);
    this.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    var normals = new Float32Array(faces.length * 3 * 3);
    this.setAttribute('normal', new THREE.BufferAttribute(normals, 3));

    if (vertexColors !== THREE.NoColors) {

      var colors = new Float32Array(faces.length * 3 * 3);
      this.setAttribute('color', new THREE.BufferAttribute(colors, 3));

    }

    if (hasFaceVertexUv === true) {

      var uvs = new Float32Array(faces.length * 3 * 2);
      this.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));

    }

    for (var i = 0, i2 = 0, i3 = 0; i < faces.length; i++, i2 += 6, i3 += 9) {

      var face = faces[i];

      var a = vertices[face.a];
      var b = vertices[face.b];
      var c = vertices[face.c];

      positions[i3] = a.x;
      positions[i3 + 1] = a.y;
      positions[i3 + 2] = a.z;

      positions[i3 + 3] = b.x;
      positions[i3 + 4] = b.y;
      positions[i3 + 5] = b.z;

      positions[i3 + 6] = c.x;
      positions[i3 + 7] = c.y;
      positions[i3 + 8] = c.z;

      if (hasFaceVertexNormals === true) {

        var na = face.vertexNormals[0];
        var nb = face.vertexNormals[1];
        var nc = face.vertexNormals[2];

        normals[i3] = na.x;
        normals[i3 + 1] = na.y;
        normals[i3 + 2] = na.z;

        normals[i3 + 3] = nb.x;
        normals[i3 + 4] = nb.y;
        normals[i3 + 5] = nb.z;

        normals[i3 + 6] = nc.x;
        normals[i3 + 7] = nc.y;
        normals[i3 + 8] = nc.z;

      } else {

        var n = face.normal;

        normals[i3] = n.x;
        normals[i3 + 1] = n.y;
        normals[i3 + 2] = n.z;

        normals[i3 + 3] = n.x;
        normals[i3 + 4] = n.y;
        normals[i3 + 5] = n.z;

        normals[i3 + 6] = n.x;
        normals[i3 + 7] = n.y;
        normals[i3 + 8] = n.z;

      }

      if (vertexColors === THREE.FaceColors) {

        var fc = face.color;

        colors[i3] = fc.r;
        colors[i3 + 1] = fc.g;
        colors[i3 + 2] = fc.b;

        colors[i3 + 3] = fc.r;
        colors[i3 + 4] = fc.g;
        colors[i3 + 5] = fc.b;

        colors[i3 + 6] = fc.r;
        colors[i3 + 7] = fc.g;
        colors[i3 + 8] = fc.b;

      } else if (vertexColors === THREE.VertexColors) {

        var vca = face.vertexColors[0];
        var vcb = face.vertexColors[1];
        var vcc = face.vertexColors[2];

        colors[i3] = vca.r;
        colors[i3 + 1] = vca.g;
        colors[i3 + 2] = vca.b;

        colors[i3 + 3] = vcb.r;
        colors[i3 + 4] = vcb.g;
        colors[i3 + 5] = vcb.b;

        colors[i3 + 6] = vcc.r;
        colors[i3 + 7] = vcc.g;
        colors[i3 + 8] = vcc.b;

      }

      if (hasFaceVertexUv === true) {

        var uva = faceVertexUvs[0][i][0];
        var uvb = faceVertexUvs[0][i][1];
        var uvc = faceVertexUvs[0][i][2];

        uvs[i2] = uva.x;
        uvs[i2 + 1] = uva.y;

        uvs[i2 + 2] = uvb.x;
        uvs[i2 + 3] = uvb.y;

        uvs[i2 + 4] = uvc.x;
        uvs[i2 + 5] = uvc.y;

      }

    }

    this.computeBoundingSphere();

    return this;

  },

  computeBoundingBox: function () {

    var vector = new THREE.Vector3();

    return function () {

      if (this.boundingBox === null) {

        this.boundingBox = new THREE.Box3();

      }

      var positions = this.attributes.position.array;

      if (positions) {

        var bb = this.boundingBox;
        bb.makeEmpty();

        for (var i = 0, il = positions.length; i < il; i += 3) {

          vector.set(positions[i], positions[i + 1], positions[i + 2]);
          bb.expandByPoint(vector);

        }

      }

      if (positions === undefined || positions.length === 0) {

        this.boundingBox.min.set(0, 0, 0);
        this.boundingBox.max.set(0, 0, 0);

      }

      if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {

        THREE.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.');

      }

    };

  }(),

  computeBoundingSphere: function () {

    var box = new THREE.Box3();
    var vector = new THREE.Vector3();

    return function () {

      if (this.boundingSphere === null) {

        this.boundingSphere = new THREE.Sphere();

      }

      var positions = this.attributes.position.array;

      if (positions) {

        box.makeEmpty();

        var center = this.boundingSphere.center;

        for (var i = 0, il = positions.length; i < il; i += 3) {

          vector.set(positions[i], positions[i + 1], positions[i + 2]);
          box.expandByPoint(vector);

        }

        box.getCenter(center);

        // hoping to find a boundingSphere with a radius smaller than the
        // boundingSphere of the boundingBox:  sqrt(3) smaller in the best case

        var maxRadiusSq = 0;

        for (var i = 0, il = positions.length; i < il; i += 3) {

          vector.set(positions[i], positions[i + 1], positions[i + 2]);
          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(vector));

        }

        this.boundingSphere.radius = Math.sqrt(maxRadiusSq);

        if (isNaN(this.boundingSphere.radius)) {

          THREE.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.');

        }

      }

    };

  }(),

  computeFaceNormals: function () {



    // backwards compatibility
  },
  computeVertexNormals: function () {

    var attributes = this.attributes;

    if (attributes.position) {

      var positions = attributes.position.array;

      if (attributes.normal === undefined) {

        this.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(positions.length), 3));

      } else {

        // reset existing normals to zero

        var normals = attributes.normal.array;

        for (var i = 0, il = normals.length; i < il; i++) {

          normals[i] = 0;

        }

      }

      var normals = attributes.normal.array;

      var vA,vB,vC,

        pA = new THREE.Vector3(),
        pB = new THREE.Vector3(),
        pC = new THREE.Vector3(),

        cb = new THREE.Vector3(),
        ab = new THREE.Vector3();

      // indexed elements

      if (attributes.index) {

        var indices = attributes.index.array;

        var offsets = this.offsets.length > 0 ? this.offsets : [{ start: 0, count: indices.length, index: 0 }];

        for (var j = 0, jl = offsets.length; j < jl; ++j) {

          var start = offsets[j].start;
          var count = offsets[j].count;
          var index = offsets[j].index;

          for (var i = start, il = start + count; i < il; i += 3) {

            vA = (index + indices[i]) * 3;
            vB = (index + indices[i + 1]) * 3;
            vC = (index + indices[i + 2]) * 3;

            pA.fromArray(positions, vA);
            pB.fromArray(positions, vB);
            pC.fromArray(positions, vC);

            cb.subVectors(pC, pB);
            ab.subVectors(pA, pB);
            cb.cross(ab);

            normals[vA] += cb.x;
            normals[vA + 1] += cb.y;
            normals[vA + 2] += cb.z;

            normals[vB] += cb.x;
            normals[vB + 1] += cb.y;
            normals[vB + 2] += cb.z;

            normals[vC] += cb.x;
            normals[vC + 1] += cb.y;
            normals[vC + 2] += cb.z;

          }

        }

      } else {

        // non-indexed elements (unconnected triangle soup)

        for (var i = 0, il = positions.length; i < il; i += 9) {

          pA.fromArray(positions, i);
          pB.fromArray(positions, i + 3);
          pC.fromArray(positions, i + 6);

          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);

          normals[i] = cb.x;
          normals[i + 1] = cb.y;
          normals[i + 2] = cb.z;

          normals[i + 3] = cb.x;
          normals[i + 4] = cb.y;
          normals[i + 5] = cb.z;

          normals[i + 6] = cb.x;
          normals[i + 7] = cb.y;
          normals[i + 8] = cb.z;

        }

      }

      this.normalizeNormals();

      attributes.normal.needsUpdate = true;

    }

  },

  computeTangents: function () {

    // based on http://www.terathon.com/code/tangent.html
    // (per vertex tangents)

    if (this.attributes.index === undefined ||
    this.attributes.position === undefined ||
    this.attributes.normal === undefined ||
    this.attributes.uv === undefined) {

      THREE.warn('THREE.BufferGeometry: Missing required attributes (index, position, normal or uv) in BufferGeometry.computeTangents()');
      return;

    }

    var indices = this.attributes.index.array;
    var positions = this.attributes.position.array;
    var normals = this.attributes.normal.array;
    var uvs = this.attributes.uv.array;

    var nVertices = positions.length / 3;

    if (this.attributes.tangent === undefined) {

      this.setAttribute('tangent', new THREE.BufferAttribute(new Float32Array(4 * nVertices), 4));

    }

    var tangents = this.attributes.tangent.array;

    var tan1 = [],tan2 = [];

    for (var k = 0; k < nVertices; k++) {

      tan1[k] = new THREE.Vector3();
      tan2[k] = new THREE.Vector3();

    }

    var vA = new THREE.Vector3(),
      vB = new THREE.Vector3(),
      vC = new THREE.Vector3(),

      uvA = new THREE.Vector2(),
      uvB = new THREE.Vector2(),
      uvC = new THREE.Vector2(),

      x1,x2,y1,y2,z1,z2,
      s1,s2,t1,t2,r;

    var sdir = new THREE.Vector3(),tdir = new THREE.Vector3();

    function handleTriangle(a, b, c) {

      vA.fromArray(positions, a * 3);
      vB.fromArray(positions, b * 3);
      vC.fromArray(positions, c * 3);

      uvA.fromArray(uvs, a * 2);
      uvB.fromArray(uvs, b * 2);
      uvC.fromArray(uvs, c * 2);

      x1 = vB.x - vA.x;
      x2 = vC.x - vA.x;

      y1 = vB.y - vA.y;
      y2 = vC.y - vA.y;

      z1 = vB.z - vA.z;
      z2 = vC.z - vA.z;

      s1 = uvB.x - uvA.x;
      s2 = uvC.x - uvA.x;

      t1 = uvB.y - uvA.y;
      t2 = uvC.y - uvA.y;

      r = 1.0 / (s1 * t2 - s2 * t1);

      sdir.set(
        (t2 * x1 - t1 * x2) * r,
        (t2 * y1 - t1 * y2) * r,
        (t2 * z1 - t1 * z2) * r
      );

      tdir.set(
        (s1 * x2 - s2 * x1) * r,
        (s1 * y2 - s2 * y1) * r,
        (s1 * z2 - s2 * z1) * r
      );

      tan1[a].add(sdir);
      tan1[b].add(sdir);
      tan1[c].add(sdir);

      tan2[a].add(tdir);
      tan2[b].add(tdir);
      tan2[c].add(tdir);

    }

    var i, il;
    var j, jl;
    var iA, iB, iC;

    if (this.drawcalls.length === 0) {

      this.addDrawCall(0, indices.length, 0);

    }

    var drawcalls = this.drawcalls;

    for (j = 0, jl = drawcalls.length; j < jl; ++j) {

      var start = drawcalls[j].start;
      var count = drawcalls[j].count;
      var index = drawcalls[j].index;

      for (i = start, il = start + count; i < il; i += 3) {

        iA = index + indices[i];
        iB = index + indices[i + 1];
        iC = index + indices[i + 2];

        handleTriangle(iA, iB, iC);

      }

    }

    var tmp = new THREE.Vector3(),tmp2 = new THREE.Vector3();
    var n = new THREE.Vector3(),n2 = new THREE.Vector3();
    var w, t, test;

    function handleVertex(v) {

      n.fromArray(normals, v * 3);
      n2.copy(n);

      t = tan1[v];

      // Gram-Schmidt orthogonalize

      tmp.copy(t);
      tmp.sub(n.multiplyScalar(n.dot(t))).normalize();

      // Calculate handedness

      tmp2.crossVectors(n2, t);
      test = tmp2.dot(tan2[v]);
      w = test < 0.0 ? -1.0 : 1.0;

      tangents[v * 4] = tmp.x;
      tangents[v * 4 + 1] = tmp.y;
      tangents[v * 4 + 2] = tmp.z;
      tangents[v * 4 + 3] = w;

    }

    for (j = 0, jl = drawcalls.length; j < jl; ++j) {

      var start = drawcalls[j].start;
      var count = drawcalls[j].count;
      var index = drawcalls[j].index;

      for (i = start, il = start + count; i < il; i += 3) {

        iA = index + indices[i];
        iB = index + indices[i + 1];
        iC = index + indices[i + 2];

        handleVertex(iA);
        handleVertex(iB);
        handleVertex(iC);

      }

    }

  },

  /*
  Compute the draw offset for large models by chunking the index buffer into chunks of 65k addressable vertices.
  This method will effectively rewrite the index buffer and remap all attributes to match the new indices.
  WARNING: This method will also expand the vertex count to prevent sprawled triangles across draw offsets.
  size - Defaults to 65535, but allows for larger or smaller chunks.
  */
  computeOffsets: function (size) {

    if (size === undefined) size = 65535; // WebGL limits type of index buffer values to 16-bit.

    var indices = this.attributes.index.array;
    var vertices = this.attributes.position.array;

    var facesCount = indices.length / 3;

    /*
    console.log("Computing buffers in offsets of "+size+" -> indices:"+indices.length+" vertices:"+vertices.length);
    console.log("Faces to process: "+(indices.length/3));
    console.log("Reordering "+verticesCount+" vertices.");
    */

    var sortedIndices = new Uint16Array(indices.length); //16-bit buffers
    var indexPtr = 0;
    var vertexPtr = 0;

    var offsets = [{ start: 0, count: 0, index: 0 }];
    var offset = offsets[0];

    var duplicatedVertices = 0;
    var newVerticeMaps = 0;
    var faceVertices = new Int32Array(6);
    var vertexMap = new Int32Array(vertices.length);
    var revVertexMap = new Int32Array(vertices.length);
    for (var j = 0; j < vertices.length; j++) {vertexMap[j] = -1;revVertexMap[j] = -1;}

    /*
    	Traverse every face and reorder vertices in the proper offsets of 65k.
    	We can have more than 65k entries in the index buffer per offset, but only reference 65k values.
    */
    for (var findex = 0; findex < facesCount; findex++) {
      newVerticeMaps = 0;

      for (var vo = 0; vo < 3; vo++) {
        var vid = indices[findex * 3 + vo];
        if (vertexMap[vid] == -1) {
          //Unmapped vertice
          faceVertices[vo * 2] = vid;
          faceVertices[vo * 2 + 1] = -1;
          newVerticeMaps++;
        } else if (vertexMap[vid] < offset.index) {
          //Reused vertices from previous block (duplicate)
          faceVertices[vo * 2] = vid;
          faceVertices[vo * 2 + 1] = -1;
          duplicatedVertices++;
        } else {
          //Reused vertice in the current block
          faceVertices[vo * 2] = vid;
          faceVertices[vo * 2 + 1] = vertexMap[vid];
        }
      }

      var faceMax = vertexPtr + newVerticeMaps;
      if (faceMax > offset.index + size) {
        var new_offset = { start: indexPtr, count: 0, index: vertexPtr };
        offsets.push(new_offset);
        offset = new_offset;

        //Re-evaluate reused vertices in light of new offset.
        for (var v = 0; v < 6; v += 2) {
          var new_vid = faceVertices[v + 1];
          if (new_vid > -1 && new_vid < offset.index)
          faceVertices[v + 1] = -1;
        }
      }

      //Reindex the face.
      for (var v = 0; v < 6; v += 2) {
        var vid = faceVertices[v];
        var new_vid = faceVertices[v + 1];

        if (new_vid === -1)
        new_vid = vertexPtr++;

        vertexMap[vid] = new_vid;
        revVertexMap[new_vid] = vid;
        sortedIndices[indexPtr++] = new_vid - offset.index; //XXX overflows at 16bit
        offset.count++;
      }
    }

    /* Move all attribute values to map to the new computed indices , also expand the vertice stack to match our new vertexPtr. */
    this.reorderBuffers(sortedIndices, revVertexMap, vertexPtr);
    this.offsets = offsets; // TODO: Deprecate
    this.drawcalls = offsets;

    /*
    var orderTime = Date.now();
    console.log("Reorder time: "+(orderTime-s)+"ms");
    console.log("Duplicated "+duplicatedVertices+" vertices.");
    console.log("Compute Buffers time: "+(Date.now()-s)+"ms");
    console.log("Draw offsets: "+offsets.length);
    */

    return offsets;

  },

  merge: function (geometry, offset) {

    if (geometry instanceof THREE.BufferGeometry === false) {

      THREE.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
      return;

    }

    if (offset === undefined) offset = 0;

    var attributes = this.attributes;

    for (var key in attributes) {

      if (geometry.attributes[key] === undefined) continue;

      var attribute1 = attributes[key];
      var attributeArray1 = attribute1.array;

      var attribute2 = geometry.attributes[key];
      var attributeArray2 = attribute2.array;

      var attributeSize = attribute2.itemSize;

      for (var i = 0, j = attributeSize * offset; i < attributeArray2.length; i++, j++) {

        attributeArray1[j] = attributeArray2[i];

      }

    }

    return this;

  },

  normalizeNormals: function () {

    var normals = this.attributes.normal.array;

    var x, y, z, n;

    for (var i = 0, il = normals.length; i < il; i += 3) {

      x = normals[i];
      y = normals[i + 1];
      z = normals[i + 2];

      n = 1.0 / Math.sqrt(x * x + y * y + z * z);

      normals[i] *= n;
      normals[i + 1] *= n;
      normals[i + 2] *= n;

    }

  },

  /*
  	reoderBuffers:
  	Reorder attributes based on a new indexBuffer and indexMap.
  	indexBuffer - Uint16Array of the new ordered indices.
  	indexMap - Int32Array where the position is the new vertex ID and the value the old vertex ID for each vertex.
  	vertexCount - Amount of total vertices considered in this reordering (in case you want to grow the vertice stack).
  */
  reorderBuffers: function (indexBuffer, indexMap, vertexCount) {

    /* Create a copy of all attributes for reordering. */
    var sortedAttributes = {};
    for (var attr in this.attributes) {
      if (attr == 'index')
      continue;
      var sourceArray = this.attributes[attr].array;
      sortedAttributes[attr] = new sourceArray.constructor(this.attributes[attr].itemSize * vertexCount);
    }

    /* Move attribute positions based on the new index map */
    for (var new_vid = 0; new_vid < vertexCount; new_vid++) {
      var vid = indexMap[new_vid];
      for (var attr in this.attributes) {
        if (attr == 'index')
        continue;
        var attrArray = this.attributes[attr].array;
        var attrSize = this.attributes[attr].itemSize;
        var sortedAttr = sortedAttributes[attr];
        for (var k = 0; k < attrSize; k++)
        sortedAttr[new_vid * attrSize + k] = attrArray[vid * attrSize + k];
      }
    }

    /* Carry the new sorted buffers locally */
    this.attributes['index'].array = indexBuffer;
    for (var attr in this.attributes) {
      if (attr == 'index')
      continue;
      this.attributes[attr].array = sortedAttributes[attr];
      this.attributes[attr].numItems = this.attributes[attr].itemSize * vertexCount;
    }
  },

  // Backport from r88: https://github.com/mrdoob/three.js/commit/d38d3cce0223cf55a2bf11d8084b972bac0b30d3
  // Copied from https://github.com/mrdoob/three.js/blob/r125/src/core/BufferGeometry.js#L263-L278
  setFromPoints: function (points) {

    const position = [];

    for (let i = 0, l = points.length; i < l; i++) {
      const point = points[i];
      position.push(point.x, point.y, point.z || 0);
    }

    this.setAttribute('position', new THREE.Float32BufferAttribute(position, 3));
    return this;
  },

  // Backport from r72: https://github.com/mrdoob/three.js/commit/4a606a66fe0083bd8bf741a647aa11501eecae59
  // Copied from https://github.com/mrdoob/three.js/blob/r125/src/core/BufferGeometry.js#L60-L74
  setIndex: function (index) {

    // arrayMax from https://github.com/mrdoob/three.js/blob/r125/src/utils.js#L17-L31
    const _arrayMax = (array) => {
      if (array.length === 0) return -Infinity;
      var max = array[0];

      for (var i = 1, l = array.length; i < l; ++i) {
        if (array[i] > max) max = array[i];
      }

      return max;
    };

    if (Array.isArray(index)) {
      this.index = new (_arrayMax(index) > 65535 ? THREE.Uint32BufferAttribute : THREE.Uint16BufferAttribute)(index, 1);
    } else {
      this.index = index;
    }

    return this;
  },

  // Polyfill for r72 BufferGeometry.offsets -> BufferGeometry.groups:
  // .offsets -> .drawcalls: https://github.com/mrdoob/three.js/commit/a2cf50f473fbbff1b6519d73a71d6df7d507362e
  // .drawcalls -> .groups: https://github.com/mrdoob/three.js/commit/3ed8a04c0c9f249e386935392e6bf89fd3b686af
  get groups() {
    return this.offsets;
  },

  set groups(val) {
    this.offsets = val;this.drawcalls = val;
  },

  // Backport from r88: https://github.com/mrdoob/three.js/commit/d38d3cce0223cf55a2bf11d8084b972bac0b30d3
  // Copied from https://github.com/mrdoob/three.js/blob/r125/src/core/BufferGeometry.js#L263-L278
  addGroup: function (start, count, materialIndex = 0) {
    if (materialIndex !== undefined && materialIndex !== 0) {
      console.warn("THREE.BufferGeometry: .addGroup() with `materialIndex !== 0` is not supported in this Three.js version. Ignoring the `materialIndex` parameter.");
    }
    return this.addDrawCall(start, count);
  },

  clone: function () {

    var geometry = new THREE.BufferGeometry();

    for (var attr in this.attributes) {

      var sourceAttr = this.attributes[attr];
      geometry.setAttribute(attr, sourceAttr.clone());

    }

    for (var i = 0, il = this.offsets.length; i < il; i++) {

      var offset = this.offsets[i];

      geometry.offsets.push({

        start: offset.start,
        index: offset.index,
        count: offset.count

      });

    }

    return geometry;

  },

  dispose: function () {

    this.dispatchEvent({ type: 'dispose' });

  }

};

THREE.EventDispatcher.prototype.apply(THREE.BufferGeometry.prototype);

// File:src/cameras/Camera.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author WestLangley / http://github.com/WestLangley
*/

THREE.Camera = function () {

  THREE.Object3D.call(this);

  this.type = 'Camera';

  this.matrixWorldInverse = new THREE.Matrix4();
  this.projectionMatrix = new THREE.Matrix4();

};

THREE.Camera.prototype = Object.create(THREE.Object3D.prototype);
THREE.Camera.prototype.constructor = THREE.Camera;

THREE.Camera.prototype.getWorldDirection = function () {

  var quaternion = new THREE.Quaternion();

  return function (optionalTarget) {

    var result = optionalTarget || new THREE.Vector3();

    this.getWorldQuaternion(quaternion);

    return result.set(0, 0, -1).applyQuaternion(quaternion);

  };

}();

THREE.Camera.prototype.lookAt = function () {

  // This routine does not support cameras with rotated and/or translated parent(s)

  var m1 = new THREE.Matrix4();

  return function (vector) {

    m1.lookAt(this.position, vector, this.up);

    this.quaternion.setFromRotationMatrix(m1);

  };

}();

THREE.Camera.prototype.updateMatrixWorld = function (force) {

  THREE.Object3D.prototype.updateMatrixWorld.call(this, force);

  this.matrixWorldInverse.getInverse(this.matrixWorld);

};

THREE.Camera.prototype.clone = function (camera) {

  if (camera === undefined) camera = new THREE.Camera();

  THREE.Object3D.prototype.clone.call(this, camera);

  camera.matrixWorldInverse.copy(this.matrixWorldInverse);
  camera.projectionMatrix.copy(this.projectionMatrix);

  return camera;
};

// File:src/cameras/OrthographicCamera.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.OrthographicCamera = function (left, right, top, bottom, near, far) {

  THREE.Camera.call(this);

  this.type = 'OrthographicCamera';

  this.zoom = 1;

  this.left = left;
  this.right = right;
  this.top = top;
  this.bottom = bottom;

  this.near = near !== undefined ? near : 0.1;
  this.far = far !== undefined ? far : 2000;

  this.updateProjectionMatrix();

};

THREE.OrthographicCamera.prototype = Object.create(THREE.Camera.prototype);
THREE.OrthographicCamera.prototype.constructor = THREE.OrthographicCamera;

THREE.OrthographicCamera.prototype.updateProjectionMatrix = function () {

  var dx = (this.right - this.left) / (2 * this.zoom);
  var dy = (this.top - this.bottom) / (2 * this.zoom);
  var cx = (this.right + this.left) / 2;
  var cy = (this.top + this.bottom) / 2;

  this.projectionMatrix.makeOrthographic(cx - dx, cx + dx, cy + dy, cy - dy, this.near, this.far);

};

THREE.OrthographicCamera.prototype.clone = function () {

  var camera = new THREE.OrthographicCamera();

  THREE.Camera.prototype.clone.call(this, camera);

  camera.zoom = this.zoom;

  camera.left = this.left;
  camera.right = this.right;
  camera.top = this.top;
  camera.bottom = this.bottom;

  camera.near = this.near;
  camera.far = this.far;

  camera.projectionMatrix.copy(this.projectionMatrix);

  return camera;
};

// File:src/cameras/PerspectiveCamera.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author greggman / http://games.greggman.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

THREE.PerspectiveCamera = function (fov, aspect, near, far) {

  THREE.Camera.call(this);

  this.type = 'PerspectiveCamera';

  this.zoom = 1;

  this.fov = fov !== undefined ? fov : 50;
  this.aspect = aspect !== undefined ? aspect : 1;
  this.near = near !== undefined ? near : 0.1;
  this.far = far !== undefined ? far : 2000;

  this.updateProjectionMatrix();

};

THREE.PerspectiveCamera.prototype = Object.create(THREE.Camera.prototype);
THREE.PerspectiveCamera.prototype.constructor = THREE.PerspectiveCamera;


/**
 * Uses Focal Length (in mm) to estimate and set FOV
 * 35mm (fullframe) camera is used if frame size is not specified;
 * Formula based on http://www.bobatkins.com/photography/technical/field_of_view.html
 */

THREE.PerspectiveCamera.prototype.setLens = function (focalLength, frameHeight) {

  if (frameHeight === undefined) frameHeight = 24;

  this.fov = 2 * THREE.Math.radToDeg(Math.atan(frameHeight / (focalLength * 2)));
  this.updateProjectionMatrix();

};


/**
 * Sets an offset in a larger frustum. This is useful for multi-window or
 * multi-monitor/multi-machine setups.
 *
 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
 * the monitors are in grid like this
 *
 *   +---+---+---+
 *   | A | B | C |
 *   +---+---+---+
 *   | D | E | F |
 *   +---+---+---+
 *
 * then for each monitor you would call it like this
 *
 *   var w = 1920;
 *   var h = 1080;
 *   var fullWidth = w * 3;
 *   var fullHeight = h * 2;
 *
 *   --A--
 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
 *   --B--
 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
 *   --C--
 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
 *   --D--
 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
 *   --E--
 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
 *   --F--
 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
 *
 *   Note there is no reason monitors have to be the same size or in a grid.
 */

THREE.PerspectiveCamera.prototype.setViewOffset = function (fullWidth, fullHeight, x, y, width, height) {

  this.fullWidth = fullWidth;
  this.fullHeight = fullHeight;
  this.x = x;
  this.y = y;
  this.width = width;
  this.height = height;

  this.updateProjectionMatrix();

};


THREE.PerspectiveCamera.prototype.updateProjectionMatrix = function () {

  var fov = THREE.Math.radToDeg(2 * Math.atan(Math.tan(THREE.Math.degToRad(this.fov) * 0.5) / this.zoom));

  if (this.fullWidth) {

    var aspect = this.fullWidth / this.fullHeight;
    var top = Math.tan(THREE.Math.degToRad(fov * 0.5)) * this.near;
    var bottom = -top;
    var left = aspect * bottom;
    var right = aspect * top;
    var width = Math.abs(right - left);
    var height = Math.abs(top - bottom);

    this.projectionMatrix.makeFrustum(
      left + this.x * width / this.fullWidth,
      left + (this.x + this.width) * width / this.fullWidth,
      top - (this.y + this.height) * height / this.fullHeight,
      top - this.y * height / this.fullHeight,
      this.near,
      this.far
    );

  } else {

    this.projectionMatrix.makePerspective(fov, this.aspect, this.near, this.far);

  }

};

THREE.PerspectiveCamera.prototype.clone = function () {

  var camera = new THREE.PerspectiveCamera();

  THREE.Camera.prototype.clone.call(this, camera);

  camera.zoom = this.zoom;

  camera.fov = this.fov;
  camera.aspect = this.aspect;
  camera.near = this.near;
  camera.far = this.far;

  camera.projectionMatrix.copy(this.projectionMatrix);

  return camera;

};

// File:src/lights/Light.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.Light = function (color) {

  THREE.Object3D.call(this);

  this.type = 'Light';

  this.color = new THREE.Color(color);

};

THREE.Light.prototype = Object.create(THREE.Object3D.prototype);
THREE.Light.prototype.constructor = THREE.Light;

THREE.Light.prototype.clone = function (light) {

  if (light === undefined) light = new THREE.Light();

  THREE.Object3D.prototype.clone.call(this, light);

  light.color.copy(this.color);

  return light;

};

// File:src/lights/AmbientLight.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.AmbientLight = function (color) {

  THREE.Light.call(this, color);

  this.type = 'AmbientLight';

};

THREE.AmbientLight.prototype = Object.create(THREE.Light.prototype);
THREE.AmbientLight.prototype.constructor = THREE.AmbientLight;

THREE.AmbientLight.prototype.clone = function () {

  var light = new THREE.AmbientLight();

  THREE.Light.prototype.clone.call(this, light);

  return light;

};

// File:src/lights/AreaLight.js

/**
 * @author MPanknin / http://www.redplant.de/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.AreaLight = function (color, intensity) {

  THREE.Light.call(this, color);

  this.type = 'AreaLight';

  this.normal = new THREE.Vector3(0, -1, 0);
  this.right = new THREE.Vector3(1, 0, 0);

  this.intensity = intensity !== undefined ? intensity : 1;

  this.width = 1.0;
  this.height = 1.0;

  this.constantAttenuation = 1.5;
  this.linearAttenuation = 0.5;
  this.quadraticAttenuation = 0.1;

};

THREE.AreaLight.prototype = Object.create(THREE.Light.prototype);
THREE.AreaLight.prototype.constructor = THREE.AreaLight;


// File:src/lights/DirectionalLight.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.DirectionalLight = function (color, intensity) {

  THREE.Light.call(this, color);

  this.type = 'DirectionalLight';

  this.position.set(0, 1, 0);
  this.target = new THREE.Object3D();

  this.intensity = intensity !== undefined ? intensity : 1;

  this.castShadow = false;
  this.onlyShadow = false;

  //

  this.shadowCameraNear = 50;
  this.shadowCameraFar = 5000;

  this.shadowCameraLeft = -500;
  this.shadowCameraRight = 500;
  this.shadowCameraTop = 500;
  this.shadowCameraBottom = -500;

  this.shadowCameraVisible = false;

  this.shadowBias = 0;
  this.shadowDarkness = 0.5;

  this.shadowMapWidth = 512;
  this.shadowMapHeight = 512;

  //

  this.shadowCascade = false;

  this.shadowCascadeOffset = new THREE.Vector3(0, 0, -1000);
  this.shadowCascadeCount = 2;

  this.shadowCascadeBias = [0, 0, 0];
  this.shadowCascadeWidth = [512, 512, 512];
  this.shadowCascadeHeight = [512, 512, 512];

  this.shadowCascadeNearZ = [-1.000, 0.990, 0.998];
  this.shadowCascadeFarZ = [0.990, 0.998, 1.000];

  this.shadowCascadeArray = [];

  //

  this.shadowMap = null;
  this.shadowMapSize = null;
  this.shadowCamera = null;
  this.shadowMatrix = null;

};

THREE.DirectionalLight.prototype = Object.create(THREE.Light.prototype);
THREE.DirectionalLight.prototype.constructor = THREE.DirectionalLight;

THREE.DirectionalLight.prototype.clone = function () {

  var light = new THREE.DirectionalLight();

  THREE.Light.prototype.clone.call(this, light);

  light.target = this.target.clone();

  light.intensity = this.intensity;

  light.castShadow = this.castShadow;
  light.onlyShadow = this.onlyShadow;

  //

  light.shadowCameraNear = this.shadowCameraNear;
  light.shadowCameraFar = this.shadowCameraFar;

  light.shadowCameraLeft = this.shadowCameraLeft;
  light.shadowCameraRight = this.shadowCameraRight;
  light.shadowCameraTop = this.shadowCameraTop;
  light.shadowCameraBottom = this.shadowCameraBottom;

  light.shadowCameraVisible = this.shadowCameraVisible;

  light.shadowBias = this.shadowBias;
  light.shadowDarkness = this.shadowDarkness;

  light.shadowMapWidth = this.shadowMapWidth;
  light.shadowMapHeight = this.shadowMapHeight;

  //

  light.shadowCascade = this.shadowCascade;

  light.shadowCascadeOffset.copy(this.shadowCascadeOffset);
  light.shadowCascadeCount = this.shadowCascadeCount;

  light.shadowCascadeBias = this.shadowCascadeBias.slice(0);
  light.shadowCascadeWidth = this.shadowCascadeWidth.slice(0);
  light.shadowCascadeHeight = this.shadowCascadeHeight.slice(0);

  light.shadowCascadeNearZ = this.shadowCascadeNearZ.slice(0);
  light.shadowCascadeFarZ = this.shadowCascadeFarZ.slice(0);

  return light;

};

// File:src/lights/HemisphereLight.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.HemisphereLight = function (skyColor, groundColor, intensity) {

  THREE.Light.call(this, skyColor);

  this.type = 'HemisphereLight';

  this.position.set(0, 100, 0);

  this.groundColor = new THREE.Color(groundColor);
  this.intensity = intensity !== undefined ? intensity : 1;

};

THREE.HemisphereLight.prototype = Object.create(THREE.Light.prototype);
THREE.HemisphereLight.prototype.constructor = THREE.HemisphereLight;

THREE.HemisphereLight.prototype.clone = function () {

  var light = new THREE.HemisphereLight();

  THREE.Light.prototype.clone.call(this, light);

  light.groundColor.copy(this.groundColor);
  light.intensity = this.intensity;

  return light;

};

// File:src/lights/PointLight.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.PointLight = function (color, intensity, distance, decay) {

  THREE.Light.call(this, color);

  this.type = 'PointLight';

  this.intensity = intensity !== undefined ? intensity : 1;
  this.distance = distance !== undefined ? distance : 0;
  this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.

};

THREE.PointLight.prototype = Object.create(THREE.Light.prototype);
THREE.PointLight.prototype.constructor = THREE.PointLight;

THREE.PointLight.prototype.clone = function () {

  var light = new THREE.PointLight();

  THREE.Light.prototype.clone.call(this, light);

  light.intensity = this.intensity;
  light.distance = this.distance;
  light.decay = this.decay;

  return light;

};

// File:src/lights/SpotLight.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.SpotLight = function (color, intensity, distance, angle, exponent, decay) {

  THREE.Light.call(this, color);

  this.type = 'SpotLight';

  this.position.set(0, 1, 0);
  this.target = new THREE.Object3D();

  this.intensity = intensity !== undefined ? intensity : 1;
  this.distance = distance !== undefined ? distance : 0;
  this.angle = angle !== undefined ? angle : Math.PI / 3;
  this.exponent = exponent !== undefined ? exponent : 10;
  this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.

  this.castShadow = false;
  this.onlyShadow = false;

  //

  this.shadowCameraNear = 50;
  this.shadowCameraFar = 5000;
  this.shadowCameraFov = 50;

  this.shadowCameraVisible = false;

  this.shadowBias = 0;
  this.shadowDarkness = 0.5;

  this.shadowMapWidth = 512;
  this.shadowMapHeight = 512;

  //

  this.shadowMap = null;
  this.shadowMapSize = null;
  this.shadowCamera = null;
  this.shadowMatrix = null;

};

THREE.SpotLight.prototype = Object.create(THREE.Light.prototype);
THREE.SpotLight.prototype.constructor = THREE.SpotLight;

THREE.SpotLight.prototype.clone = function () {

  var light = new THREE.SpotLight();

  THREE.Light.prototype.clone.call(this, light);

  light.target = this.target.clone();

  light.intensity = this.intensity;
  light.distance = this.distance;
  light.angle = this.angle;
  light.exponent = this.exponent;
  light.decay = this.decay;

  light.castShadow = this.castShadow;
  light.onlyShadow = this.onlyShadow;

  //

  light.shadowCameraNear = this.shadowCameraNear;
  light.shadowCameraFar = this.shadowCameraFar;
  light.shadowCameraFov = this.shadowCameraFov;

  light.shadowCameraVisible = this.shadowCameraVisible;

  light.shadowBias = this.shadowBias;
  light.shadowDarkness = this.shadowDarkness;

  light.shadowMapWidth = this.shadowMapWidth;
  light.shadowMapHeight = this.shadowMapHeight;

  return light;

};

// File:src/loaders/Cache.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Cache = {

  files: {},

  add: function (key, file) {

    // console.log( 'THREE.Cache', 'Adding key:', key );

    this.files[key] = file;

  },

  get: function (key) {

    // console.log( 'THREE.Cache', 'Checking key:', key );

    return this.files[key];

  },

  remove: function (key) {

    delete this.files[key];

  },

  clear: function () {

    this.files = {};

  }

};

// File:src/loaders/XHRLoader.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.XHRLoader = function (manager) {

  this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;

};

THREE.XHRLoader.prototype = {

  constructor: THREE.XHRLoader,

  load: function (url, onLoad, onProgress, onError) {

    var scope = this;

    var cached = THREE.Cache.get(url);

    if (cached !== undefined) {

      if (onLoad) onLoad(cached);
      return;

    }

    var request = new XMLHttpRequest();
    request.open('GET', url, true);

    request.addEventListener('load', function (event) {

      THREE.Cache.add(url, this.response);

      if (onLoad) onLoad(this.response);

      scope.manager.itemEnd(url);

    }, false);

    if (onProgress !== undefined) {

      request.addEventListener('progress', function (event) {

        onProgress(event);

      }, false);

    }

    if (onError !== undefined) {

      request.addEventListener('error', function (event) {

        onError(event);

      }, false);

    }

    if (this.crossOrigin !== undefined) request.crossOrigin = this.crossOrigin;
    if (this.responseType !== undefined) request.responseType = this.responseType;

    request.send(null);

    scope.manager.itemStart(url);

  },

  setResponseType: function (value) {

    this.responseType = value;

  },

  setCrossOrigin: function (value) {

    this.crossOrigin = value;

  }

};

// File:src/loaders/ImageLoader.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.ImageLoader = function (manager) {

  this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;

};

THREE.ImageLoader.prototype = {

  constructor: THREE.ImageLoader,

  load: function (url, onLoad, onProgress, onError) {

    var scope = this;

    var cached = THREE.Cache.get(url);

    if (cached !== undefined) {

      onLoad(cached);
      return;

    }

    var image = document.createElement('img');

    image.addEventListener('load', function (event) {

      THREE.Cache.add(url, this);

      if (onLoad) onLoad(this);

      scope.manager.itemEnd(url);

    }, false);

    if (onProgress !== undefined) {

      image.addEventListener('progress', function (event) {

        onProgress(event);

      }, false);

    }

    if (onError !== undefined) {

      image.addEventListener('error', function (event) {

        onError(event);

      }, false);

    }

    if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;

    image.src = url;

    scope.manager.itemStart(url);

    return image;

  },

  setCrossOrigin: function (value) {

    this.crossOrigin = value;

  }

};

// File:src/loaders/LoadingManager.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.LoadingManager = function (onLoad, onProgress, onError) {

  var scope = this;

  var loaded = 0,total = 0;

  this.onLoad = onLoad;
  this.onProgress = onProgress;
  this.onError = onError;

  this.itemStart = function (url) {

    total++;

  };

  this.itemEnd = function (url) {

    loaded++;

    if (scope.onProgress !== undefined) {

      scope.onProgress(url, loaded, total);

    }

    if (loaded === total && scope.onLoad !== undefined) {

      scope.onLoad();

    }

  };

};

THREE.DefaultLoadingManager = new THREE.LoadingManager();

// File:src/loaders/TextureLoader.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.TextureLoader = function (manager) {

  this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;

};

THREE.TextureLoader.prototype = {

  constructor: THREE.TextureLoader,

  load: function (url, onLoad, onProgress, onError) {

    var scope = this;

    var loader = new THREE.ImageLoader(scope.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.load(url, function (image) {

      var texture = new THREE.Texture(image);
      texture.needsUpdate = true;

      if (onLoad !== undefined) {

        onLoad(texture);

      }

    }, onProgress, onError);

  },

  setCrossOrigin: function (value) {

    this.crossOrigin = value;

  }

};

// File:src/loaders/BinaryTextureLoader.js

/**
 * @author Nikos M. / https://github.com/foo123/
 *
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 */

THREE.DataTextureLoader = THREE.BinaryTextureLoader = function () {

  // override in sub classes
  this._parser = null;

};

THREE.BinaryTextureLoader.prototype = {

  constructor: THREE.BinaryTextureLoader,

  load: function (url, onLoad, onProgress, onError) {

    var scope = this;

    var texture = new THREE.DataTexture();

    var loader = new THREE.XHRLoader();
    loader.setResponseType('arraybuffer');

    loader.load(url, function (buffer) {

      var texData = scope._parser(buffer);

      if (!texData) return;

      if (undefined !== texData.image) {

        texture.image = texData.image;

      } else if (undefined !== texData.data) {

        texture.image.width = texData.width;
        texture.image.height = texData.height;
        texture.image.data = texData.data;

      }

      texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : THREE.ClampToEdgeWrapping;
      texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : THREE.ClampToEdgeWrapping;

      texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : THREE.LinearFilter;
      texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : THREE.LinearMipMapLinearFilter;

      texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;

      if (undefined !== texData.format) {

        texture.format = texData.format;

      }
      if (undefined !== texData.type) {

        texture.type = texData.type;

      }

      if (undefined !== texData.mipmaps) {

        texture.mipmaps = texData.mipmaps;

      }

      if (1 === texData.mipmapCount) {

        texture.minFilter = THREE.LinearFilter;

      }

      texture.needsUpdate = true;

      if (onLoad) onLoad(texture, texData);

    }, onProgress, onError);


    return texture;

  }

};

// File:src/loaders/CompressedTextureLoader.js

/**
 * @author mrdoob / http://mrdoob.com/
 *
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 */

THREE.CompressedTextureLoader = function () {

  // override in sub classes
  this._parser = null;

};


THREE.CompressedTextureLoader.prototype = {

  constructor: THREE.CompressedTextureLoader,

  load: function (url, onLoad, onError) {

    var scope = this;

    var images = [];

    var texture = new THREE.CompressedTexture();
    texture.image = images;

    var loader = new THREE.XHRLoader();
    loader.setResponseType('arraybuffer');

    if (url instanceof Array) {

      var loaded = 0;

      var loadTexture = function (i) {

        loader.load(url[i], function (buffer) {

          var texDatas = scope._parser(buffer, true);

          images[i] = {
            width: texDatas.width,
            height: texDatas.height,
            format: texDatas.format,
            mipmaps: texDatas.mipmaps
          };

          loaded += 1;

          if (loaded === 6) {

            if (texDatas.mipmapCount == 1)
            texture.minFilter = THREE.LinearFilter;

            texture.format = texDatas.format;
            texture.needsUpdate = true;

            if (onLoad) onLoad(texture);

          }

        });

      };

      for (var i = 0, il = url.length; i < il; ++i) {

        loadTexture(i);

      }

    } else {

      // compressed cubemap texture stored in a single DDS file

      loader.load(url, function (buffer) {

        var texDatas = scope._parser(buffer, true);

        if (texDatas.isCubemap) {

          var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

          for (var f = 0; f < faces; f++) {

            images[f] = { mipmaps: [] };

            for (var i = 0; i < texDatas.mipmapCount; i++) {

              images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
              images[f].format = texDatas.format;
              images[f].width = texDatas.width;
              images[f].height = texDatas.height;

            }

          }

        } else {

          texture.image.width = texDatas.width;
          texture.image.height = texDatas.height;
          texture.mipmaps = texDatas.mipmaps;

        }

        if (texDatas.mipmapCount === 1) {

          texture.minFilter = THREE.LinearFilter;

        }

        texture.format = texDatas.format;
        texture.needsUpdate = true;

        if (onLoad) onLoad(texture);

      });

    }

    return texture;

  }

};

// File:src/materials/Material.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.Material = function () {

  Object.defineProperty(this, 'id', { value: THREE.MaterialIdCount++ });

  this.uuid = THREE.Math.generateUUID();

  this.name = '';
  this.type = 'Material';

  this.side = THREE.FrontSide;

  this.opacity = 1;
  this.transparent = false;

  this.blending = THREE.NormalBlending;

  this.blendSrc = THREE.SrcAlphaFactor;
  this.blendDst = THREE.OneMinusSrcAlphaFactor;
  this.blendEquation = THREE.AddEquation;
  this.blendSrcAlpha = null;
  this.blendDstAlpha = null;
  this.blendEquationAlpha = null;

  this.depthTest = true;
  this.depthWrite = true;

  this.colorWrite = true;

  this.polygonOffset = false;
  this.polygonOffsetFactor = 0;
  this.polygonOffsetUnits = 0;

  this.alphaTest = 0;

  this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer

  this.visible = true;

  this._needsUpdate = true; //used to trigger shader recompilation

  //TODO: A different solution for this may be needed for the WebGPU renderer, perhaps it can diff
  //the material internally somehow, but any approach that is not a single flag check would be slower
  this._uniformsNeedUpdate = true; //Used for the WebGPU renderer, which does not maintain a list of uniforms that have a needsUpdate flag each

};

THREE.Material.prototype = {

  constructor: THREE.Material,

  get needsUpdate() {

    return this._needsUpdate;

  },

  set needsUpdate(value) {

    this._needsUpdate = value;

    if (value === true) this.update();

  },

  get uniformsNeedUpdate() {

    return this._uniformsNeedUpdate;

  },

  set uniformsNeedUpdate(value) {

    this._uniformsNeedUpdate = value;

    if (value === true) this.update();

  },

  setValues: function (values) {

    if (values === undefined) return;

    for (var key in values) {

      var newValue = values[key];

      if (newValue === undefined) {

        THREE.warn("THREE.Material: '" + key + "' parameter is undefined.");
        continue;

      }

      if (key in this) {

        var currentValue = this[key];

        if (currentValue instanceof THREE.Color) {

          currentValue.set(newValue);

        } else if (currentValue instanceof THREE.Vector3 && newValue instanceof THREE.Vector3) {

          currentValue.copy(newValue);

        } else if (key == 'overdraw') {

          // ensure overdraw is backwards-compatable with legacy boolean type
          this[key] = Number(newValue);

        } else {

          this[key] = newValue;

        }

      }

    }

  },

  clone: function (material) {

    if (material === undefined) material = new THREE.Material();

    material.name = this.name;

    material.side = this.side;

    material.opacity = this.opacity;
    material.transparent = this.transparent;

    material.blending = this.blending;

    material.blendSrc = this.blendSrc;
    material.blendDst = this.blendDst;
    material.blendEquation = this.blendEquation;
    material.blendSrcAlpha = this.blendSrcAlpha;
    material.blendDstAlpha = this.blendDstAlpha;
    material.blendEquationAlpha = this.blendEquationAlpha;

    material.depthTest = this.depthTest;
    material.depthWrite = this.depthWrite;

    material.polygonOffset = this.polygonOffset;
    material.polygonOffsetFactor = this.polygonOffsetFactor;
    material.polygonOffsetUnits = this.polygonOffsetUnits;

    material.alphaTest = this.alphaTest;

    material.overdraw = this.overdraw;

    material.visible = this.visible;

    return material;

  },

  update: function () {

    this.dispatchEvent({ type: 'update' });

  },

  dispose: function () {

    this.dispatchEvent({ type: 'dispose' });

  }

};

THREE.EventDispatcher.prototype.apply(THREE.Material.prototype);

THREE.MaterialIdCount = 0;

// File:src/materials/LineBasicMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round",
 *
 *  vertexColors: <bool>
 *
 *  fog: <bool>
 * }
 */

THREE.LineBasicMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'LineBasicMaterial';

  this.color = new THREE.Color(0xffffff);

  this.linewidth = 1;
  this.linecap = 'round';
  this.linejoin = 'round';

  this.vertexColors = THREE.NoColors;

  this.fog = true;

  this.setValues(parameters);

};

THREE.LineBasicMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.LineBasicMaterial.prototype.constructor = THREE.LineBasicMaterial;

THREE.LineBasicMaterial.prototype.clone = function () {

  var material = new THREE.LineBasicMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);

  material.linewidth = this.linewidth;
  material.linecap = this.linecap;
  material.linejoin = this.linejoin;

  material.vertexColors = this.vertexColors;

  material.fog = this.fog;

  return material;

};

// File:src/materials/LineDashedMaterial.js

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>,
 *
 *  vertexColors: <bool>
 *
 *  fog: <bool>
 * }
 */

THREE.LineDashedMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'LineDashedMaterial';

  this.color = new THREE.Color(0xffffff);

  this.linewidth = 1;

  this.scale = 1;
  this.dashSize = 3;
  this.gapSize = 1;

  this.vertexColors = false;

  this.fog = true;

  this.setValues(parameters);

};

THREE.LineDashedMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.LineDashedMaterial.prototype.constructor = THREE.LineDashedMaterial;

THREE.LineDashedMaterial.prototype.clone = function () {

  var material = new THREE.LineDashedMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);

  material.linewidth = this.linewidth;

  material.scale = this.scale;
  material.dashSize = this.dashSize;
  material.gapSize = this.gapSize;

  material.vertexColors = this.vertexColors;

  material.fog = this.fog;

  return material;

};

// File:src/materials/MeshBasicMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  shading: THREE.SmoothShading,
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  vertexColors: THREE.NoColors / THREE.VertexColors / THREE.FaceColors,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *
 *  fog: <bool>
 * }
 */

THREE.MeshBasicMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'MeshBasicMaterial';

  this.color = new THREE.Color(0xffffff); // emissive

  this.map = null;

  this.lightMap = null;

  this.specularMap = null;

  this.alphaMap = null;

  this.envMap = null;
  this.combine = THREE.MultiplyOperation;
  this.reflectivity = 1;
  this.refractionRatio = 0.98;

  this.fog = true;

  this.shading = THREE.SmoothShading;

  this.wireframe = false;
  this.wireframeLinewidth = 1;
  this.wireframeLinecap = 'round';
  this.wireframeLinejoin = 'round';

  this.vertexColors = THREE.NoColors;

  this.skinning = false;
  this.morphTargets = false;

  this.setValues(parameters);

};

THREE.MeshBasicMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.MeshBasicMaterial.prototype.constructor = THREE.MeshBasicMaterial;

THREE.MeshBasicMaterial.prototype.clone = function () {

  var material = new THREE.MeshBasicMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);

  material.map = this.map;

  material.lightMap = this.lightMap;

  material.specularMap = this.specularMap;

  material.alphaMap = this.alphaMap;

  material.envMap = this.envMap;
  material.combine = this.combine;
  material.reflectivity = this.reflectivity;
  material.refractionRatio = this.refractionRatio;

  material.fog = this.fog;

  material.shading = this.shading;

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;
  material.wireframeLinecap = this.wireframeLinecap;
  material.wireframeLinejoin = this.wireframeLinejoin;

  material.vertexColors = this.vertexColors;

  material.skinning = this.skinning;
  material.morphTargets = this.morphTargets;

  return material;

};

// File:src/materials/MeshLambertMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  emissive: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  shading: THREE.SmoothShading,
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  vertexColors: THREE.NoColors / THREE.VertexColors / THREE.FaceColors,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *	fog: <bool>
 * }
 */

THREE.MeshLambertMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'MeshLambertMaterial';

  this.color = new THREE.Color(0xffffff); // diffuse
  this.emissive = new THREE.Color(0x000000);

  this.wrapAround = false;
  this.wrapRGB = new THREE.Vector3(1, 1, 1);

  this.map = null;

  this.lightMap = null;

  this.specularMap = null;

  this.alphaMap = null;

  this.envMap = null;
  this.combine = THREE.MultiplyOperation;
  this.reflectivity = 1;
  this.refractionRatio = 0.98;

  this.fog = true;

  this.shading = THREE.SmoothShading;

  this.wireframe = false;
  this.wireframeLinewidth = 1;
  this.wireframeLinecap = 'round';
  this.wireframeLinejoin = 'round';

  this.vertexColors = THREE.NoColors;

  this.skinning = false;
  this.morphTargets = false;
  this.morphNormals = false;

  this.setValues(parameters);

};

THREE.MeshLambertMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.MeshLambertMaterial.prototype.constructor = THREE.MeshLambertMaterial;

THREE.MeshLambertMaterial.prototype.clone = function () {

  var material = new THREE.MeshLambertMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);
  material.emissive.copy(this.emissive);

  material.wrapAround = this.wrapAround;
  material.wrapRGB.copy(this.wrapRGB);

  material.map = this.map;

  material.lightMap = this.lightMap;

  material.specularMap = this.specularMap;

  material.alphaMap = this.alphaMap;

  material.envMap = this.envMap;
  material.combine = this.combine;
  material.reflectivity = this.reflectivity;
  material.refractionRatio = this.refractionRatio;

  material.fog = this.fog;

  material.shading = this.shading;

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;
  material.wireframeLinecap = this.wireframeLinecap;
  material.wireframeLinejoin = this.wireframeLinejoin;

  material.vertexColors = this.vertexColors;

  material.skinning = this.skinning;
  material.morphTargets = this.morphTargets;
  material.morphNormals = this.morphNormals;

  return material;

};

// File:src/materials/MeshPhongMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  emissive: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  shading: THREE.SmoothShading,
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  vertexColors: THREE.NoColors / THREE.VertexColors / THREE.FaceColors,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *	fog: <bool>
 * }
 */

THREE.MeshPhongMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'MeshPhongMaterial';

  this.color = new THREE.Color(0xffffff); // diffuse
  this.emissive = new THREE.Color(0x000000);
  this.specular = new THREE.Color(0x111111);
  this.shininess = 30;

  this.metal = false;

  this.wrapAround = false;
  this.wrapRGB = new THREE.Vector3(1, 1, 1);

  this.map = null;

  this.lightMap = null;

  this.bumpMap = null;
  this.bumpScale = 1;

  this.normalMap = null;
  this.normalScale = new THREE.Vector2(1, 1);

  this.specularMap = null;

  this.alphaMap = null;

  this.envMap = null;
  this.combine = THREE.MultiplyOperation;
  this.reflectivity = 1;
  this.refractionRatio = 0.98;

  this.fog = true;

  this.shading = THREE.SmoothShading;

  this.wireframe = false;
  this.wireframeLinewidth = 1;
  this.wireframeLinecap = 'round';
  this.wireframeLinejoin = 'round';

  this.vertexColors = THREE.NoColors;

  this.skinning = false;
  this.morphTargets = false;
  this.morphNormals = false;

  this.setValues(parameters);

};

THREE.MeshPhongMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.MeshPhongMaterial.prototype.constructor = THREE.MeshPhongMaterial;

THREE.MeshPhongMaterial.prototype.clone = function () {

  var material = new THREE.MeshPhongMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);
  material.emissive.copy(this.emissive);
  material.specular.copy(this.specular);
  material.shininess = this.shininess;

  material.metal = this.metal;

  material.wrapAround = this.wrapAround;
  material.wrapRGB.copy(this.wrapRGB);

  material.map = this.map;

  material.lightMap = this.lightMap;

  material.bumpMap = this.bumpMap;
  material.bumpScale = this.bumpScale;

  material.normalMap = this.normalMap;
  material.normalScale.copy(this.normalScale);

  material.specularMap = this.specularMap;

  material.alphaMap = this.alphaMap;

  material.envMap = this.envMap;
  material.combine = this.combine;
  material.reflectivity = this.reflectivity;
  material.refractionRatio = this.refractionRatio;

  material.fog = this.fog;

  material.shading = this.shading;

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;
  material.wireframeLinecap = this.wireframeLinecap;
  material.wireframeLinejoin = this.wireframeLinejoin;

  material.vertexColors = this.vertexColors;

  material.skinning = this.skinning;
  material.morphTargets = this.morphTargets;
  material.morphNormals = this.morphNormals;

  return material;

};

// File:src/materials/MeshDepthMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  opacity: <float>,
 *
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */

THREE.MeshDepthMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'MeshDepthMaterial';

  this.morphTargets = false;
  this.wireframe = false;
  this.wireframeLinewidth = 1;

  this.setValues(parameters);

};

THREE.MeshDepthMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.MeshDepthMaterial.prototype.constructor = THREE.MeshDepthMaterial;

THREE.MeshDepthMaterial.prototype.clone = function () {

  var material = new THREE.MeshDepthMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;

  return material;

};

// File:src/materials/MeshNormalMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 *
 * parameters = {
 *  opacity: <float>,
 *
 *  shading: THREE.FlatShading,
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */

THREE.MeshNormalMaterial = function (parameters) {

  THREE.Material.call(this, parameters);

  this.type = 'MeshNormalMaterial';

  this.wireframe = false;
  this.wireframeLinewidth = 1;

  this.morphTargets = false;

  this.setValues(parameters);

};

THREE.MeshNormalMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.MeshNormalMaterial.prototype.constructor = THREE.MeshNormalMaterial;

THREE.MeshNormalMaterial.prototype.clone = function () {

  var material = new THREE.MeshNormalMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;

  return material;

};

// File:src/materials/PointCloudMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>,
 *
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  vertexColors: <bool>,
 *
 *  fog: <bool>
 * }
 */

THREE.PointCloudMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'PointCloudMaterial';

  this.color = new THREE.Color(0xffffff);

  this.map = null;

  this.size = 1;
  this.sizeAttenuation = true;

  this.vertexColors = THREE.NoColors;

  this.fog = true;

  this.setValues(parameters);

};

THREE.PointCloudMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.PointCloudMaterial.prototype.constructor = THREE.PointCloudMaterial;

THREE.PointCloudMaterial.prototype.clone = function () {

  var material = new THREE.PointCloudMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.color.copy(this.color);

  material.map = this.map;
  if (this.defines) {
    material.defines = Object.assign({}, this.defines);
  }

  material.size = this.size;
  material.sizeAttenuation = this.sizeAttenuation;

  material.vertexColors = this.vertexColors;

  material.fog = this.fog;

  return material;

};

// backwards compatibility

THREE.ParticleBasicMaterial = function (parameters) {

  THREE.warn('THREE.ParticleBasicMaterial has been renamed to THREE.PointCloudMaterial.');
  return new THREE.PointCloudMaterial(parameters);

};

// File:src/materials/ShaderMaterial.js

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { type: "f", value: 1.0 }, "parameter2": { type: "i" value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  shading: THREE.SmoothShading,
 *  blending: THREE.NormalBlending,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  vertexColors: THREE.NoColors / THREE.VertexColors / THREE.FaceColors,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *	fog: <bool>
 * }
 */

THREE.ShaderMaterial = function (parameters) {

  THREE.Material.call(this);

  this.type = 'ShaderMaterial';

  this.defines = {};
  this.uniforms = {};
  this.attributes = null;

  this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
  this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';

  this.shading = THREE.SmoothShading;

  this.linewidth = 1;

  this.wireframe = false;
  this.wireframeLinewidth = 1;

  this.fog = false; // set to use scene fog

  this.lights = false; // set to use scene lights

  this.vertexColors = THREE.NoColors; // set to use "color" attribute stream

  this.skinning = false; // set to use skinning attribute streams

  this.morphTargets = false; // set to use morph targets
  this.morphNormals = false; // set to use morph normals

  // When rendered geometry doesn't include these attributes but the material does,
  // use these default values in WebGL. This avoids errors when buffer data is missing.
  this.defaultAttributeValues = {
    'color': [1, 1, 1],
    'uv': [0, 0],
    'uv2': [0, 0]
  };

  this.index0AttributeName = undefined;

  this.setValues(parameters);

};

THREE.ShaderMaterial.prototype = Object.create(THREE.Material.prototype);
THREE.ShaderMaterial.prototype.constructor = THREE.ShaderMaterial;

THREE.ShaderMaterial.prototype.clone = function () {

  var material = new THREE.ShaderMaterial();

  THREE.Material.prototype.clone.call(this, material);

  material.fragmentShader = this.fragmentShader;
  material.vertexShader = this.vertexShader;

  material.uniforms = THREE.UniformsUtils.clone(this.uniforms);

  material.attributes = this.attributes;
  material.defines = this.defines;

  material.shading = this.shading;

  material.wireframe = this.wireframe;
  material.wireframeLinewidth = this.wireframeLinewidth;

  material.fog = this.fog;

  material.lights = this.lights;

  material.vertexColors = this.vertexColors;

  material.skinning = this.skinning;

  material.morphTargets = this.morphTargets;
  material.morphNormals = this.morphNormals;

  return material;

};

// File:src/materials/RawShaderMaterial.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.RawShaderMaterial = function (parameters) {

  THREE.ShaderMaterial.call(this, parameters);

  this.type = 'RawShaderMaterial';

};

THREE.RawShaderMaterial.prototype = Object.create(THREE.ShaderMaterial.prototype);
THREE.RawShaderMaterial.prototype.constructor = THREE.RawShaderMaterial;

THREE.RawShaderMaterial.prototype.clone = function () {

  var material = new THREE.RawShaderMaterial();

  THREE.ShaderMaterial.prototype.clone.call(this, material);

  return material;

};

// File:src/textures/Texture.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author szimek / https://github.com/szimek/
 */

THREE.Texture = function (image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {

  Object.defineProperty(this, 'id', { value: THREE.TextureIdCount++ });

  this.uuid = THREE.Math.generateUUID();

  this.name = '';
  this.sourceFile = '';

  this.image = image !== undefined ? image : THREE.Texture.DEFAULT_IMAGE;
  this.mipmaps = [];

  this.mapping = mapping !== undefined ? mapping : THREE.Texture.DEFAULT_MAPPING;

  this.wrapS = wrapS !== undefined ? wrapS : THREE.ClampToEdgeWrapping;
  this.wrapT = wrapT !== undefined ? wrapT : THREE.ClampToEdgeWrapping;

  this.magFilter = magFilter !== undefined ? magFilter : THREE.LinearFilter;
  this.minFilter = minFilter !== undefined ? minFilter : THREE.LinearMipMapLinearFilter;

  this.anisotropy = anisotropy !== undefined ? anisotropy : 1;

  this.format = format !== undefined ? format : THREE.RGBAFormat;
  this.type = type !== undefined ? type : THREE.UnsignedByteType;

  this.offset = new THREE.Vector2(0, 0);
  this.repeat = new THREE.Vector2(1, 1);

  this.generateMipmaps = true;
  this.premultiplyAlpha = false;
  this.flipY = true;
  this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

  this._needsUpdate = false;
  this.onUpdate = null;

};

THREE.Texture.DEFAULT_IMAGE = undefined;
THREE.Texture.DEFAULT_MAPPING = THREE.UVMapping;

THREE.Texture.prototype = {

  constructor: THREE.Texture,

  get needsUpdate() {

    return this._needsUpdate;

  },

  set needsUpdate(value) {

    if (value === true) this.update();

    this._needsUpdate = value;

  },

  clone: function (texture) {

    if (texture === undefined) texture = new THREE.Texture();

    texture.image = this.image;
    texture.mipmaps = this.mipmaps.slice(0);

    texture.mapping = this.mapping;

    texture.wrapS = this.wrapS;
    texture.wrapT = this.wrapT;

    texture.magFilter = this.magFilter;
    texture.minFilter = this.minFilter;

    texture.anisotropy = this.anisotropy;

    texture.format = this.format;
    texture.type = this.type;

    texture.offset.copy(this.offset);
    texture.repeat.copy(this.repeat);

    texture.generateMipmaps = this.generateMipmaps;
    texture.premultiplyAlpha = this.premultiplyAlpha;
    texture.flipY = this.flipY;
    texture.unpackAlignment = this.unpackAlignment;

    return texture;

  },

  update: function () {

    this.dispatchEvent({ type: 'update' });

  },

  dispose: function () {

    this.dispatchEvent({ type: 'dispose' });

  }

};

THREE.EventDispatcher.prototype.apply(THREE.Texture.prototype);

THREE.TextureIdCount = 0;

// File:src/textures/CubeTexture.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.CubeTexture = function (images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {

  mapping = mapping !== undefined ? mapping : THREE.CubeReflectionMapping;

  THREE.Texture.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);

  this.images = images;

};

THREE.CubeTexture.prototype = Object.create(THREE.Texture.prototype);
THREE.CubeTexture.prototype.constructor = THREE.CubeTexture;

THREE.CubeTexture.clone = function (texture) {

  if (texture === undefined) texture = new THREE.CubeTexture();

  THREE.Texture.prototype.clone.call(this, texture);

  texture.images = this.images;

  return texture;

};

// File:src/textures/CompressedTexture.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.CompressedTexture = function (mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy) {

  THREE.Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);

  this.image = { width: width, height: height };
  this.mipmaps = mipmaps;

  // no flipping for cube textures
  // (also flipping doesn't work for compressed textures )

  this.flipY = false;

  // can't generate mipmaps for compressed textures
  // mips must be embedded in DDS files

  this.generateMipmaps = false;

};

THREE.CompressedTexture.prototype = Object.create(THREE.Texture.prototype);
THREE.CompressedTexture.prototype.constructor = THREE.CompressedTexture;

THREE.CompressedTexture.prototype.clone = function () {

  var texture = new THREE.CompressedTexture();

  THREE.Texture.prototype.clone.call(this, texture);

  return texture;

};

// File:src/textures/DataTexture.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.DataTexture = function (data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy) {

  THREE.Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);

  this.image = { data: data, width: width, height: height };

};

THREE.DataTexture.prototype = Object.create(THREE.Texture.prototype);
THREE.DataTexture.prototype.constructor = THREE.DataTexture;

THREE.DataTexture.prototype.clone = function () {

  var texture = new THREE.DataTexture();

  THREE.Texture.prototype.clone.call(this, texture);

  return texture;

};

// File:src/objects/Group.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Group = function () {

  THREE.Object3D.call(this);

  this.type = 'Group';

};

THREE.Group.prototype = Object.create(THREE.Object3D.prototype);
THREE.Group.prototype.constructor = THREE.Group;

// File:src/objects/PointCloud.js

/**
 * @author alteredq / http://alteredqualia.com/
 */

THREE.PointCloud = function (geometry, material) {

  THREE.Object3D.call(this);

  this.type = 'PointCloud';

  this.geometry = geometry;
  this.material = material !== undefined ? material : new THREE.PointCloudMaterial({ color: Math.random() * 0xffffff });

};

THREE.PointCloud.prototype = Object.create(THREE.Object3D.prototype);
THREE.PointCloud.prototype.constructor = THREE.PointCloud;

THREE.PointCloud.prototype.raycast = function () {

  var inverseMatrix = new THREE.Matrix4();
  var ray = new THREE.Ray();

  return function (raycaster, intersects) {

    var object = this;
    var geometry = object.geometry;
    var threshold = raycaster.params.PointCloud.threshold;

    inverseMatrix.getInverse(this.matrixWorld);
    ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);

    if (geometry.boundingBox !== null) {

      if (ray.isIntersectionBox(geometry.boundingBox) === false) {

        return;

      }

    }

    var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    var position = new THREE.Vector3();

    var testPoint = function (point, index) {

      var rayPointDistance = ray.distanceToPoint(point);

      if (rayPointDistance < localThreshold) {

        var intersectPoint = ray.closestPointToPoint(point);
        intersectPoint.applyMatrix4(object.matrixWorld);

        var distance = raycaster.ray.origin.distanceTo(intersectPoint);

        intersects.push({

          distance: distance,
          distanceToRay: rayPointDistance,
          point: intersectPoint.clone(),
          index: index,
          face: null,
          object: object

        });

      }

    };

    if (geometry instanceof THREE.BufferGeometry) {

      var attributes = geometry.attributes;
      var positions = attributes.position.array;

      if (attributes.index !== undefined) {

        var indices = attributes.index.array;
        var offsets = geometry.offsets;

        if (offsets.length === 0) {

          var offset = {
            start: 0,
            count: indices.length,
            index: 0
          };

          offsets = [offset];

        }

        for (var oi = 0, ol = offsets.length; oi < ol; ++oi) {

          var start = offsets[oi].start;
          var count = offsets[oi].count;
          var index = offsets[oi].index;

          for (var i = start, il = start + count; i < il; i++) {

            var a = index + indices[i];

            position.fromArray(positions, a * 3);

            testPoint(position, a);

          }

        }

      } else {

        var pointCount = positions.length / 3;

        for (var i = 0; i < pointCount; i++) {

          position.set(
            positions[3 * i],
            positions[3 * i + 1],
            positions[3 * i + 2]
          );

          testPoint(position, i);

        }

      }

    } else {

      var vertices = this.geometry.vertices;

      for (var i = 0; i < vertices.length; i++) {

        testPoint(vertices[i], i);

      }

    }

  };

}();

THREE.PointCloud.prototype.clone = function (object) {

  if (object === undefined) object = new THREE.PointCloud(this.geometry, this.material);

  THREE.Object3D.prototype.clone.call(this, object);

  return object;

};

// File:src/objects/Line.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Line = function (geometry, material, mode) {

  THREE.Object3D.call(this);

  this.type = 'Line';

  this.geometry = geometry;
  this.material = material !== undefined ? material : new THREE.LineBasicMaterial({ color: Math.random() * 0xffffff });

  this.mode = mode !== undefined ? mode : THREE.LineStrip;

};

THREE.LineStrip = 0;
THREE.LinePieces = 1;

THREE.Line.prototype = Object.create(THREE.Object3D.prototype);
THREE.Line.prototype.constructor = THREE.Line;

// Backport for r90 Line.computeLineDistances https://github.com/mrdoob/three.js/commit/4b82ecc08bc22f9684c505ce30c3594bfc3b1627
// Copied from https://github.com/mrdoob/three.js/blob/r125/src/objects/Line.js#L46-L85
THREE.Line.prototype.computeLineDistances = function () {

  var start = new THREE.Vector3();
  var end = new THREE.Vector3();

  return function () {

    const geometry = this.geometry;

    // we assume non-indexed geometry

    if (geometry.index === null) {

      const positionAttribute = geometry.attributes.position;
      const lineDistances = [0];

      for (let i = 1, l = positionAttribute.count; i < l; i++) {

        start.fromBufferAttribute(positionAttribute, i - 1);
        end.fromBufferAttribute(positionAttribute, i);

        lineDistances[i] = lineDistances[i - 1];
        lineDistances[i] += start.distanceTo(end);

      }

      geometry.setAttribute('lineDistance', new THREE.Float32BufferAttribute(lineDistances, 1));

    } else {

      console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');

    }

    return this;

  };

}();

THREE.Line.prototype.raycast = function () {

  var inverseMatrix = new THREE.Matrix4();
  var ray = new THREE.Ray();
  var sphere = new THREE.Sphere();

  return function (raycaster, intersects) {

    var precision = raycaster.linePrecision;
    var precisionSq = precision * precision;

    var geometry = this.geometry;

    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

    // Checking boundingSphere distance to ray

    sphere.copy(geometry.boundingSphere);
    sphere.applyMatrix4(this.matrixWorld);

    if (raycaster.ray.isIntersectionSphere(sphere) === false) {

      return;

    }

    inverseMatrix.getInverse(this.matrixWorld);
    ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);

    var vStart = new THREE.Vector3();
    var vEnd = new THREE.Vector3();
    var interSegment = new THREE.Vector3();
    var interRay = new THREE.Vector3();
    var step = this.mode === THREE.LineStrip ? 1 : 2;

    if (geometry instanceof THREE.BufferGeometry) {

      var attributes = geometry.attributes;

      if (attributes.index !== undefined) {

        var indices = attributes.index.array;
        var positions = attributes.position.array;
        var offsets = geometry.offsets;

        if (offsets.length === 0) {

          offsets = [{ start: 0, count: indices.length, index: 0 }];

        }

        for (var oi = 0; oi < offsets.length; oi++) {

          var start = offsets[oi].start;
          var count = offsets[oi].count;
          var index = offsets[oi].index;

          for (var i = start; i < start + count - 1; i += step) {

            var a = index + indices[i];
            var b = index + indices[i + 1];

            vStart.fromArray(positions, a * 3);
            vEnd.fromArray(positions, b * 3);

            var distSq = ray.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

            if (distSq > precisionSq) continue;

            var distance = ray.origin.distanceTo(interRay);

            if (distance < raycaster.near || distance > raycaster.far) continue;

            intersects.push({

              distance: distance,
              // What do we want? intersection point on the ray or on the segment??
              // point: raycaster.ray.at( distance ),
              point: interSegment.clone().applyMatrix4(this.matrixWorld),
              index: i,
              offsetIndex: oi,
              face: null,
              faceIndex: null,
              object: this

            });

          }

        }

      } else {

        var positions = attributes.position.array;

        for (var i = 0; i < positions.length / 3 - 1; i += step) {

          vStart.fromArray(positions, 3 * i);
          vEnd.fromArray(positions, 3 * i + 3);

          var distSq = ray.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

          if (distSq > precisionSq) continue;

          var distance = ray.origin.distanceTo(interRay);

          if (distance < raycaster.near || distance > raycaster.far) continue;

          intersects.push({

            distance: distance,
            // What do we want? intersection point on the ray or on the segment??
            // point: raycaster.ray.at( distance ),
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i,
            face: null,
            faceIndex: null,
            object: this

          });

        }

      }

    }

  };

}();

THREE.Line.prototype.clone = function (object) {

  if (object === undefined) object = new THREE.Line(this.geometry, this.material, this.mode);

  THREE.Object3D.prototype.clone.call(this, object);

  return object;

};

// File:src/objects/Mesh.js

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author jonobr1 / http://jonobr1.com/
 */

THREE.Mesh = function (geometry, material) {

  THREE.Object3D.call(this);

  this.type = 'Mesh';

  this.geometry = geometry;
  this.material = material !== undefined ? material : new THREE.MeshBasicMaterial({ color: Math.random() * 0xffffff });

};

THREE.Mesh.prototype = Object.create(THREE.Object3D.prototype);
THREE.Mesh.prototype.constructor = THREE.Mesh;

THREE.Mesh.prototype.raycast = function () {

  var inverseMatrix = new THREE.Matrix4();
  var ray = new THREE.Ray();
  var sphere = new THREE.Sphere();

  var vA = new THREE.Vector3();
  var vB = new THREE.Vector3();
  var vC = new THREE.Vector3();

  return function (raycaster, intersects) {

    var geometry = this.geometry;

    // Checking boundingSphere distance to ray

    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

    sphere.copy(geometry.boundingSphere);
    sphere.applyMatrix4(this.matrixWorld);

    if (raycaster.ray.isIntersectionSphere(sphere) === false) {

      return;

    }

    // Check boundingBox before continuing

    inverseMatrix.getInverse(this.matrixWorld);
    ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);

    if (geometry.boundingBox !== null) {

      if (ray.isIntersectionBox(geometry.boundingBox) === false) {

        return;

      }

    }

    if (geometry instanceof THREE.BufferGeometry) {

      var material = this.material;

      if (material === undefined) return;

      var attributes = geometry.attributes;

      var a, b, c;
      var precision = raycaster.precision;

      if (attributes.index !== undefined) {

        var indices = attributes.index.array;
        var positions = attributes.position.array;
        var offsets = geometry.offsets;

        if (offsets.length === 0) {

          offsets = [{ start: 0, count: indices.length, index: 0 }];

        }

        for (var oi = 0, ol = offsets.length; oi < ol; ++oi) {

          var start = offsets[oi].start;
          var count = offsets[oi].count;
          var index = offsets[oi].index;

          for (var i = start, il = start + count; i < il; i += 3) {

            a = index + indices[i];
            b = index + indices[i + 1];
            c = index + indices[i + 2];

            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);

            if (material.side === THREE.BackSide) {

              var intersectionPoint = ray.intersectTriangle(vC, vB, vA, true);

            } else {

              var intersectionPoint = ray.intersectTriangle(vA, vB, vC, material.side !== THREE.DoubleSide);

            }

            if (intersectionPoint === null) continue;

            intersectionPoint.applyMatrix4(this.matrixWorld);

            var distance = raycaster.ray.origin.distanceTo(intersectionPoint);

            if (distance < precision || distance < raycaster.near || distance > raycaster.far) continue;

            intersects.push({

              distance: distance,
              point: intersectionPoint,
              face: new THREE.Face3(a, b, c, THREE.Triangle.normal(vA, vB, vC)),
              faceIndex: null,
              object: this

            });

          }

        }

      } else {

        var positions = attributes.position.array;

        for (var i = 0, j = 0, il = positions.length; i < il; i += 3, j += 9) {

          a = i;
          b = i + 1;
          c = i + 2;

          vA.fromArray(positions, j);
          vB.fromArray(positions, j + 3);
          vC.fromArray(positions, j + 6);

          if (material.side === THREE.BackSide) {

            var intersectionPoint = ray.intersectTriangle(vC, vB, vA, true);

          } else {

            var intersectionPoint = ray.intersectTriangle(vA, vB, vC, material.side !== THREE.DoubleSide);

          }

          if (intersectionPoint === null) continue;

          intersectionPoint.applyMatrix4(this.matrixWorld);

          var distance = raycaster.ray.origin.distanceTo(intersectionPoint);

          if (distance < precision || distance < raycaster.near || distance > raycaster.far) continue;

          intersects.push({

            distance: distance,
            point: intersectionPoint,
            face: new THREE.Face3(a, b, c, THREE.Triangle.normal(vA, vB, vC)),
            faceIndex: null,
            object: this

          });

        }

      }

    }

  };

}();

THREE.Mesh.prototype.clone = function (object, recursive) {

  if (object === undefined) object = new THREE.Mesh(this.geometry, this.material);

  THREE.Object3D.prototype.clone.call(this, object, recursive);

  return object;

};

// File:src/scenes/Scene.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.Scene = function () {

  THREE.Object3D.call(this);

  this.type = 'Scene';

  this.fog = null;
  this.overrideMaterial = null;

  this.autoUpdate = true; // checked by the renderer

};

THREE.Scene.prototype = Object.create(THREE.Object3D.prototype);
THREE.Scene.prototype.constructor = THREE.Scene;

THREE.Scene.prototype.clone = function (object) {

  if (object === undefined) object = new THREE.Scene();

  THREE.Object3D.prototype.clone.call(this, object);

  if (this.fog !== null) object.fog = this.fog.clone();
  if (this.overrideMaterial !== null) object.overrideMaterial = this.overrideMaterial.clone();

  object.autoUpdate = this.autoUpdate;
  object.matrixAutoUpdate = this.matrixAutoUpdate;

  return object;

};

// File:src/renderers/shaders/ShaderChunk.js

THREE.ShaderChunk = {};

// File:src/renderers/shaders/ShaderChunk/common.glsl

THREE.ShaderChunk['common'] = "#define PI 3.14159\n#define PI2 6.28318\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n\nfloat square( in float a ) { return a*a; }\nvec2  square( in vec2 a )  { return vec2( a.x*a.x, a.y*a.y ); }\nvec3  square( in vec3 a )  { return vec3( a.x*a.x, a.y*a.y, a.z*a.z ); }\nvec4  square( in vec4 a )  { return vec4( a.x*a.x, a.y*a.y, a.z*a.z, a.w*a.w ); }\nfloat saturate( in float a ) { return clamp( a, 0.0, 1.0 ); }\nvec2  saturate( in vec2 a )  { return clamp( a, 0.0, 1.0 ); }\nvec3  saturate( in vec3 a )  { return clamp( a, 0.0, 1.0 ); }\nvec4  saturate( in vec4 a )  { return clamp( a, 0.0, 1.0 ); }\nfloat average( in float a ) { return a; }\nfloat average( in vec2 a )  { return ( a.x + a.y) * 0.5; }\nfloat average( in vec3 a )  { return ( a.x + a.y + a.z) / 3.0; }\nfloat average( in vec4 a )  { return ( a.x + a.y + a.z + a.w) * 0.25; }\nfloat whiteCompliment( in float a ) { return saturate( 1.0 - a ); }\nvec2  whiteCompliment( in vec2 a )  { return saturate( vec2(1.0) - a ); }\nvec3  whiteCompliment( in vec3 a )  { return saturate( vec3(1.0) - a ); }\nvec4  whiteCompliment( in vec4 a )  { return saturate( vec4(1.0) - a ); }\nvec3 transformDirection( in vec3 normal, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( normal, 0.0 ) ).xyz );\n}\n// http://en.wikibooks.org/wiki/GLSL_Programming/Applying_Matrix_Transformations\nvec3 inverseTransformDirection( in vec3 normal, in mat4 matrix ) {\n	return normalize( ( vec4( normal, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal) {\n	float distance = dot( planeNormal, point-pointOnPlane );\n	return point - distance * planeNormal;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return pointOnLine + lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) );\n}\nfloat calcLightAttenuation( float lightDistance, float cutoffDistance, float decayExponent ) {\n	if ( decayExponent > 0.0 ) {\n	  return pow( saturate( 1.0 - lightDistance / cutoffDistance ), decayExponent );\n	}\n	return 1.0;\n}\n\nvec3 inputToLinear( in vec3 a ) {\n#ifdef GAMMA_INPUT\n	return pow( a, vec3( float( GAMMA_FACTOR ) ) );\n#else\n	return a;\n#endif\n}\nvec3 linearToOutput( in vec3 a ) {\n#ifdef GAMMA_OUTPUT\n	return pow( a, vec3( 1.0 / float( GAMMA_FACTOR ) ) );\n#else\n	return a;\n#endif\n}\n";

// File:src/renderers/shaders/ShaderChunk/alphatest_fragment.glsl

THREE.ShaderChunk['alphatest_fragment'] = "#ifdef ALPHATEST\n\n	if ( diffuseColor.a < ALPHATEST ) discard;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/lights_lambert_vertex.glsl

THREE.ShaderChunk['lights_lambert_vertex'] = "vLightFront = vec3( 0.0 );\n\n#ifdef DOUBLE_SIDED\n\n	vLightBack = vec3( 0.0 );\n\n#endif\n\ntransformedNormal = normalize( transformedNormal );\n\n#if MAX_DIR_LIGHTS > 0\n\nfor( int i = 0; i < MAX_DIR_LIGHTS; i ++ ) {\n\n	vec3 dirVector = transformDirection( directionalLightDirection[ i ], viewMatrix );\n\n	float dotProduct = dot( transformedNormal, dirVector );\n	vec3 directionalLightWeighting = vec3( max( dotProduct, 0.0 ) );\n\n	#ifdef DOUBLE_SIDED\n\n		vec3 directionalLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n\n		#ifdef WRAP_AROUND\n\n			vec3 directionalLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n\n		#endif\n\n	#endif\n\n	#ifdef WRAP_AROUND\n\n		vec3 directionalLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\n		directionalLightWeighting = mix( directionalLightWeighting, directionalLightWeightingHalf, wrapRGB );\n\n		#ifdef DOUBLE_SIDED\n\n			directionalLightWeightingBack = mix( directionalLightWeightingBack, directionalLightWeightingHalfBack, wrapRGB );\n\n		#endif\n\n	#endif\n\n	vLightFront += directionalLightColor[ i ] * directionalLightWeighting;\n\n	#ifdef DOUBLE_SIDED\n\n		vLightBack += directionalLightColor[ i ] * directionalLightWeightingBack;\n\n	#endif\n\n}\n\n#endif\n\n#if MAX_POINT_LIGHTS > 0\n\n	for( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\n\n		vec4 lPosition = viewMatrix * vec4( pointLightPosition[ i ], 1.0 );\n		vec3 lVector = lPosition.xyz - mvPosition.xyz;\n\n		float attenuation = calcLightAttenuation( length( lVector ), pointLightDistance[ i ], pointLightDecay[ i ] );\n\n		lVector = normalize( lVector );\n		float dotProduct = dot( transformedNormal, lVector );\n\n		vec3 pointLightWeighting = vec3( max( dotProduct, 0.0 ) );\n\n		#ifdef DOUBLE_SIDED\n\n			vec3 pointLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n\n			#ifdef WRAP_AROUND\n\n				vec3 pointLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n\n			#endif\n\n		#endif\n\n		#ifdef WRAP_AROUND\n\n			vec3 pointLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\n			pointLightWeighting = mix( pointLightWeighting, pointLightWeightingHalf, wrapRGB );\n\n			#ifdef DOUBLE_SIDED\n\n				pointLightWeightingBack = mix( pointLightWeightingBack, pointLightWeightingHalfBack, wrapRGB );\n\n			#endif\n\n		#endif\n\n		vLightFront += pointLightColor[ i ] * pointLightWeighting * attenuation;\n\n		#ifdef DOUBLE_SIDED\n\n			vLightBack += pointLightColor[ i ] * pointLightWeightingBack * attenuation;\n\n		#endif\n\n	}\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n	for( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\n\n		vec4 lPosition = viewMatrix * vec4( spotLightPosition[ i ], 1.0 );\n		vec3 lVector = lPosition.xyz - mvPosition.xyz;\n\n		float spotEffect = dot( spotLightDirection[ i ], normalize( spotLightPosition[ i ] - worldPosition.xyz ) );\n\n		if ( spotEffect > spotLightAngleCos[ i ] ) {\n\n			spotEffect = max( pow( max( spotEffect, 0.0 ), spotLightExponent[ i ] ), 0.0 );\n\n			float attenuation = calcLightAttenuation( length( lVector ), spotLightDistance[ i ], spotLightDecay[ i ] );\n\n			lVector = normalize( lVector );\n\n			float dotProduct = dot( transformedNormal, lVector );\n			vec3 spotLightWeighting = vec3( max( dotProduct, 0.0 ) );\n\n			#ifdef DOUBLE_SIDED\n\n				vec3 spotLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n\n				#ifdef WRAP_AROUND\n\n					vec3 spotLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n\n				#endif\n\n			#endif\n\n			#ifdef WRAP_AROUND\n\n				vec3 spotLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\n				spotLightWeighting = mix( spotLightWeighting, spotLightWeightingHalf, wrapRGB );\n\n				#ifdef DOUBLE_SIDED\n\n					spotLightWeightingBack = mix( spotLightWeightingBack, spotLightWeightingHalfBack, wrapRGB );\n\n				#endif\n\n			#endif\n\n			vLightFront += spotLightColor[ i ] * spotLightWeighting * attenuation * spotEffect;\n\n			#ifdef DOUBLE_SIDED\n\n				vLightBack += spotLightColor[ i ] * spotLightWeightingBack * attenuation * spotEffect;\n\n			#endif\n\n		}\n\n	}\n\n#endif\n\n#if MAX_HEMI_LIGHTS > 0\n\n	for( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {\n\n		vec3 lVector = transformDirection( hemisphereLightDirection[ i ], viewMatrix );\n\n		float dotProduct = dot( transformedNormal, lVector );\n\n		float hemiDiffuseWeight = 0.5 * dotProduct + 0.5;\n		float hemiDiffuseWeightBack = -0.5 * dotProduct + 0.5;\n\n		vLightFront += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );\n\n		#ifdef DOUBLE_SIDED\n\n			vLightBack += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeightBack );\n\n		#endif\n\n	}\n\n#endif\n\nvLightFront += ambientLightColor;\n\n#ifdef DOUBLE_SIDED\n\n	vLightBack += ambientLightColor;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/map_particle_pars_fragment.glsl

THREE.ShaderChunk['map_particle_pars_fragment'] = "#ifdef USE_MAP\n\n	uniform vec4 offsetRepeat;\n	uniform sampler2D map;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/default_vertex.glsl

THREE.ShaderChunk['default_vertex'] = "#ifdef USE_SKINNING\n\n	vec4 mvPosition = modelViewMatrix * skinned;\n\n#elif defined( USE_MORPHTARGETS )\n\n	vec4 mvPosition = modelViewMatrix * vec4( morphed, 1.0 );\n\n#else\n\n	vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\n#endif\n\ngl_Position = projectionMatrix * mvPosition;\n";

// File:src/renderers/shaders/ShaderChunk/map_pars_fragment.glsl

THREE.ShaderChunk['map_pars_fragment'] = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP )\n\n	varying vec2 vUv;\n\n#endif\n\n#ifdef USE_MAP\n\n	uniform sampler2D map;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/logdepthbuf_pars_vertex.glsl

THREE.ShaderChunk['logdepthbuf_pars_vertex'] = "#ifdef USE_LOGDEPTHBUF\n\n	#ifdef USE_LOGDEPTHBUF_EXT\n\n		varying float vFragDepth;\n\n	#endif\n\n	uniform float logDepthBufFC;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/lightmap_pars_vertex.glsl

THREE.ShaderChunk['lightmap_pars_vertex'] = "#ifdef USE_LIGHTMAP\n\n	varying vec2 vUv2;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/envmap_pars_fragment.glsl

THREE.ShaderChunk['envmap_pars_fragment'] = "#ifdef USE_ENVMAP\n\n	uniform float reflectivity;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	uniform float flipEnvMap;\n\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\n		uniform float refractionRatio;\n\n	#else\n\n		varying vec3 vReflect;\n\n	#endif\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/logdepthbuf_fragment.glsl

THREE.ShaderChunk['logdepthbuf_fragment'] = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\n	gl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/lightmap_pars_fragment.glsl

THREE.ShaderChunk['lightmap_pars_fragment'] = "#ifdef USE_LIGHTMAP\n\n	varying vec2 vUv2;\n	uniform sampler2D lightMap;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/map_fragment.glsl

THREE.ShaderChunk['map_fragment'] = "#ifdef USE_MAP\n\n	vec4 texelColor = texture2D( map, vUv );\n\n	texelColor.xyz = inputToLinear( texelColor.xyz );\n\n	diffuseColor *= texelColor;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/lightmap_vertex.glsl

THREE.ShaderChunk['lightmap_vertex'] = "#ifdef USE_LIGHTMAP\n\n	vUv2 = uv2;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/map_particle_fragment.glsl

THREE.ShaderChunk['map_particle_fragment'] = "#ifdef USE_MAP\n\n	diffuseColor *= texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/color_pars_fragment.glsl

THREE.ShaderChunk['color_pars_fragment'] = "#ifdef USE_COLOR\n\n	varying vec3 vColor;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/color_vertex.glsl

THREE.ShaderChunk['color_vertex'] = "#ifdef USE_COLOR\n\n	vColor.xyz = inputToLinear( color.xyz );\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/envmap_pars_vertex.glsl

THREE.ShaderChunk['envmap_pars_vertex'] = "#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP ) && ! defined( PHONG )\n\n	varying vec3 vReflect;\n\n	uniform float refractionRatio;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/linear_to_gamma_fragment.glsl

THREE.ShaderChunk['linear_to_gamma_fragment'] = "\n	outgoingLight = linearToOutput( outgoingLight );\n";

// File:src/renderers/shaders/ShaderChunk/color_pars_vertex.glsl

THREE.ShaderChunk['color_pars_vertex'] = "#ifdef USE_COLOR\n\n	varying vec3 vColor;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/lights_lambert_pars_vertex.glsl

THREE.ShaderChunk['lights_lambert_pars_vertex'] = "uniform vec3 ambientLightColor;\n\n#if MAX_DIR_LIGHTS > 0\n\n	uniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];\n	uniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];\n\n#endif\n\n#if MAX_HEMI_LIGHTS > 0\n\n	uniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];\n	uniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];\n	uniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];\n\n#endif\n\n#if MAX_POINT_LIGHTS > 0\n\n	uniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];\n	uniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\n	uniform float pointLightDistance[ MAX_POINT_LIGHTS ];\n	uniform float pointLightDecay[ MAX_POINT_LIGHTS ];\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n	uniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];\n	uniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\n	uniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];\n	uniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\n	uniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];\n	uniform float spotLightExponent[ MAX_SPOT_LIGHTS ];\n	uniform float spotLightDecay[ MAX_SPOT_LIGHTS ];\n\n#endif\n\n#ifdef WRAP_AROUND\n\n	uniform vec3 wrapRGB;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/map_pars_vertex.glsl

THREE.ShaderChunk['map_pars_vertex'] = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP )\n\n	varying vec2 vUv;\n	uniform vec4 offsetRepeat;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/envmap_fragment.glsl

THREE.ShaderChunk['envmap_fragment'] = "#ifdef USE_ENVMAP\n\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\n		vec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\n		// Transforming Normal Vectors with the Inverse Transformation\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\n		#ifdef ENVMAP_MODE_REFLECTION\n\n			vec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\n		#else\n\n			vec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\n		#endif\n\n	#else\n\n		vec3 reflectVec = vReflect;\n\n	#endif\n\n	#ifdef DOUBLE_SIDED\n		float flipNormal = ( -1.0 + 2.0 * float( gl_FrontFacing ) );\n	#else\n		float flipNormal = 1.0;\n	#endif\n\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\n	#elif defined( ENVMAP_TYPE_EQUIREC )\n		vec2 sampleUV;\n		sampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n		sampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n		vec4 envColor = texture2D( envMap, sampleUV );\n\n	#elif defined( ENVMAP_TYPE_SPHERE )\n		vec3 reflectView = flipNormal * normalize((viewMatrix * vec4( reflectVec, 0.0 )).xyz + vec3(0.0,0.0,1.0));\n		vec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n	#endif\n\n	envColor.xyz = inputToLinear( envColor.xyz );\n\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\n	#elif defined( ENVMAP_BLENDING_MIX )\n\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\n	#elif defined( ENVMAP_BLENDING_ADD )\n\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n\n	#endif\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/specularmap_pars_fragment.glsl

THREE.ShaderChunk['specularmap_pars_fragment'] = "#ifdef USE_SPECULARMAP\n\n	uniform sampler2D specularMap;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/logdepthbuf_vertex.glsl

THREE.ShaderChunk['logdepthbuf_vertex'] = "#ifdef USE_LOGDEPTHBUF\n\n	gl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\n	#ifdef USE_LOGDEPTHBUF_EXT\n\n		vFragDepth = 1.0 + gl_Position.w;\n\n#else\n\n		gl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\n	#endif\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/specularmap_fragment.glsl

THREE.ShaderChunk['specularmap_fragment'] = "float specularStrength;\n\n#ifdef USE_SPECULARMAP\n\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n\n#else\n\n	specularStrength = 1.0;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/bumpmap_pars_fragment.glsl

THREE.ShaderChunk['bumpmap_pars_fragment'] = "#ifdef USE_BUMPMAP\n\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n\n	// Derivative maps - bump mapping unparametrized surfaces by Morten Mikkelsen\n	// http://mmikkelsen3d.blogspot.sk/2011/07/derivative-maps.html\n\n	// Evaluate the derivative of the height w.r.t. screen-space using forward differencing (listing 2)\n\n	vec2 dHdxy_fwd() {\n\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\n		return vec2( dBx, dBy );\n\n	}\n\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\n		vec3 vSigmaX = dFdx( surf_pos );\n		vec3 vSigmaY = dFdy( surf_pos );\n		vec3 vN = surf_norm;		// normalized\n\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n\n		float fDet = dot( vSigmaX, R1 );\n\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n\n	}\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/defaultnormal_vertex.glsl

THREE.ShaderChunk['defaultnormal_vertex'] = "#ifdef USE_SKINNING\n\n	vec3 objectNormal = skinnedNormal.xyz;\n\n#elif defined( USE_MORPHNORMALS )\n\n	vec3 objectNormal = morphedNormal;\n\n#else\n\n	vec3 objectNormal = normal;\n\n#endif\n\n#ifdef FLIP_SIDED\n\n	objectNormal = -objectNormal;\n\n#endif\n\nvec3 transformedNormal = normalMatrix * objectNormal;\n";

// File:src/renderers/shaders/ShaderChunk/map_vertex.glsl

THREE.ShaderChunk['map_vertex'] = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP )\n\n	vUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/lightmap_fragment.glsl

THREE.ShaderChunk['lightmap_fragment'] = "#ifdef USE_LIGHTMAP\n\n	outgoingLight *= diffuseColor.xyz * texture2D( lightMap, vUv2 ).xyz;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/color_fragment.glsl

THREE.ShaderChunk['color_fragment'] = "#ifdef USE_COLOR\n\n	diffuseColor.rgb *= vColor;\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/envmap_vertex.glsl

THREE.ShaderChunk['envmap_vertex'] = "#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP ) && ! defined( PHONG )\n\n	vec3 worldNormal = transformDirection( objectNormal, modelMatrix );\n\n	vec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\n	#ifdef ENVMAP_MODE_REFLECTION\n\n		vReflect = reflect( cameraToVertex, worldNormal );\n\n	#else\n\n		vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\n	#endif\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/worldpos_vertex.glsl

THREE.ShaderChunk['worldpos_vertex'] = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\n	#ifdef USE_SKINNING\n\n		vec4 worldPosition = modelMatrix * skinned;\n\n	#elif defined( USE_MORPHTARGETS )\n\n		vec4 worldPosition = modelMatrix * vec4( morphed, 1.0 );\n\n	#else\n\n		vec4 worldPosition = modelMatrix * vec4( position, 1.0 );\n\n	#endif\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/logdepthbuf_pars_fragment.glsl

THREE.ShaderChunk['logdepthbuf_pars_fragment'] = "#ifdef USE_LOGDEPTHBUF\n\n	uniform float logDepthBufFC;\n\n	#ifdef USE_LOGDEPTHBUF_EXT\n\n		#extension GL_EXT_frag_depth : enable\n		varying float vFragDepth;\n\n	#endif\n\n#endif";

// File:src/renderers/shaders/ShaderChunk/alphamap_fragment.glsl

THREE.ShaderChunk['alphamap_fragment'] = "#ifdef USE_ALPHAMAP\n\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n\n#endif\n";

// File:src/renderers/shaders/ShaderChunk/alphamap_pars_fragment.glsl

THREE.ShaderChunk['alphamap_pars_fragment'] = "#ifdef USE_ALPHAMAP\n\n	uniform sampler2D alphaMap;\n\n#endif\n";

// File:src/renderers/shaders/UniformsUtils.js

/**
 * Uniform Utilities
 */

THREE.UniformsUtils = {

  merge: function (uniforms) {

    var merged = {};

    for (var u = 0; u < uniforms.length; u++) {

      var tmp = this.clone(uniforms[u]);

      for (var p in tmp) {

        merged[p] = tmp[p];

      }

    }

    return merged;

  },

  clone: function (uniforms_src) {

    var uniforms_dst = {};

    for (var u in uniforms_src) {

      uniforms_dst[u] = {};

      for (var p in uniforms_src[u]) {

        var parameter_src = uniforms_src[u][p];

        if (parameter_src instanceof THREE.Color ||
        parameter_src instanceof THREE.Vector2 ||
        parameter_src instanceof THREE.Vector3 ||
        parameter_src instanceof THREE.Vector4 ||
        parameter_src instanceof THREE.Matrix4 ||
        parameter_src instanceof THREE.Texture) {

          uniforms_dst[u][p] = parameter_src.clone();

        } else if (parameter_src instanceof Array) {

          uniforms_dst[u][p] = parameter_src.slice();

        } else {

          uniforms_dst[u][p] = parameter_src;

        }

      }

    }

    return uniforms_dst;

  }

};

// File:src/renderers/shaders/UniformsLib.js

/**
 * Uniforms library for shared webgl shaders
 */

THREE.UniformsLib = {

  common: {

    "diffuse": { type: "c", value: new THREE.Color(0xeeeeee) },
    "opacity": { type: "f", value: 1.0 },

    "map": { type: "t", value: null },
    "offsetRepeat": { type: "v4", value: new THREE.Vector4(0, 0, 1, 1) },

    "lightMap": { type: "t", value: null },
    "specularMap": { type: "t", value: null },
    "alphaMap": { type: "t", value: null },

    "envMap": { type: "t", value: null },
    "flipEnvMap": { type: "f", value: -1 },
    "reflectivity": { type: "f", value: 1.0 },
    "refractionRatio": { type: "f", value: 0.98 },

    "morphTargetInfluences": { type: "f", value: 0 }

  },

  bump: {

    "bumpMap": { type: "t", value: null },
    "bumpScale": { type: "f", value: 1 }

  },

  normalmap: {

    "normalMap": { type: "t", value: null },
    "normalScale": { type: "v2", value: new THREE.Vector2(1, 1) }
  },

  fog: {

    "fogDensity": { type: "f", value: 0.00025 },
    "fogNear": { type: "f", value: 1 },
    "fogFar": { type: "f", value: 2000 },
    "fogColor": { type: "c", value: new THREE.Color(0xffffff) }

  },

  lights: {

    "ambientLightColor": { type: "fv", value: [] },

    "directionalLightDirection": { type: "fv", value: [] },
    "directionalLightColor": { type: "fv", value: [] },

    "hemisphereLightDirection": { type: "fv", value: [] },
    "hemisphereLightSkyColor": { type: "fv", value: [] },
    "hemisphereLightGroundColor": { type: "fv", value: [] },

    "pointLightColor": { type: "fv", value: [] },
    "pointLightPosition": { type: "fv", value: [] },
    "pointLightDistance": { type: "fv1", value: [] },
    "pointLightDecay": { type: "fv1", value: [] },

    "spotLightColor": { type: "fv", value: [] },
    "spotLightPosition": { type: "fv", value: [] },
    "spotLightDirection": { type: "fv", value: [] },
    "spotLightDistance": { type: "fv1", value: [] },
    "spotLightAngleCos": { type: "fv1", value: [] },
    "spotLightExponent": { type: "fv1", value: [] },
    "spotLightDecay": { type: "fv1", value: [] }

  },

  particle: {

    "psColor": { type: "c", value: new THREE.Color(0xeeeeee) },
    "opacity": { type: "f", value: 1.0 },
    "size": { type: "f", value: 1.0 },
    "scale": { type: "f", value: 1.0 },
    "map": { type: "t", value: null },
    "offsetRepeat": { type: "v4", value: new THREE.Vector4(0, 0, 1, 1) },

    "fogDensity": { type: "f", value: 0.00025 },
    "fogNear": { type: "f", value: 1 },
    "fogFar": { type: "f", value: 2000 },
    "fogColor": { type: "c", value: new THREE.Color(0xffffff) }

  }

};

// File:src/renderers/shaders/ShaderLib.js

/**
 * Webgl Shader Library for three.js
 *
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 */


THREE.ShaderLib = {

  'lambert': {

    uniforms: THREE.UniformsUtils.merge([

    THREE.UniformsLib["common"],
    THREE.UniformsLib["fog"],
    THREE.UniformsLib["lights"],

    {
      "emissive": { type: "c", value: new THREE.Color(0x000000) },
      "wrapRGB": { type: "v3", value: new THREE.Vector3(1, 1, 1) }
    }]

    ),

    vertexShader: [

    "#define LAMBERT",

    "varying vec3 vLightFront;",

    "#ifdef DOUBLE_SIDED",

    "	varying vec3 vLightBack;",

    "#endif",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["map_pars_vertex"],
    THREE.ShaderChunk["lightmap_pars_vertex"],
    THREE.ShaderChunk["envmap_pars_vertex"],
    THREE.ShaderChunk["lights_lambert_pars_vertex"],
    THREE.ShaderChunk["color_pars_vertex"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    THREE.ShaderChunk["map_vertex"],
    THREE.ShaderChunk["lightmap_vertex"],
    THREE.ShaderChunk["color_vertex"],

    THREE.ShaderChunk["defaultnormal_vertex"],

    THREE.ShaderChunk["default_vertex"],
    THREE.ShaderChunk["logdepthbuf_vertex"],

    THREE.ShaderChunk["worldpos_vertex"],
    THREE.ShaderChunk["envmap_vertex"],
    THREE.ShaderChunk["lights_lambert_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform vec3 diffuse;",
    "uniform vec3 emissive;",
    "uniform float opacity;",

    "varying vec3 vLightFront;",

    "#ifdef DOUBLE_SIDED",

    "	varying vec3 vLightBack;",

    "#endif",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["color_pars_fragment"],
    THREE.ShaderChunk["map_pars_fragment"],
    THREE.ShaderChunk["alphamap_pars_fragment"],
    THREE.ShaderChunk["lightmap_pars_fragment"],
    THREE.ShaderChunk["envmap_pars_fragment"],
    THREE.ShaderChunk["specularmap_pars_fragment"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    "	vec3 outgoingLight = vec3( 0.0 );", // outgoing light does not have an alpha, the surface does
    "	vec4 diffuseColor = vec4( diffuse, opacity );",

    THREE.ShaderChunk["logdepthbuf_fragment"],
    THREE.ShaderChunk["map_fragment"],
    THREE.ShaderChunk["color_fragment"],
    THREE.ShaderChunk["alphamap_fragment"],
    THREE.ShaderChunk["alphatest_fragment"],
    THREE.ShaderChunk["specularmap_fragment"],

    "	#ifdef DOUBLE_SIDED",

    //"float isFront = float( gl_FrontFacing );",
    //"gl_FragColor.xyz *= isFront * vLightFront + ( 1.0 - isFront ) * vLightBack;",

    "		if ( gl_FrontFacing )",
    "			outgoingLight += diffuseColor.rgb * vLightFront + emissive;",
    "		else",
    "			outgoingLight += diffuseColor.rgb * vLightBack + emissive;",

    "	#else",

    "		outgoingLight += diffuseColor.rgb * vLightFront + emissive;",

    "	#endif",

    THREE.ShaderChunk["lightmap_fragment"],
    THREE.ShaderChunk["envmap_fragment"],

    THREE.ShaderChunk["linear_to_gamma_fragment"],

    "	gl_FragColor = vec4( outgoingLight, diffuseColor.a );", // TODO, this should be pre-multiplied to allow for bright highlights on very transparent objects

    "}"].

    join("\n")

  },

  'particle_basic': {

    uniforms: THREE.UniformsUtils.merge([

    THREE.UniformsLib["particle"]]

    ),

    vertexShader: [

    "uniform float size;",
    "uniform float scale;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["color_pars_vertex"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    THREE.ShaderChunk["color_vertex"],

    "	vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",

    "	#ifdef USE_SIZEATTENUATION",
    "		gl_PointSize = size * ( scale / length( mvPosition.xyz ) );",
    "	#else",
    "		gl_PointSize = size;",
    "	#endif",

    "	gl_Position = projectionMatrix * mvPosition;",

    THREE.ShaderChunk["logdepthbuf_vertex"],
    THREE.ShaderChunk["worldpos_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform vec3 psColor;",
    "uniform float opacity;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["color_pars_fragment"],
    THREE.ShaderChunk["map_particle_pars_fragment"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    "	vec3 outgoingLight = vec3( 0.0 );", // outgoing light does not have an alpha, the surface does
    "	vec4 diffuseColor = vec4( psColor, opacity );",

    THREE.ShaderChunk["logdepthbuf_fragment"],
    THREE.ShaderChunk["map_particle_fragment"],
    THREE.ShaderChunk["color_fragment"],
    THREE.ShaderChunk["alphatest_fragment"],

    "	outgoingLight = diffuseColor.rgb;", // simple shader

    "	gl_FragColor = vec4( outgoingLight, diffuseColor.a );", // TODO, this should be pre-multiplied to allow for bright highlights on very transparent objects

    "}"].

    join("\n")

  },

  'dashed': {

    uniforms: THREE.UniformsUtils.merge([

    THREE.UniformsLib["common"],
    THREE.UniformsLib["fog"],

    {
      "scale": { type: "f", value: 1 },
      "dashSize": { type: "f", value: 1 },
      "totalSize": { type: "f", value: 2 }
    }]

    ),

    vertexShader: [

    "uniform float scale;",
    "attribute float lineDistance;",

    "varying float vLineDistance;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["color_pars_vertex"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    THREE.ShaderChunk["color_vertex"],

    "	vLineDistance = scale * lineDistance;",

    "	vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
    "	gl_Position = projectionMatrix * mvPosition;",

    THREE.ShaderChunk["logdepthbuf_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform vec3 diffuse;",
    "uniform float opacity;",

    "uniform float dashSize;",
    "uniform float totalSize;",

    "varying float vLineDistance;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["color_pars_fragment"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    "	if ( mod( vLineDistance, totalSize ) > dashSize ) {",

    "		discard;",

    "	}",

    "	vec3 outgoingLight = vec3( 0.0 );", // outgoing light does not have an alpha, the surface does
    "	vec4 diffuseColor = vec4( diffuse, opacity );",

    THREE.ShaderChunk["logdepthbuf_fragment"],
    THREE.ShaderChunk["color_fragment"],

    "	outgoingLight = diffuseColor.rgb;", // simple shader

    "	gl_FragColor = vec4( outgoingLight, diffuseColor.a );", // TODO, this should be pre-multiplied to allow for bright highlights on very transparent objects

    "}"].

    join("\n")

  },

  'depth': {

    uniforms: {

      "mNear": { type: "f", value: 1.0 },
      "mFar": { type: "f", value: 2000.0 },
      "opacity": { type: "f", value: 1.0 }

    },

    vertexShader: [

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["morphtarget_pars_vertex"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    THREE.ShaderChunk["morphtarget_vertex"],
    THREE.ShaderChunk["default_vertex"],
    THREE.ShaderChunk["logdepthbuf_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform float mNear;",
    "uniform float mFar;",
    "uniform float opacity;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    THREE.ShaderChunk["logdepthbuf_fragment"],

    "	#ifdef USE_LOGDEPTHBUF_EXT",

    "		float depth = gl_FragDepthEXT / gl_FragCoord.w;",

    "	#else",

    "		float depth = gl_FragCoord.z / gl_FragCoord.w;",

    "	#endif",

    "	float color = 1.0 - smoothstep( mNear, mFar, depth );",
    "	gl_FragColor = vec4( vec3( color ), opacity );", // TODO, this should be pre-multiplied to allow for bright highlights on very transparent objects

    "}"].

    join("\n")

  },

  'normal': {

    uniforms: {

      "opacity": { type: "f", value: 1.0 }

    },

    vertexShader: [

    "varying vec3 vNormal;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["morphtarget_pars_vertex"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    "	vNormal = normalize( normalMatrix * normal );",

    THREE.ShaderChunk["morphtarget_vertex"],
    THREE.ShaderChunk["default_vertex"],
    THREE.ShaderChunk["logdepthbuf_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform float opacity;",
    "varying vec3 vNormal;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    "	gl_FragColor = vec4( 0.5 * normalize( vNormal ) + 0.5, opacity );",

    THREE.ShaderChunk["logdepthbuf_fragment"],

    "}"].

    join("\n")

  },

  /* -------------------------------------------------------------------------
  //	Cube map shader
   ------------------------------------------------------------------------- */

  'cube': {

    uniforms: { "tCube": { type: "t", value: null },
      "tFlip": { type: "f", value: -1 } },

    vertexShader: [

    "varying vec3 vWorldPosition;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    "	vWorldPosition = transformDirection( position, modelMatrix );",

    "	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    THREE.ShaderChunk["logdepthbuf_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform samplerCube tCube;",
    "uniform float tFlip;",

    "varying vec3 vWorldPosition;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    "	gl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );",

    THREE.ShaderChunk["logdepthbuf_fragment"],

    "}"].

    join("\n")

  },

  /* -------------------------------------------------------------------------
  //	Cube map shader
   ------------------------------------------------------------------------- */

  'equirect': {

    uniforms: { "tEquirect": { type: "t", value: null },
      "tFlip": { type: "f", value: -1 } },

    vertexShader: [

    "varying vec3 vWorldPosition;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_vertex"],

    "void main() {",

    "	vWorldPosition = transformDirection( position, modelMatrix );",

    "	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    THREE.ShaderChunk["logdepthbuf_vertex"],

    "}"].

    join("\n"),

    fragmentShader: [

    "uniform sampler2D tEquirect;",
    "uniform float tFlip;",

    "varying vec3 vWorldPosition;",

    THREE.ShaderChunk["common"],
    THREE.ShaderChunk["logdepthbuf_pars_fragment"],

    "void main() {",

    // "	gl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );",
    "vec3 direction = normalize( vWorldPosition );",
    "vec2 sampleUV;",
    "sampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );",
    "sampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;",
    "gl_FragColor = texture2D( tEquirect, sampleUV );",

    THREE.ShaderChunk["logdepthbuf_fragment"],

    "}"].

    join("\n")

  }

};


// File:src/renderers/WebGLRenderTarget.js

/**
 * @author szimek / https://github.com/szimek/
 * @author alteredq / http://alteredqualia.com/
 */

THREE.WebGLRenderTarget = function (width, height, options) {

  this.width = width;
  this.height = height;

  options = options || {};

  this.wrapS = options.wrapS !== undefined ? options.wrapS : THREE.ClampToEdgeWrapping;
  this.wrapT = options.wrapT !== undefined ? options.wrapT : THREE.ClampToEdgeWrapping;

  this.magFilter = options.magFilter !== undefined ? options.magFilter : THREE.LinearFilter;
  this.minFilter = options.minFilter !== undefined ? options.minFilter : THREE.LinearMipMapLinearFilter;

  this.anisotropy = options.anisotropy !== undefined ? options.anisotropy : 1;

  this.offset = new THREE.Vector2(0, 0);
  this.repeat = new THREE.Vector2(1, 1);

  this.format = options.format !== undefined ? options.format : THREE.RGBAFormat;
  this.type = options.type !== undefined ? options.type : THREE.UnsignedByteType;

  this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
  this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;

  this.generateMipmaps = true;

  this.shareDepthFrom = options.shareDepthFrom !== undefined ? options.shareDepthFrom : null;

};

THREE.WebGLRenderTarget.prototype = {

  constructor: THREE.WebGLRenderTarget,

  // Polyfill for r73 addition of WebGLRenderTarget.texture https://github.com/mrdoob/three.js/commit/bfadabd632ace09bf5f4ae15d5f508d1a93638aa
  get texture() {
    return this;
  },

  setSize: function (width, height) {

    this.width = width;
    this.height = height;

  },

  clone: function () {

    var tmp = new THREE.WebGLRenderTarget(this.width, this.height);

    tmp.wrapS = this.wrapS;
    tmp.wrapT = this.wrapT;

    tmp.magFilter = this.magFilter;
    tmp.minFilter = this.minFilter;

    tmp.anisotropy = this.anisotropy;

    tmp.offset.copy(this.offset);
    tmp.repeat.copy(this.repeat);

    tmp.format = this.format;
    tmp.type = this.type;

    tmp.depthBuffer = this.depthBuffer;
    tmp.stencilBuffer = this.stencilBuffer;

    tmp.generateMipmaps = this.generateMipmaps;

    tmp.shareDepthFrom = this.shareDepthFrom;

    return tmp;

  },

  dispose: function () {

    this.dispatchEvent({ type: 'dispose' });

  }

};

THREE.EventDispatcher.prototype.apply(THREE.WebGLRenderTarget.prototype);

// File:src/renderers/WebGLRenderTargetCube.js

/**
 * @author alteredq / http://alteredqualia.com
 */

THREE.WebGLRenderTargetCube = function (width, height, options) {

  THREE.WebGLRenderTarget.call(this, width, height, options);

  this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5

};

THREE.WebGLRenderTargetCube.prototype = Object.create(THREE.WebGLRenderTarget.prototype);
THREE.WebGLRenderTargetCube.prototype.constructor = THREE.WebGLRenderTargetCube;

// File:src/renderers/webgl/WebGLExtensions.js

/**
* @author mrdoob / http://mrdoob.com/
*/

THREE.WebGLExtensions = function (gl) {

  var extensions = {};

  this.get = function (name) {

    if (extensions[name] !== undefined) {

      return extensions[name];

    }

    var extension;

    switch (name) {

      case 'EXT_texture_filter_anisotropic':
        extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
        break;

      case 'WEBGL_compressed_texture_s3tc':
        extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
        break;

      case 'WEBGL_compressed_texture_pvrtc':
        extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
        break;

      default:
        extension = gl.getExtension(name);

    }

    if (extension === null) {

      THREE.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');

    }

    extensions[name] = extension;

    return extension;

  };

};

// File:src/renderers/webgl/WebGLState.js

/**
* @author mrdoob / http://mrdoob.com/
*/

THREE.WebGLState = function (gl, paramThreeToGL) {

  var newAttributes = new Uint8Array(16);
  var enabledAttributes = new Uint8Array(16);

  var currentBlending = null;
  var currentBlendEquation = null;
  var currentBlendSrc = null;
  var currentBlendDst = null;
  var currentBlendEquationAlpha = null;
  var currentBlendSrcAlpha = null;
  var currentBlendDstAlpha = null;

  var currentDepthTest = null;
  var currentDepthWrite = null;

  var currentColorWrite = null;

  var currentDoubleSided = null;
  var currentFlipSided = null;

  var currentLineWidth = null;

  var currentPolygonOffset = null;
  var currentPolygonOffsetFactor = null;
  var currentPolygonOffsetUnits = null;

  this.initAttributes = function () {

    for (var i = 0, l = newAttributes.length; i < l; i++) {

      newAttributes[i] = 0;

    }

  };

  this.enableAttribute = function (attribute) {

    newAttributes[attribute] = 1;

    if (enabledAttributes[attribute] === 0) {

      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;

    }

  };

  this.disableUnusedAttributes = function () {

    for (var i = 0, l = enabledAttributes.length; i < l; i++) {

      if (enabledAttributes[i] !== newAttributes[i]) {

        gl.disableVertexAttribArray(i);
        enabledAttributes[i] = 0;

      }

    }

  };

  this.setBlending = function (blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha) {

    if (blending !== currentBlending) {

      if (blending === THREE.NoBlending) {

        gl.disable(gl.BLEND);

      } else if (blending === THREE.AdditiveBlending) {

        gl.enable(gl.BLEND);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);

      } else if (blending === THREE.SubtractiveBlending) {

        // TODO: Find blendFuncSeparate() combination
        gl.enable(gl.BLEND);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ZERO, gl.ONE_MINUS_SRC_COLOR);

      } else if (blending === THREE.MultiplyBlending) {

        // TODO: Find blendFuncSeparate() combination
        gl.enable(gl.BLEND);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);

      } else if (blending === THREE.CustomBlending) {

        gl.enable(gl.BLEND);

      } else {

        gl.enable(gl.BLEND);
        gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);

      }

      currentBlending = blending;

    }

    if (blending === THREE.CustomBlending) {

      blendEquationAlpha = blendEquationAlpha || blendEquation;
      blendSrcAlpha = blendSrcAlpha || blendSrc;
      blendDstAlpha = blendDstAlpha || blendDst;

      if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {

        gl.blendEquationSeparate(paramThreeToGL(blendEquation), paramThreeToGL(blendEquationAlpha));

        currentBlendEquation = blendEquation;
        currentBlendEquationAlpha = blendEquationAlpha;

      }

      if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {

        gl.blendFuncSeparate(paramThreeToGL(blendSrc), paramThreeToGL(blendDst), paramThreeToGL(blendSrcAlpha), paramThreeToGL(blendDstAlpha));

        currentBlendSrc = blendSrc;
        currentBlendDst = blendDst;
        currentBlendSrcAlpha = blendSrcAlpha;
        currentBlendDstAlpha = blendDstAlpha;

      }

    } else {

      currentBlendEquation = null;
      currentBlendSrc = null;
      currentBlendDst = null;
      currentBlendEquationAlpha = null;
      currentBlendSrcAlpha = null;
      currentBlendDstAlpha = null;

    }

  };

  this.setDepthTest = function (depthTest) {

    if (currentDepthTest !== depthTest) {

      if (depthTest) {

        gl.enable(gl.DEPTH_TEST);

      } else {

        gl.disable(gl.DEPTH_TEST);

      }

      currentDepthTest = depthTest;

    }

  };

  this.setDepthWrite = function (depthWrite) {

    if (currentDepthWrite !== depthWrite) {

      gl.depthMask(depthWrite);
      currentDepthWrite = depthWrite;

    }

  };

  this.setColorWrite = function (colorWrite) {

    if (currentColorWrite !== colorWrite) {

      gl.colorMask(colorWrite, colorWrite, colorWrite, colorWrite);
      currentColorWrite = colorWrite;

    }

  };

  this.setDoubleSided = function (doubleSided) {

    if (currentDoubleSided !== doubleSided) {

      if (doubleSided) {

        gl.disable(gl.CULL_FACE);

      } else {

        gl.enable(gl.CULL_FACE);

      }

      currentDoubleSided = doubleSided;

    }

  };

  this.setFlipSided = function (flipSided) {

    if (currentFlipSided !== flipSided) {

      if (flipSided) {

        gl.frontFace(gl.CW);

      } else {

        gl.frontFace(gl.CCW);

      }

      currentFlipSided = flipSided;

    }

  };

  this.setLineWidth = function (width) {

    if (width !== currentLineWidth) {

      gl.lineWidth(width);

      currentLineWidth = width;

    }

  };

  this.setPolygonOffset = function (polygonoffset, factor, units) {

    if (currentPolygonOffset !== polygonoffset) {

      if (polygonoffset) {

        gl.enable(gl.POLYGON_OFFSET_FILL);

      } else {

        gl.disable(gl.POLYGON_OFFSET_FILL);

      }

      currentPolygonOffset = polygonoffset;

    }

    if (polygonoffset && (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units)) {

      gl.polygonOffset(factor, units);

      currentPolygonOffsetFactor = factor;
      currentPolygonOffsetUnits = units;

    }

  };

  this.reset = function () {

    for (var i = 0; i < enabledAttributes.length; i++) {

      enabledAttributes[i] = 0;

    }

    currentBlending = null;
    currentDepthTest = null;
    currentDepthWrite = null;
    currentColorWrite = null;
    currentDoubleSided = null;
    currentFlipSided = null;

  };

};

// File:src/extras/ImageUtils.js

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author Daosheng Mu / https://github.com/DaoshengMu/
 */

THREE.ImageUtils = {

  crossOrigin: undefined,

  loadTextureAsBitmap: function (url, mapping, onLoad, onError) {
    var loader = new THREE.ImageLoader();
    loader.crossOrigin = this.crossOrigin;

    var texture = new THREE.Texture(undefined, mapping);

    loader.load(url, function (img) {

      window.createImageBitmap(img).then((image) => {
        texture.image = image;
        texture.needsUpdate = true;
        onLoad && onLoad(texture);
      });

    }, undefined, function (event) {

      if (onError) onError(event);

    });

    texture.sourceFile = url;

    return texture;
  },

  loadTexture: function (url, mapping, onLoad, onError) {

    var loader = new THREE.ImageLoader();
    loader.crossOrigin = this.crossOrigin;

    var texture = new THREE.Texture(undefined, mapping);

    loader.load(url, function (image) {

      texture.image = image;
      texture.needsUpdate = true;

      if (onLoad) onLoad(texture);

    }, undefined, function (event) {

      if (onError) onError(event);

    });

    texture.sourceFile = url;

    return texture;

  },

  loadTextureCube: function (array, mapping, onLoad, onError) {

    var images = [];

    var loader = new THREE.ImageLoader();
    loader.crossOrigin = this.crossOrigin;

    var texture = new THREE.CubeTexture(images, mapping);

    // no flipping needed for cube textures

    texture.flipY = false;

    var loaded = 0;

    var loadTexture = function (i) {

      loader.load(array[i], function (image) {

        texture.images[i] = image;

        loaded += 1;

        if (loaded === 6) {

          texture.needsUpdate = true;

          if (onLoad) onLoad(texture);

        }

      }, undefined, onError);

    };

    for (var i = 0, il = array.length; i < il; ++i) {

      loadTexture(i);

    }

    return texture;

  },

  loadCompressedTexture: function () {

    THREE.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');

  },

  loadCompressedTextureCube: function () {

    THREE.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');

  },

  getNormalMap: function (image, depth) {

    // Adapted from http://www.paulbrunt.co.uk/lab/heightnormal/

    var cross = function (a, b) {

      return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];

    };

    var subtract = function (a, b) {

      return [a[0] - b[0], a[1] - b[1], a[2] - b[2]];

    };

    var normalize = function (a) {

      var l = Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
      return [a[0] / l, a[1] / l, a[2] / l];

    };

    depth = depth | 1;

    var width = image.width;
    var height = image.height;

    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    var context = canvas.getContext('2d');
    context.drawImage(image, 0, 0);

    var data = context.getImageData(0, 0, width, height).data;
    var imageData = context.createImageData(width, height);
    var output = imageData.data;

    for (var x = 0; x < width; x++) {

      for (var y = 0; y < height; y++) {

        var ly = y - 1 < 0 ? 0 : y - 1;
        var uy = y + 1 > height - 1 ? height - 1 : y + 1;
        var lx = x - 1 < 0 ? 0 : x - 1;
        var ux = x + 1 > width - 1 ? width - 1 : x + 1;

        var points = [];
        var origin = [0, 0, data[(y * width + x) * 4] / 255 * depth];
        points.push([-1, 0, data[(y * width + lx) * 4] / 255 * depth]);
        points.push([-1, -1, data[(ly * width + lx) * 4] / 255 * depth]);
        points.push([0, -1, data[(ly * width + x) * 4] / 255 * depth]);
        points.push([1, -1, data[(ly * width + ux) * 4] / 255 * depth]);
        points.push([1, 0, data[(y * width + ux) * 4] / 255 * depth]);
        points.push([1, 1, data[(uy * width + ux) * 4] / 255 * depth]);
        points.push([0, 1, data[(uy * width + x) * 4] / 255 * depth]);
        points.push([-1, 1, data[(uy * width + lx) * 4] / 255 * depth]);

        var normals = [];
        var num_points = points.length;

        for (var i = 0; i < num_points; i++) {

          var v1 = points[i];
          var v2 = points[(i + 1) % num_points];
          v1 = subtract(v1, origin);
          v2 = subtract(v2, origin);
          normals.push(normalize(cross(v1, v2)));

        }

        var normal = [0, 0, 0];

        for (var i = 0; i < normals.length; i++) {

          normal[0] += normals[i][0];
          normal[1] += normals[i][1];
          normal[2] += normals[i][2];

        }

        normal[0] /= normals.length;
        normal[1] /= normals.length;
        normal[2] /= normals.length;

        var idx = (y * width + x) * 4;

        output[idx] = (normal[0] + 1.0) / 2.0 * 255 | 0;
        output[idx + 1] = (normal[1] + 1.0) / 2.0 * 255 | 0;
        output[idx + 2] = normal[2] * 255 | 0;
        output[idx + 3] = 255;

      }

    }

    context.putImageData(imageData, 0, 0);

    return canvas;

  },

  generateDataTexture: function (width, height, color) {

    var size = width * height;
    var data = new Uint8Array(3 * size);

    var r = Math.floor(color.r * 255);
    var g = Math.floor(color.g * 255);
    var b = Math.floor(color.b * 255);

    for (var i = 0; i < size; i++) {

      data[i * 3] = r;
      data[i * 3 + 1] = g;
      data[i * 3 + 2] = b;

    }

    var texture = new THREE.DataTexture(data, width, height, THREE.RGBFormat);
    texture.needsUpdate = true;

    return texture;

  }

};

// File:src/extras/geometries/PlaneBufferGeometry.js

/**
 * @author mrdoob / http://mrdoob.com/
 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
 */

THREE.PlaneBufferGeometry = function (width, height, widthSegments, heightSegments) {

  THREE.BufferGeometry.call(this);

  this.type = 'PlaneBufferGeometry';

  this.parameters = {
    width: width,
    height: height,
    widthSegments: widthSegments,
    heightSegments: heightSegments
  };

  var width_half = width / 2;
  var height_half = height / 2;

  var gridX = widthSegments || 1;
  var gridY = heightSegments || 1;

  var gridX1 = gridX + 1;
  var gridY1 = gridY + 1;

  var segment_width = width / gridX;
  var segment_height = height / gridY;

  var vertices = new Float32Array(gridX1 * gridY1 * 3);
  var normals = new Float32Array(gridX1 * gridY1 * 3);
  var uvs = new Float32Array(gridX1 * gridY1 * 2);

  var offset = 0;
  var offset2 = 0;

  for (var iy = 0; iy < gridY1; iy++) {

    var y = iy * segment_height - height_half;

    for (var ix = 0; ix < gridX1; ix++) {

      var x = ix * segment_width - width_half;

      vertices[offset] = x;
      vertices[offset + 1] = -y;

      normals[offset + 2] = 1;

      uvs[offset2] = ix / gridX;
      uvs[offset2 + 1] = 1 - iy / gridY;

      offset += 3;
      offset2 += 2;

    }

  }

  offset = 0;

  var indices = new (vertices.length / 3 > 65535 ? Uint32Array : Uint16Array)(gridX * gridY * 6);

  for (var iy = 0; iy < gridY; iy++) {

    for (var ix = 0; ix < gridX; ix++) {

      var a = ix + gridX1 * iy;
      var b = ix + gridX1 * (iy + 1);
      var c = ix + 1 + gridX1 * (iy + 1);
      var d = ix + 1 + gridX1 * iy;

      indices[offset] = a;
      indices[offset + 1] = b;
      indices[offset + 2] = d;

      indices[offset + 3] = b;
      indices[offset + 4] = c;
      indices[offset + 5] = d;

      offset += 6;

    }

  }

  this.setAttribute('index', new THREE.BufferAttribute(indices, 1));
  this.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));

};

THREE.PlaneBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.PlaneBufferGeometry.prototype.constructor = THREE.PlaneBufferGeometry;


/**
 * Polyfill for r75 THREE.BoxBufferGeometry
 *
 * BoxBufferGeometry (r72): https://github.com/mrdoob/three.js/commit/b5ddc513c7f3e6ce592876822c46871a029dc473
 * BoxBufferGeometry -> BoxGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied BoxGeometry as BoxBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/BoxGeometry.js
 *
 * Caveats: No support for multimaterials if THREE.REVISION < 72
 */
THREE.BoxBufferGeometry = function (width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {

  THREE.BufferGeometry.call(this);

  this.type = 'BoxGeometry';

  this.parameters = {
    width: width,
    height: height,
    depth: depth,
    widthSegments: widthSegments,
    heightSegments: heightSegments,
    depthSegments: depthSegments
  };

  const scope = this;

  // segments

  widthSegments = Math.floor(widthSegments);
  heightSegments = Math.floor(heightSegments);
  depthSegments = Math.floor(depthSegments);

  // buffers

  const indices = [];
  const vertices = [];
  const normals = [];
  const uvs = [];

  // helper variables

  let numberOfVertices = 0;
  let groupStart = 0;

  // build each side of the box geometry

  buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
  buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
  buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
  buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
  buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
  buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz

  // build geometry

  this.setIndex(indices);
  this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));

  function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {

    const segmentWidth = width / gridX;
    const segmentHeight = height / gridY;

    const widthHalf = width / 2;
    const heightHalf = height / 2;
    const depthHalf = depth / 2;

    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;

    let vertexCounter = 0;
    let groupCount = 0;

    const vector = new THREE.Vector3();

    // generate vertices, normals and uvs

    for (let iy = 0; iy < gridY1; iy++) {

      const y = iy * segmentHeight - heightHalf;

      for (let ix = 0; ix < gridX1; ix++) {

        const x = ix * segmentWidth - widthHalf;

        // set values to correct vector component

        vector[u] = x * udir;
        vector[v] = y * vdir;
        vector[w] = depthHalf;

        // now apply vector to vertex buffer

        vertices.push(vector.x, vector.y, vector.z);

        // set values to correct vector component

        vector[u] = 0;
        vector[v] = 0;
        vector[w] = depth > 0 ? 1 : -1;

        // now apply vector to normal buffer

        normals.push(vector.x, vector.y, vector.z);

        // uvs

        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);

        // counters

        vertexCounter += 1;

      }

    }

    // indices

    // 1. you need three indices to draw a single face
    // 2. a single segment consists of two faces
    // 3. so we need to generate six (2*3) indices per segment

    for (let iy = 0; iy < gridY; iy++) {

      for (let ix = 0; ix < gridX; ix++) {

        const a = numberOfVertices + ix + gridX1 * iy;
        const b = numberOfVertices + ix + gridX1 * (iy + 1);
        const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
        const d = numberOfVertices + (ix + 1) + gridX1 * iy;

        // faces

        indices.push(a, b, d);
        indices.push(b, c, d);

        // increase counter

        groupCount += 6;

      }

    }

    // add a group to the geometry. this will ensure multi material support
    //if (!MATERIAL_INDEX_SUPPORTED)
    materialIndex = 0;
    scope.addGroup(groupStart, groupCount, materialIndex);

    // calculate new start value for groups

    groupStart += groupCount;

    // update total number of vertices

    numberOfVertices += vertexCounter;

  }

};

THREE.BoxBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.BoxBufferGeometry.prototype.constructor = THREE.BoxBufferGeometry;

/**
 * Polyfill for r72 THREE.CircleBufferGeometry
 *
 * CircleBufferGeometry (r72): https://github.com/mrdoob/three.js/commit/c94cb5fe669285840ccdd06002c960f1eecde0a4
 * CircleBufferGeometry -> CircleGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied CircleGeometry as CircleBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/CircleGeometry.js
 */
THREE.CircleBufferGeometry = function (radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2) {

  THREE.BufferGeometry.call(this);

  this.type = 'CircleGeometry';

  this.parameters = {
    radius: radius,
    segments: segments,
    thetaStart: thetaStart,
    thetaLength: thetaLength
  };

  segments = Math.max(3, segments);

  // buffers

  const indices = [];
  const vertices = [];
  const normals = [];
  const uvs = [];

  // helper variables

  const vertex = new THREE.Vector3();
  const uv = new THREE.Vector2();

  // center point

  vertices.push(0, 0, 0);
  normals.push(0, 0, 1);
  uvs.push(0.5, 0.5);

  for (let s = 0, i = 3; s <= segments; s++, i += 3) {

    const segment = thetaStart + s / segments * thetaLength;

    // vertex

    vertex.x = radius * Math.cos(segment);
    vertex.y = radius * Math.sin(segment);

    vertices.push(vertex.x, vertex.y, vertex.z);

    // normal

    normals.push(0, 0, 1);

    // uvs

    uv.x = (vertices[i] / radius + 1) / 2;
    uv.y = (vertices[i + 1] / radius + 1) / 2;

    uvs.push(uv.x, uv.y);

  }

  // indices

  for (let i = 1; i <= segments; i++) {

    indices.push(i, i + 1, 0);

  }

  // build geometry

  this.setIndex(indices);
  this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
};

THREE.CircleBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.CircleBufferGeometry.prototype.constructor = THREE.CircleBufferGeometry;

/**
 * Polyfill for r75 THREE.CylinderBufferGeometry
 *
 * CylinderBufferGeometry (r75): https://github.com/mrdoob/three.js/commit/8a8f05ddf1fadfe3cc57dafed5e0035cab25412b
 * CylinderBufferGeometry -> CylinderGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied CylinderGeometry as CylinderBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/CylinderGeometry.js
 *
 * Caveats: No support for multimaterials if THREE.REVISION < 72
 */
THREE.CylinderBufferGeometry = function (radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {

  THREE.BufferGeometry.call(this);

  this.type = 'CylinderGeometry';

  this.parameters = {
    radiusTop: radiusTop,
    radiusBottom: radiusBottom,
    height: height,
    radialSegments: radialSegments,
    heightSegments: heightSegments,
    openEnded: openEnded,
    thetaStart: thetaStart,
    thetaLength: thetaLength
  };

  const scope = this;

  radialSegments = Math.floor(radialSegments);
  heightSegments = Math.floor(heightSegments);

  // buffers

  const indices = [];
  const vertices = [];
  const normals = [];
  const uvs = [];

  // helper variables

  let index = 0;
  const indexArray = [];
  const halfHeight = height / 2;
  let groupStart = 0;

  // generate geometry

  generateTorso();

  if (openEnded === false) {

    if (radiusTop > 0) generateCap(true);
    if (radiusBottom > 0) generateCap(false);

  }

  // build geometry

  this.setIndex(indices);
  this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));

  function generateTorso() {

    const normal = new THREE.Vector3();
    const vertex = new THREE.Vector3();

    let groupCount = 0;

    // this will be used to calculate the normal
    const slope = (radiusBottom - radiusTop) / height;

    // generate vertices, normals and uvs

    for (let y = 0; y <= heightSegments; y++) {

      const indexRow = [];

      const v = y / heightSegments;

      // calculate the radius of the current row

      const radius = v * (radiusBottom - radiusTop) + radiusTop;

      for (let x = 0; x <= radialSegments; x++) {

        const u = x / radialSegments;

        const theta = u * thetaLength + thetaStart;

        const sinTheta = Math.sin(theta);
        const cosTheta = Math.cos(theta);

        // vertex

        vertex.x = radius * sinTheta;
        vertex.y = -v * height + halfHeight;
        vertex.z = radius * cosTheta;
        vertices.push(vertex.x, vertex.y, vertex.z);

        // normal

        normal.set(sinTheta, slope, cosTheta).normalize();
        normals.push(normal.x, normal.y, normal.z);

        // uv

        uvs.push(u, 1 - v);

        // save index of vertex in respective row

        indexRow.push(index++);

      }

      // now save vertices of the row in our index array

      indexArray.push(indexRow);

    }

    // generate indices

    for (let x = 0; x < radialSegments; x++) {

      for (let y = 0; y < heightSegments; y++) {

        // we use the index array to access the correct indices

        const a = indexArray[y][x];
        const b = indexArray[y + 1][x];
        const c = indexArray[y + 1][x + 1];
        const d = indexArray[y][x + 1];

        // faces

        indices.push(a, b, d);
        indices.push(b, c, d);

        // update group counter

        groupCount += 6;

      }

    }

    // add a group to the geometry. this will ensure multi material support

    scope.addGroup(groupStart, groupCount, 0);

    // calculate new start value for groups

    groupStart += groupCount;

  }

  function generateCap(top) {

    // save the index of the first center vertex
    const centerIndexStart = index;

    const uv = new THREE.Vector2();
    const vertex = new THREE.Vector3();

    let groupCount = 0;

    const radius = top === true ? radiusTop : radiusBottom;
    const sign = top === true ? 1 : -1;

    // first we generate the center vertex data of the cap.
    // because the geometry needs one set of uvs per face,
    // we must generate a center vertex per face/segment

    for (let x = 1; x <= radialSegments; x++) {

      // vertex

      vertices.push(0, halfHeight * sign, 0);

      // normal

      normals.push(0, sign, 0);

      // uv

      uvs.push(0.5, 0.5);

      // increase index

      index++;

    }

    // save the index of the last center vertex
    const centerIndexEnd = index;

    // now we generate the surrounding vertices, normals and uvs

    for (let x = 0; x <= radialSegments; x++) {

      const u = x / radialSegments;
      const theta = u * thetaLength + thetaStart;

      const cosTheta = Math.cos(theta);
      const sinTheta = Math.sin(theta);

      // vertex

      vertex.x = radius * sinTheta;
      vertex.y = halfHeight * sign;
      vertex.z = radius * cosTheta;
      vertices.push(vertex.x, vertex.y, vertex.z);

      // normal

      normals.push(0, sign, 0);

      // uv

      uv.x = cosTheta * 0.5 + 0.5;
      uv.y = sinTheta * 0.5 * sign + 0.5;
      uvs.push(uv.x, uv.y);

      // increase index

      index++;

    }

    // generate indices

    for (let x = 0; x < radialSegments; x++) {

      const c = centerIndexStart + x;
      const i = centerIndexEnd + x;

      if (top === true) {

        // face top

        indices.push(i, i + 1, c);

      } else {

        // face bottom

        indices.push(i + 1, i, c);

      }

      groupCount += 3;

    }

    // add a group to the geometry. this will ensure multi material support

    const materialIndex = 0; //MATERIAL_INDEX_SUPPORTED ? (top === true ? 1 : 2) : 0;
    scope.addGroup(groupStart, groupCount, materialIndex);

    // calculate new start value for groups

    groupStart += groupCount;

  }

};

THREE.CylinderBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.CylinderBufferGeometry.prototype.constructor = THREE.CylinderBufferGeometry;


/**
 * Polyfill for r82 THREE.PolyhedronBufferGeometry
 *
 * PolyhedronBufferGeometry (r82): https://github.com/mrdoob/three.js/commit/4e59e79c344dc203a0360f0c8b370d90f957bbff
 * PolyhedronBufferGeometry -> PolyhedronGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied PolyhedronGeometry as PolyhedronBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/PolyhedronGeometry.js
 */
THREE.PolyhedronBufferGeometry = function (vertices, indices, radius = 1, detail = 0) {

  THREE.BufferGeometry.call(this);

  this.type = 'PolyhedronGeometry';

  this.parameters = {
    vertices: vertices,
    indices: indices,
    radius: radius,
    detail: detail
  };

  // default buffer data

  const vertexBuffer = [];
  const uvBuffer = [];

  // the subdivision creates the vertex buffer data

  subdivide(detail);

  // all vertices should lie on a conceptual sphere with a given radius

  applyRadius(radius);

  // finally, create the uv data

  generateUVs();

  // build non-indexed geometry

  this.setAttribute('position', new THREE.Float32BufferAttribute(vertexBuffer, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(vertexBuffer.slice(), 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvBuffer, 2));

  if (detail === 0) {

    this.computeVertexNormals(); // flat normals

  } else {

    this.normalizeNormals(); // smooth normals

  }

  // helper functions

  function subdivide(detail) {

    const a = new THREE.Vector3();
    const b = new THREE.Vector3();
    const c = new THREE.Vector3();

    // iterate over all faces and apply a subdivison with the given detail value

    for (let i = 0; i < indices.length; i += 3) {

      // get the vertices of the face

      getVertexByIndex(indices[i + 0], a);
      getVertexByIndex(indices[i + 1], b);
      getVertexByIndex(indices[i + 2], c);

      // perform subdivision

      subdivideFace(a, b, c, detail);

    }

  }

  function subdivideFace(a, b, c, detail) {

    const cols = detail + 1;

    // we use this multidimensional array as a data structure for creating the subdivision

    const v = [];

    // construct all of the vertices for this subdivision

    for (let i = 0; i <= cols; i++) {

      v[i] = [];

      const aj = a.clone().lerp(c, i / cols);
      const bj = b.clone().lerp(c, i / cols);

      const rows = cols - i;

      for (let j = 0; j <= rows; j++) {

        if (j === 0 && i === cols) {

          v[i][j] = aj;

        } else {

          v[i][j] = aj.clone().lerp(bj, j / rows);

        }

      }

    }

    // construct all of the faces

    for (let i = 0; i < cols; i++) {

      for (let j = 0; j < 2 * (cols - i) - 1; j++) {

        const k = Math.floor(j / 2);

        if (j % 2 === 0) {

          pushVertex(v[i][k + 1]);
          pushVertex(v[i + 1][k]);
          pushVertex(v[i][k]);

        } else {

          pushVertex(v[i][k + 1]);
          pushVertex(v[i + 1][k + 1]);
          pushVertex(v[i + 1][k]);

        }

      }

    }

  }

  function applyRadius(radius) {

    const vertex = new THREE.Vector3();

    // iterate over the entire buffer and apply the radius to each vertex

    for (let i = 0; i < vertexBuffer.length; i += 3) {

      vertex.x = vertexBuffer[i + 0];
      vertex.y = vertexBuffer[i + 1];
      vertex.z = vertexBuffer[i + 2];

      vertex.normalize().multiplyScalar(radius);

      vertexBuffer[i + 0] = vertex.x;
      vertexBuffer[i + 1] = vertex.y;
      vertexBuffer[i + 2] = vertex.z;

    }

  }

  function generateUVs() {

    const vertex = new THREE.Vector3();

    for (let i = 0; i < vertexBuffer.length; i += 3) {

      vertex.x = vertexBuffer[i + 0];
      vertex.y = vertexBuffer[i + 1];
      vertex.z = vertexBuffer[i + 2];

      const u = azimuth(vertex) / 2 / Math.PI + 0.5;
      const v = inclination(vertex) / Math.PI + 0.5;
      uvBuffer.push(u, 1 - v);

    }

    correctUVs();

    correctSeam();

  }

  function correctSeam() {

    // handle case when face straddles the seam, see #3269

    for (let i = 0; i < uvBuffer.length; i += 6) {

      // uv data of a single face

      const x0 = uvBuffer[i + 0];
      const x1 = uvBuffer[i + 2];
      const x2 = uvBuffer[i + 4];

      const max = Math.max(x0, x1, x2);
      const min = Math.min(x0, x1, x2);

      // 0.9 is somewhat arbitrary

      if (max > 0.9 && min < 0.1) {

        if (x0 < 0.2) uvBuffer[i + 0] += 1;
        if (x1 < 0.2) uvBuffer[i + 2] += 1;
        if (x2 < 0.2) uvBuffer[i + 4] += 1;

      }

    }

  }

  function pushVertex(vertex) {

    vertexBuffer.push(vertex.x, vertex.y, vertex.z);

  }

  function getVertexByIndex(index, vertex) {

    const stride = index * 3;

    vertex.x = vertices[stride + 0];
    vertex.y = vertices[stride + 1];
    vertex.z = vertices[stride + 2];

  }

  function correctUVs() {

    const a = new THREE.Vector3();
    const b = new THREE.Vector3();
    const c = new THREE.Vector3();

    const centroid = new THREE.Vector3();

    const uvA = new THREE.Vector2();
    const uvB = new THREE.Vector2();
    const uvC = new THREE.Vector2();

    for (let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6) {

      a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
      b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
      c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);

      uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
      uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
      uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);

      centroid.copy(a).add(b).add(c).divideScalar(3);

      const azi = azimuth(centroid);

      correctUV(uvA, j + 0, a, azi);
      correctUV(uvB, j + 2, b, azi);
      correctUV(uvC, j + 4, c, azi);

    }

  }

  function correctUV(uv, stride, vector, azimuth) {

    if (azimuth < 0 && uv.x === 1) {

      uvBuffer[stride] = uv.x - 1;

    }

    if (vector.x === 0 && vector.z === 0) {

      uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;

    }

  }

  // Angle around the Y axis, counter-clockwise when looking from above.

  function azimuth(vector) {

    return Math.atan2(vector.z, -vector.x);

  }


  // Angle above the XZ plane.

  function inclination(vector) {

    return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));

  }

};

THREE.PolyhedronBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.PolyhedronBufferGeometry.prototype.constructor = THREE.PolyhedronBufferGeometry;


/**
 * Polyfill for r82 THREE.OctahedronBufferGeometry
 *
 * OctahedronBufferGeometry (r82): https://github.com/mrdoob/three.js/commit/4e59e79c344dc203a0360f0c8b370d90f957bbff
 * OctahedronBufferGeometry -> OctahedronGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied OctahedronGeometry as OctahedronBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/OctahedronGeometry.js
 */
THREE.OctahedronBufferGeometry = function (radius = 1, detail = 0) {

  const vertices = [
  1, 0, 0, -1, 0, 0, 0, 1, 0,
  0, -1, 0, 0, 0, 1, 0, 0, -1];


  const indices = [
  0, 2, 4, 0, 4, 3, 0, 3, 5,
  0, 5, 2, 1, 2, 5, 1, 5, 3,
  1, 3, 4, 1, 4, 2];


  THREE.PolyhedronBufferGeometry.call(this, vertices, indices, radius, detail);

  this.type = 'OctahedronGeometry';

  this.parameters = {
    radius: radius,
    detail: detail
  };

};

THREE.OctahedronBufferGeometry.prototype = Object.create(THREE.PolyhedronBufferGeometry.prototype);
THREE.OctahedronBufferGeometry.prototype.constructor = THREE.OctahedronBufferGeometry;


/**
 * Polyfill for r75 THREE.RingBufferGeometry
 * @author Mugen87 / https://github.com/Mugen87
 * See https://github.com/mrdoob/three.js/blob/r75/src/extras/geometries/RingBufferGeometry.js
 */
THREE.RingBufferGeometry = function (innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength) {

  THREE.BufferGeometry.call(this);

  this.type = 'RingBufferGeometry';

  this.parameters = {
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    thetaSegments: thetaSegments,
    phiSegments: phiSegments,
    thetaStart: thetaStart,
    thetaLength: thetaLength
  };

  innerRadius = innerRadius || 20;
  outerRadius = outerRadius || 50;

  thetaStart = thetaStart !== undefined ? thetaStart : 0;
  thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

  thetaSegments = thetaSegments !== undefined ? Math.max(3, thetaSegments) : 8;
  phiSegments = phiSegments !== undefined ? Math.max(1, phiSegments) : 1;

  // these are used to calculate buffer length
  var vertexCount = (thetaSegments + 1) * (phiSegments + 1);
  var indexCount = thetaSegments * phiSegments * 2 * 3;

  // buffers
  var indices = new THREE.BufferAttribute(new (indexCount > 65535 ? Uint32Array : Uint16Array)(indexCount), 1);
  var vertices = new THREE.BufferAttribute(new Float32Array(vertexCount * 3), 3);
  var normals = new THREE.BufferAttribute(new Float32Array(vertexCount * 3), 3);
  var uvs = new THREE.BufferAttribute(new Float32Array(vertexCount * 2), 2);

  // some helper variables
  var index = 0,indexOffset = 0,segment;
  var radius = innerRadius;
  var radiusStep = (outerRadius - innerRadius) / phiSegments;
  var vertex = new THREE.Vector3();
  var uv = new THREE.Vector2();
  var j, i;

  // generate vertices, normals and uvs

  // values are generate from the inside of the ring to the outside

  for (j = 0; j <= phiSegments; j++) {

    for (i = 0; i <= thetaSegments; i++) {

      segment = thetaStart + i / thetaSegments * thetaLength;

      // vertex
      vertex.x = radius * Math.cos(segment);
      vertex.y = radius * Math.sin(segment);
      vertices.setXYZ(index, vertex.x, vertex.y, vertex.z);

      // normal
      normals.setXYZ(index, 0, 0, 1);

      // uv
      uv.x = (vertex.x / outerRadius + 1) / 2;
      uv.y = (vertex.y / outerRadius + 1) / 2;
      uvs.setXY(index, uv.x, uv.y);

      // increase index
      index++;

    }

    // increase the radius for next row of vertices
    radius += radiusStep;

  }

  // generate indices

  for (j = 0; j < phiSegments; j++) {

    var thetaSegmentLevel = j * (thetaSegments + 1);

    for (i = 0; i < thetaSegments; i++) {

      segment = i + thetaSegmentLevel;

      // indices
      var a = segment;
      var b = segment + thetaSegments + 1;
      var c = segment + thetaSegments + 2;
      var d = segment + 1;

      // face one
      indices.setX(indexOffset, a);indexOffset++;
      indices.setX(indexOffset, b);indexOffset++;
      indices.setX(indexOffset, c);indexOffset++;

      // face two
      indices.setX(indexOffset, a);indexOffset++;
      indices.setX(indexOffset, c);indexOffset++;
      indices.setX(indexOffset, d);indexOffset++;

    }

  }

  // build geometry

  this.setIndex(indices);
  this.addAttribute('position', vertices);
  this.addAttribute('normal', normals);
  this.addAttribute('uv', uvs);

};

THREE.RingBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.RingBufferGeometry.prototype.constructor = THREE.RingBufferGeometry;



/**
 * Polyfill for r72 THREE.SphereBufferGeometry
 *
 * SphereBufferGeometry (r72): https://github.com/mrdoob/three.js/commit/723d3f4019ecc09a99376c08c00a5593e205f934
 * SphereBufferGeometry -> SphereGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied SphereGeometry as SphereBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/SphereGeometry.js
 */
THREE.SphereBufferGeometry = function (radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI) {

  THREE.BufferGeometry.call(this);
  this.type = 'SphereGeometry';

  this.parameters = {
    radius: radius,
    widthSegments: widthSegments,
    heightSegments: heightSegments,
    phiStart: phiStart,
    phiLength: phiLength,
    thetaStart: thetaStart,
    thetaLength: thetaLength
  };

  widthSegments = Math.max(3, Math.floor(widthSegments));
  heightSegments = Math.max(2, Math.floor(heightSegments));

  const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);

  let index = 0;
  const grid = [];

  const vertex = new THREE.Vector3();
  const normal = new THREE.Vector3();

  // buffers

  const indices = [];
  const vertices = [];
  const normals = [];
  const uvs = [];

  // generate vertices, normals and uvs

  for (let iy = 0; iy <= heightSegments; iy++) {

    const verticesRow = [];

    const v = iy / heightSegments;

    // special case for the poles

    let uOffset = 0;

    if (iy == 0 && thetaStart == 0) {

      uOffset = 0.5 / widthSegments;

    } else if (iy == heightSegments && thetaEnd == Math.PI) {

      uOffset = -0.5 / widthSegments;

    }

    for (let ix = 0; ix <= widthSegments; ix++) {

      const u = ix / widthSegments;

      // vertex

      vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
      vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
      vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);

      vertices.push(vertex.x, vertex.y, vertex.z);

      // normal

      normal.copy(vertex).normalize();
      normals.push(normal.x, normal.y, normal.z);

      // uv

      uvs.push(u + uOffset, 1 - v);

      verticesRow.push(index++);

    }

    grid.push(verticesRow);

  }

  // indices

  for (let iy = 0; iy < heightSegments; iy++) {

    for (let ix = 0; ix < widthSegments; ix++) {

      const a = grid[iy][ix + 1];
      const b = grid[iy][ix];
      const c = grid[iy + 1][ix];
      const d = grid[iy + 1][ix + 1];

      if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
      if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);

    }

  }

  // build geometry

  this.setIndex(indices);
  this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));

};

THREE.SphereBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.SphereBufferGeometry.prototype.constructor = THREE.SphereBufferGeometry;


/**
 * Polyfill for r75 THREE.TorusBufferGeometry
 * TorusBufferGeometry (r75): https://github.com/mrdoob/three.js/commit/e6630e5f430e694e6fe38870bfea9179b1a96e30
 * TorusBufferGeometry -> TorusGeometry (r125): https://github.com/mrdoob/three.js/commit/7232aa40266d43e0caa128b52793574bf2c89cff
 * Copied TorusGeometry as TorusBufferGeometry from https://github.com/mrdoob/three.js/blob/r125/src/geometries/TorusGeometry.js
 */
THREE.TorusBufferGeometry = function (radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2) {

  THREE.BufferGeometry.call(this);
  this.type = 'TorusGeometry';

  this.parameters = {
    radius: radius,
    tube: tube,
    radialSegments: radialSegments,
    tubularSegments: tubularSegments,
    arc: arc
  };

  radialSegments = Math.floor(radialSegments);
  tubularSegments = Math.floor(tubularSegments);

  // buffers

  const indices = [];
  const vertices = [];
  const normals = [];
  const uvs = [];

  // helper variables

  const center = new THREE.Vector3();
  const vertex = new THREE.Vector3();
  const normal = new THREE.Vector3();

  // generate vertices, normals and uvs

  for (let j = 0; j <= radialSegments; j++) {

    for (let i = 0; i <= tubularSegments; i++) {

      const u = i / tubularSegments * arc;
      const v = j / radialSegments * Math.PI * 2;

      // vertex

      vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
      vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
      vertex.z = tube * Math.sin(v);

      vertices.push(vertex.x, vertex.y, vertex.z);

      // normal

      center.x = radius * Math.cos(u);
      center.y = radius * Math.sin(u);
      normal.subVectors(vertex, center).normalize();

      normals.push(normal.x, normal.y, normal.z);

      // uv

      uvs.push(i / tubularSegments);
      uvs.push(j / radialSegments);

    }

  }

  // generate indices

  for (let j = 1; j <= radialSegments; j++) {

    for (let i = 1; i <= tubularSegments; i++) {

      // indices

      const a = (tubularSegments + 1) * j + i - 1;
      const b = (tubularSegments + 1) * (j - 1) + i - 1;
      const c = (tubularSegments + 1) * (j - 1) + i;
      const d = (tubularSegments + 1) * j + i;

      // faces

      indices.push(a, b, d);
      indices.push(b, c, d);

    }

  }

  // build geometry

  this.setIndex(indices);
  this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
  this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
  this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));

};

THREE.TorusBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype);
THREE.TorusBufferGeometry.prototype.constructor = THREE.TorusBufferGeometry;